webpackJsonp([1],{

/***/ "+5KU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+XPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-language-btn',
  props: {
    dark: { type: Boolean, required: false, default: false },
    color: { type: String }
  },
  data: function data() {
    return {
      language: this.$i18n.locale,
      state: false
    };
  },
  created: function created() {
    window.LanguageButton = this;
  },

  computed: {
    items: function items() {
      return [{ text: this.$t('English'), value: 'en' }, { text: this.$t('German'), value: 'de' }];
    }
  },
  watch: {
    language: function language() {
      this.$root.$i18n.locale = this.language;
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$emit('locale-changed', this.language);
    }
  },
  methods: {
    toggleUi: function toggleUi() {
      this.state = !this.state;
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$emit('toggle-routing-panel', this.state);
    }
  }
});

/***/ }),

/***/ "+u1G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Y57":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/mee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var menu = ref.on;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","dark":_vm.dark}},Object.assign({}, tooltip, menu)),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n              "+_vm._s(_vm.$t(_vm.text))+"\n            ")],1),_vm._v(" "),_c('textarea',{ref:"textstore",staticStyle:{"display":"none","position":"relative"},attrs:{"id":"textstore"}})]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.hoverText)))])])]}}])},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.onCopyUrl()}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"medium":""}},[_vm._v("link")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(_vm.copyUrlText)))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.onCopyEmbedHTML()}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"medium":""}},[_vm._v("code")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(_vm.copyEmbedHtmlText)))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"medium":""}},[_vm._v("email")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":_vm.mailToUrl}},[_vm._v(_vm._s(_vm.$t(_vm.emailUrlText)))])])],1)],1)],1)],1),_vm._v(" "),_c('v-alert',{staticClass:"wgu-alert",attrs:{"value":_vm.alert,"dark":_vm.dark,"type":"info","transition":"fade-transition"}},[_vm._v("\n      "+_vm._s(_vm.$t(_vm.alertText))+"\n    ")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "/v9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2",class:( _obj = { 'routing-target': true }, _obj[_vm.target && _vm.target.properties.source + '-source'] = true, _obj )},[_c('v-autocomplete',{attrs:{"items":_vm.items,"label":_vm.label,"box":"","prepend-icon":"map","clearable":"","search-input":_vm.searchQuery},on:{"change":_vm.changeRouteTarget,"click:clear":_vm.clearCustomTarget,"update:searchInput":function($event){_vm.searchQuery=$event},"update:search-input":function($event){_vm.searchQuery=$event}},scopedSlots:_vm._u([{key:"item",fn:function(data){return [(data.item.value.properties.source === 'custom')?_c('v-icon',{staticClass:"nav-icon"},[_vm._v("location_searching")]):_vm._e(),_vm._v(" "),_c('span',{class:{ local: data.item.source === 'local', geocode: data.item.source === 'geocode', custom: data.item.value.properties.source === 'custom' }},[_vm._v(_vm._s(data.item.text))])]}}]),model:{value:(_vm.target),callback:function ($$v) {_vm.target=$$v},expression:"target"}}),_vm._v(" "),_c('v-alert',{staticClass:"ml-2 mb-4",attrs:{"color":"info","outline":"","value":_vm.choosingPoint}},[_c('v-icon',[_vm._v("location_searching")]),_vm._v("\n    "+_vm._s(_vm.$t('Click on the map to choose a location.'))+"\n  ")],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "01Ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.logoSrc)?_c('v-avatar',{staticClass:"wgu-app-logo",attrs:{"size":_vm.logoSize,"tile":true}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"App Logo"}})]):_vm._e(),_vm._v(" "),(_vm.logoText)?_c('div',{staticClass:"wgu-app-logo"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.logoText)}})]):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "04/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_ol_Map__ = __webpack_require__("i8bC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppHeader__ = __webpack_require__("mUig");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppFooter__ = __webpack_require__("ZfcG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_AppLogo__ = __webpack_require__("qq5n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_components_measuretool_MeasureWin__ = __webpack_require__("lgWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layerlist_LayerListPanel__ = __webpack_require__("W0OM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_components_infoclick_InfoClickWin__ = __webpack_require__("qUL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_components_progress_MapLoadingStatus__ = __webpack_require__("novK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_featureinfo_FeatureInfoPanel__ = __webpack_require__("ijS0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_components_routing_RoutingPanel__ = __webpack_require__("dgnq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_MapboxAttribution__ = __webpack_require__("G6Sb");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-tpl',
  components: {
    'wgu-map': __WEBPACK_IMPORTED_MODULE_4__src_components_ol_Map__["a" /* default */],
    'wgu-app-header': __WEBPACK_IMPORTED_MODULE_5__components_AppHeader__["a" /* default */],
    'wgu-app-footer': __WEBPACK_IMPORTED_MODULE_6__components_AppFooter__["a" /* default */],
    'wgu-app-logo': __WEBPACK_IMPORTED_MODULE_7__src_components_AppLogo__["a" /* default */],
    'wgu-measuretool-win': __WEBPACK_IMPORTED_MODULE_8__src_components_measuretool_MeasureWin__["a" /* default */],
    'wgu-infoclick-win': __WEBPACK_IMPORTED_MODULE_10__src_components_infoclick_InfoClickWin__["a" /* default */],
    'wgu-maploading-status': __WEBPACK_IMPORTED_MODULE_11__src_components_progress_MapLoadingStatus__["a" /* default */],
    'wgu-feature-info-panel': __WEBPACK_IMPORTED_MODULE_12__components_featureinfo_FeatureInfoPanel__["a" /* default */],
    'wgu-layerlist-panel': __WEBPACK_IMPORTED_MODULE_9__components_layerlist_LayerListPanel__["a" /* default */],
    'wgu-routing-panel': __WEBPACK_IMPORTED_MODULE_13__src_components_routing_RoutingPanel__["a" /* default */],
    'wgu-mapbox-attribution': __WEBPACK_IMPORTED_MODULE_14__components_MapboxAttribution__["a" /* default */]
  },
  data: function data() {
    return {
      isEmbedded: false,
      moduleWins: this.getModuleWinData(),
      modulePanels: this.getModulePanelData(),
      footerTextLeft: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig.footerTextLeft,
      footerTextRight: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig.footerTextRight,
      showCopyrightYear: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig.showCopyrightYear,
      baseColor: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig.baseColor
    };
  },
  mounted: function mounted() {
    // apply the isEmbedded state to the member var
    this.isEmbedded = this.$isEmbedded;

    // make the refs (floating module window, which are not connected to their
    // related components, e.g. buttons to toggle them)
    var refs = this.$refs;
    var cmpLookup = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(refs)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        cmpLookup[key] = refs[key][0];
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.cmpLookup = cmpLookup;
    // inform registered cmps that the app is mounted and the dynamic
    // components are available
    __WEBPACK_IMPORTED_MODULE_3__src_WguEventBus__["a" /* WguEventBus */].$emit('app-mounted');
  },

  methods: {
    /**
     * Determines the module panel configuration objects from app-config:
     *     modulePanels: [
     *       {type: 'wgu-layerlist-win'},
     *       {type: 'wgu-measuretool-win'}
     *     ]
     * @return {Array} module panel configuration objects
     */
    getModulePanelData: function getModulePanelData() {
      var appConfig = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig || {};
      var modulesConfs = appConfig.modules || {};
      var modulePanels = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(modulesConfs)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          var moduleOpts = appConfig.modules[key];
          if (moduleOpts.panel === true) {
            modulePanels.push({
              type: key + '-panel',
              dark: moduleOpts.darkLayout,
              initPos: moduleOpts.initPos,
              active: moduleOpts.mobileActive !== undefined && window.innerWidth <= 800 ? moduleOpts.mobileActive : moduleOpts.active,
              title: moduleOpts.title,
              right: moduleOpts.right,
              width: moduleOpts.width,
              height: moduleOpts.height,
              icon: moduleOpts.icon,
              toggleGroup: moduleOpts.toggleGroup,
              options: moduleOpts.options
            });
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return modulePanels;
    },

    /**
     * Determines the module window configuration objects from app-config:
     *     moduleWins: [
     *       {type: 'wgu-layerlist-win'},
     *       {type: 'wgu-measuretool-win'}
     *     ]
     * @return {Array} module window configuration objects
     */
    getModuleWinData: function getModuleWinData() {
      var appConfig = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig || {};
      var modulesConfs = appConfig.modules || {};
      var moduleWins = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(modulesConfs)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var key = _step3.value;

          var moduleOpts = appConfig.modules[key];
          if (moduleOpts.win === true) {
            moduleWins.push({
              type: key + '-win',
              dark: moduleOpts.darkLayout,
              draggable: moduleOpts.draggable,
              initPos: moduleOpts.initPos,
              active: moduleOpts.active,
              title: moduleOpts.title,
              width: moduleOpts.width,
              icon: moduleOpts.icon,
              options: moduleOpts.options
            });
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return moduleWins;
    }
  }
});

/***/ }),

/***/ "0VQP":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"_untagged":"Other"},"de":{"POIs":"POIs","Routes":"Strecke","Areas":"Gebiete","Categories":"Kategorien","Tags":"Schlagworte","_untagged":"Weitere Kartenebenen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "0t1S":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Get directions":"Route berechnen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "0zZl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1JX6":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Measure areas and distances":"Flächen und Entfernungen messen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "1SaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("WaAR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba6acc6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("YX3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("5bzy")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba6acc6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba6acc6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1cwe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.toggleUi}},tooltip),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Measure areas and distances')))])])}
var staticRenderFns = []


/***/ }),

/***/ "1gMf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{ 'wgu-app': true, 'wgu-app-embedded': _vm.isEmbedded },attrs:{"id":"wgu-app","data-app":""}},[_vm._t("wgu-app-begin"),_vm._v(" "),_c('wgu-app-header',{attrs:{"color":_vm.baseColor}},[_vm._t("wgu-tb-start",null,{"slot":"wgu-tb-start"}),_vm._v(" "),_vm._t("wgu-tb-after-title",null,{"slot":"wgu-tb-after-title"}),_vm._v(" "),_vm._t("wgu-tb-before-auto-buttons",null,{"slot":"wgu-tb-before-auto-buttons"}),_vm._v(" "),_vm._t("wgu-tb-after-auto-buttons",null,{"slot":"wgu-tb-after-auto-buttons"}),_vm._v(" "),_vm._t("wgu-tb-end",null,{"slot":"wgu-tb-end"})],2),_vm._v(" "),_vm._t("wgu-after-header"),_vm._v(" "),_c('wgu-app-logo'),_vm._v(" "),_vm._t("wgu-before-content"),_vm._v(" "),_c('v-content',[_vm._l((_vm.modulePanels),function(modulePanel,index){return [_c(modulePanel.type,{key:index,ref:modulePanel.type,refInFor:true,tag:"component",attrs:{"color":_vm.baseColor,"dark":modulePanel.dark,"active":modulePanel.active,"right":modulePanel.right,"width":modulePanel.width,"height":modulePanel.height,"title":modulePanel.title,"icon":modulePanel.icon,"toggleGroup":modulePanel.toggleGroup,"options":modulePanel.options}})]}),_vm._v(" "),_c('v-container',{staticStyle:{"padding":"0"},attrs:{"id":"ol-map-container","fluid":"","fill-height":""}},[_c('wgu-map',{attrs:{"color":_vm.baseColor}}),_vm._v(" "),_c('wgu-mapbox-attribution'),_vm._v(" "),_c('wgu-maploading-status',{attrs:{"color":_vm.baseColor}}),_vm._v(" "),_vm._t("wgu-after-map")],2)],2),_vm._v(" "),_vm._l((_vm.moduleWins),function(moduleWin,index){return [_c(moduleWin.type,{key:index,ref:moduleWin.type,refInFor:true,tag:"component",attrs:{"color":_vm.baseColor,"dark":moduleWin.dark,"draggable":moduleWin.draggable,"initPos":moduleWin.initPos,"active":moduleWin.active,"width":moduleWin.width,"title":moduleWin.title,"icon":moduleWin.icon,"options":moduleWin.options}})]}),_vm._v(" "),_vm._t("wgu-before-footer"),_vm._v(" "),_c('wgu-app-footer',{attrs:{"color":_vm.baseColor,"footerTextLeft":_vm.footerTextLeft,"footerTextRight":_vm.footerTextRight,"showCopyrightYear":_vm.showCopyrightYear}}),_vm._v(" "),_vm._t("wgu-after-footer"),_vm._v(" "),_vm._t("wgu-app-end")],2)}
var staticRenderFns = []


/***/ }),

/***/ "1jdk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1l2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_proj_Projection__ = __webpack_require__("7rnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Url__ = __webpack_require__("v9hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_extent__ = __webpack_require__("/LWt");








/**
 * Class holding the logic for permalinks.
 */

var PermalinkController = function () {
  function PermalinkController(map, permalinkConf) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PermalinkController);

    this.map = null;
    this.shouldUpdate = false;
    this.projection = null;
    this.conf = null;
    this.urlParams = null;

    this.map = map;
    this.conf = permalinkConf || {};
    this.projection = this.conf.projection ? new __WEBPACK_IMPORTED_MODULE_3_ol_proj_Projection__["a" /* default */]({ 'code': this.conf.projection }) : null;
    this.conf.paramPrefix = this.conf.paramPrefix || '';
    this.conf.location = this.conf.location || 'hash';
    this.conf.separator = this.conf.location === 'hash' ? '#' : '?';
    this.conf.history = this.conf.history ? this.conf.history : false;
    this.conf.extent = this.conf.extent ? this.conf.extent : false;
    this.conf.layers = this.conf.layers ? this.conf.layers : false;
    this.conf.precision = this.conf.precision ? this.conf.precision : 4;
    this.urlParams = __WEBPACK_IMPORTED_MODULE_5__util_Url__["a" /* default */].getParams(this.conf.location);
  }

  /**
   * Initializes the map permalink functionality:
   * Registers a 'moveend' event to update the permalink
   * 'hoverAttribute' if the layer is configured as 'hoverable'
   */

  /* the OL map for permalink */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PermalinkController, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      this.shouldUpdate = true;

      // Listen to map state changes (pan, zoom)
      this.map.on('moveend', function () {
        _this.onMapChange();
      });

      if (this.conf.history === false) {
        return;
      }

      // restore the view state when navigating through the history (browser back/forward buttons), see
      // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
      window.addEventListener('popstate', function (event) {
        if (event.state === null) {
          return;
        }

        var view = _this.map.getView();
        var state = event.state;

        _this.shouldUpdate = false;

        view.setRotation(state.rotation);

        // Use extent (bbox) or center+zoom based on config
        if (_this.conf.extent) {
          _this.applyExtent(state.extent);
        } else {
          _this.applyCenter(state.center);
        }

        // somehow we also need zoom (or resolution) for extent:
        // See: https://stackoverflow.com/questions/47770782/openlayers-fit-to-current-extent-is-zooming-out
        view.setZoom(state.zoom);

        if (_this.conf.layers) {
          _this.applyLayers(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(state.layers.map(function (lid) {
            return [lid, lid];
          })));
        }
      });
    }

    /**
     * Applies map (View) rotation, center+zoom-level or extent
     * from permalink params in current URL 'location'
     */

  }, {
    key: 'apply',
    value: function apply() {
      var permalinkParams = __WEBPACK_IMPORTED_MODULE_5__util_Url__["a" /* default */].getParams(this.conf.location);
      var prefix = this.conf.paramPrefix;
      var mapView = this.map.getView();
      var r = prefix + 'r';
      var c = prefix + 'c';
      var e = prefix + 'e';
      var z = prefix + 'z';
      var l = prefix + 'l';

      if (permalinkParams[r]) {
        mapView.setRotation(parseFloat(permalinkParams[r]));
      }

      // Both extent (bbox) or center+zoom supported.
      if (permalinkParams[e]) {
        var extent = permalinkParams[e].split(',').map(function (n) {
          return parseFloat(n);
        });
        this.applyExtent(extent);
      } else if (permalinkParams[c]) {
        var center = permalinkParams[c].split(',').map(function (n) {
          return parseFloat(n);
        });
        this.applyCenter(center);
      }

      // Always set zoom, even with extent
      // See: https://stackoverflow.com/questions/47770782/openlayers-fit-to-current-extent-is-zooming-out
      if (permalinkParams[z]) {
        mapView.setZoom(parseFloat(permalinkParams[z]));
      }

      // Set layer(s) visible
      if (permalinkParams[l]) {
        this.applyLayers(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(permalinkParams[l].split(',').map(function (lid) {
          return [lid, lid];
        })));
      }
    }

    /**
     * Make only the layers for given array of layer ids visible.
     */

  }, {
    key: 'applyLayers',
    value: function applyLayers(layers) {
      if (!layers) {
        return;
      }
      this.map.getLayers().forEach(function (layer) {
        var layerId = layer.get('lid');
        layer.setVisible(layerId === layers.get(layerId));
      });
    }

    /**
     * Position map at provided center.
     */

  }, {
    key: 'applyCenter',
    value: function applyCenter(center) {
      if (!center) {
        return;
      }
      var mapView = this.map.getView();

      // Permalink coordinates may have specific Projection like WGS84
      if (this.projection) {
        center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["a" /* transform */])(center, this.projection, mapView.getProjection());
      }

      mapView.setCenter(center);
    }

    /**
     * Position map at provided map extent.
     */

  }, {
    key: 'applyExtent',
    value: function applyExtent(extent) {
      if (!extent) {
        return;
      }
      var mapView = this.map.getView();
      // Permalink coordinates may have specific Projection like WGS84
      if (this.projection) {
        extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ol_extent__["a" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["h" /* getTransform */])(this.projection, mapView.getProjection()));
      }

      // Fit the map in extent
      mapView.fit(extent, this.map.getSize());
    }

    /**
     * Get the URL parameter permalink string as query or hash.
     */

  }, {
    key: 'getParamStr',
    value: function getParamStr() {
      var round = function round(num, places) {
        return +(Math.round(num + 'e+' + places) + 'e-' + places);
      };

      var state = this.getState();
      var prefix = this.conf.paramPrefix;
      var prec = this.conf.precision;

      // Use extent (bbox) or center+zoom based on config
      this.urlParams[prefix + 'z'] = '' + round(state.zoom, prec);
      if (this.conf.extent) {
        this.urlParams[prefix + 'e'] = state.extent.map(function (n) {
          return round(n, prec);
        }).join(',');
      } else {
        this.urlParams[prefix + 'c'] = state.center.map(function (n) {
          return round(n, prec);
        }).join(',');
      }
      this.urlParams[prefix + 'r'] = '' + round(state.rotation, prec);

      if (this.conf.layers) {
        this.urlParams[prefix + 'l'] = state.layers.join(',');
      }

      return this.conf.separator + __WEBPACK_IMPORTED_MODULE_5__util_Url__["a" /* default */].toQueryString(this.urlParams);
    }

    /**
     * Get full URL with permalink string for sharing.
     */

  }, {
    key: 'getShareUrl',
    value: function getShareUrl() {
      return location.href.split(this.conf.separator)[0] + this.getParamStr();
    }

    /**
     * Get (IFrame) code fragment for embedding the permalink in an HTML page.
     */

  }, {
    key: 'getEmbedHTML',
    value: function getEmbedHTML() {
      var mapSize = this.map.getSize();

      return '<iframe width="' + mapSize[0] + '" height="' + mapSize[1] + '" src="' + this.getShareUrl() + '" style="border:none;"></iframe>';
    }

    /**
     * Get array of visible layer id's.
     */

  }, {
    key: 'getLayerIds',
    value: function getLayerIds() {
      return this.map.getLayers().getArray().filter(function (layer) {
        return !!layer.get('lid') && layer.getVisible();
      }).map(function (layer) {
        return layer.get('lid');
      });
    }

    /**
     * Get total State of the Map.
     */

  }, {
    key: 'getState',
    value: function getState() {
      var mapView = this.map.getView();
      var center = mapView.getCenter();
      var extent = mapView.calculateExtent();

      // Optionally reproject to permalink projection (e.g. WGS84 on WebMerc).
      if (this.projection) {
        center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["a" /* transform */])(center, mapView.getProjection(), this.projection);
        extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ol_extent__["a" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["h" /* getTransform */])(mapView.getProjection(), this.projection));
      }
      return {
        zoom: mapView.getZoom(),
        center: center,
        extent: extent,
        rotation: mapView.getRotation(),
        layers: this.getLayerIds()
      };
    }

    /**
     * Callback when Map View has changed, e.g. 'moveend'.
     */

  }, {
    key: 'onMapChange',
    value: function onMapChange() {
      if (!this.shouldUpdate) {
        // do not update the URL when the view was changed in the 'popstate' handler
        this.shouldUpdate = true;
        return;
      }
      if (this.conf.history === false) {
        return;
      }
      // This changes the URL in address bar.
      window.history.pushState(this.getState(), 'map', this.getParamStr());
    }
  }]);

  return PermalinkController;
}();

/* harmony default export */ __webpack_exports__["a"] = (PermalinkController);

/***/ }),

/***/ "2Jr4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.coordRows)?_c('table',{staticClass:"wgu-coordstable",style:(_vm.tableStyles)},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.coordRows),function(value,key){return _c('tr',[_c('td',{staticClass:"key-td"},[_vm._v("\n        "+_vm._s(key)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"val-td"},[_vm._v("\n        "+_vm._s(value)+"\n      ")])])}),0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr')])}]


/***/ }),

/***/ "2nff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = flip;
/* harmony export (immutable) */ __webpack_exports__["c"] = pad2;
/* harmony export (immutable) */ __webpack_exports__["d"] = feature;
/* harmony export (immutable) */ __webpack_exports__["b"] = featureCollection;
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony export (immutable) */ __webpack_exports__["e"] = lineString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

function flip(_ref) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      a = _ref2[0],
      b = _ref2[1];

  return [b, a];
}

function pad2(x) {
  return ('0' + x).slice(-2);
}

function feature(properties, geometry) {
  return {
    type: 'Feature',
    properties: properties,
    geometry: geometry
  };
}

function featureCollection(features) {
  return {
    type: 'FeatureCollection',
    features: features
  };
}

function point(coordinates) {
  return {
    type: 'Point',
    coordinates: coordinates
  };
}

function lineString(coordinates) {
  return {
    type: 'LineString',
    coordinates: coordinates
  };
}

/***/ }),

/***/ "3F8v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3REv":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Layers":"Kartenebenen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "3j7A":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Layers":"Kartenebenen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "49tN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DestinationSelector_vue__ = __webpack_require__("oNNg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fb21022_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DestinationSelector_vue__ = __webpack_require__("/v9/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Fhxr")
  __webpack_require__("g1uR")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fb21022"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DestinationSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fb21022_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DestinationSelector_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fb21022_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DestinationSelector_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("lUVx")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4a9O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4z3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_DraggableWin__ = __webpack_require__("MPh8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MeasureTypeChooser__ = __webpack_require__("w/12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeasureResult__ = __webpack_require__("cspx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OlMeasureController__ = __webpack_require__("VT4C");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measuretool-win',
  directives: {
    DraggableWin: __WEBPACK_IMPORTED_MODULE_0__directives_DraggableWin__["a" /* DraggableWin */]
  },
  components: {
    'wgu-measure-type-chooser': __WEBPACK_IMPORTED_MODULE_2__MeasureTypeChooser__["a" /* default */],
    'wgu-measure-result': __WEBPACK_IMPORTED_MODULE_3__MeasureResult__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__["a" /* Mapable */]],
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    dark: { type: Boolean, required: false, default: false },
    icon: { type: String, required: false, default: 'photo_size_select_small' },
    title: { type: String, required: false, default: 'Measure' },
    draggable: { type: Boolean, required: false, default: true },
    initPos: { type: Object, required: false }
  },
  data: function data() {
    return {
      moduleName: 'wgu-measuretool',
      measureGeom: null,
      measureType: 'distance',
      show: false,
      left: this.initPos ? this.initPos.left + 'px' : '0',
      top: this.initPos ? this.initPos.top + 'px' : '0'
    };
  },

  watch: {
    show: function show() {
      var me = this;
      if (me.show === true) {
        me.olMapCtrl.addInteraction(me.measureType, me.onMeasureVertexSet);
      } else {
        me.olMapCtrl.removeInteraction();
      }
    },
    measureType: function measureType() {
      var me = this;
      // reset old geom
      me.measureGeom = {};
      me.olMapCtrl.addInteraction(me.measureType, me.onMeasureVertexSet);
    }
  },
  methods: {
    /**
     * Applies the changed measure value to this.measureType.
     * Called as callback of MeasureTypeChooser
     *
     * @param  {String} newMeasureType New measure type
     * @param  {String} oldMeasureType Old measure type
     */
    applyMeasureType: function applyMeasureType(newMeasureType, oldMeasureType) {
      this.measureType = newMeasureType;
    },

    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     */
    onMapBound: function onMapBound() {
      var me = this;
      var measureConf = me.$appConfig.modules[me.moduleName] || {};
      this.olMapCtrl = new __WEBPACK_IMPORTED_MODULE_4__OlMeasureController__["a" /* default */](me.map, measureConf);

      me.olMapCtrl.createMeasureLayer();
    },

    /**
     * Callback function executed when user sets a measure point on the map.
     *
     * @param  {ol/geom/Geometry} geom The geometry object of the map
     */
    onMeasureVertexSet: function onMeasureVertexSet(geom) {
      // wrap geom into object, otherwise the injection into childs does
      // not work. Maybe the OL object does not feel changed for Vue
      this.measureGeom = {
        geom: geom
      };
    }
  }
});

/***/ }),

/***/ "5Ckq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-routing-btn',
  props: {
    active: { type: Boolean, required: false, default: false },
    dark: { type: Boolean, required: false, default: false },
    icon: { type: String, required: false, default: 'search' },
    hoverText: { type: String, required: false, default: 'Get directions' },
    toggleGroup: { type: String, required: false, default: undefined }
  },
  data: function data() {
    return {
      moduleName: 'wgu-routing',
      state: this.active,
      checkStatus: true
    };
  },
  created: function created() {
    var _this = this;

    window.RoutingToggleButton = this;
    // When member of toggle group: close if any other panel active
    if (this.toggleGroup) {
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$on(this.toggleGroup, function (_ref) {
        var moduleName = _ref.moduleName,
            state = _ref.state;

        _this.state = moduleName === _this.moduleName && state;
      });
    }
    __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$on('close-direction-menu', function (state) {
      _this.checkStatus = state;
    });
  },

  methods: {
    toggleUi: function toggleUi() {
      if (this.checkStatus === false) {
        this.state = true;
        this.checkStatus = true;
      } else {
        this.state = !this.state;
      }
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$emit('toggle-routing-panel', this.state);
    }
  }
});

/***/ }),

/***/ "5F3B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5URF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LayerListPanel__ = __webpack_require__("W0OM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist-btn',
  components: {
    'wgu-layerlist-panel': __WEBPACK_IMPORTED_MODULE_1__LayerListPanel__["a" /* default */]
  },
  props: {
    icon: { type: String, required: false, default: 'layers' },
    text: { type: String, required: false, default: '' },
    dark: { type: Boolean, required: false, default: false },
    active: { type: Boolean, required: false, default: false },
    hoverText: { type: String, required: false, default: 'Layers' },
    toggleGroup: { type: String, required: false, default: undefined }
  },
  data: function data() {
    return {
      moduleName: 'wgu-layerlist',
      state: this.active,
      checkStatus: true
    };
  },
  created: function created() {
    var _this = this;

    // TODO move to a father class
    __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$on('app-mounted', function () {
      _this.panel = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.cmpLookup[_this.moduleName + '-panel'];
    });
    // When member of toggle group: close if any other panel active
    if (this.toggleGroup) {
      __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$on(this.toggleGroup, function (_ref) {
        var moduleName = _ref.moduleName,
            state = _ref.state;

        // console.log(moduleName, state);
        _this.state = moduleName === _this.moduleName && state;
      });
    }
    __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$on('close-layer', function (state) {
      _this.checkStatus = state;
    });
  },

  methods: {
    toggleUi: function toggleUi() {
      if (this.checkStatus === false) {
        this.state = true;
        this.checkStatus = true;
      } else {
        this.state = !this.state;
      }
      __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$emit('toggle-layerlist-panel', this.state);
    }
  }
});

/***/ }),

/***/ "5bzy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ANF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7NXR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = geolocationLayers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_style__ = __webpack_require__("beD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_Geolocation__ = __webpack_require__("Z+Qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_geom_Point__ = __webpack_require__("T18w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_Feature__ = __webpack_require__("nq2H");







function geolocationLayers() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var map = arguments[1];
  var enabled = options.enabled,
      _options$locationFill = options.locationFillColor,
      locationFillColor = _options$locationFill === undefined ? 'hsla(200, 70%, 60%, 0.5)' : _options$locationFill,
      _options$locationStro = options.locationStrokeColor,
      locationStrokeColor = _options$locationStro === undefined ? 'hsl(200, 70%, 40%)' : _options$locationStro,
      _options$accuracyFill = options.accuracyFillColor,
      accuracyFillColor = _options$accuracyFill === undefined ? 'hsla(200, 70%, 80%, 0.1)' : _options$accuracyFill,
      _options$accuracyStro = options.accuracyStrokeColor,
      accuracyStrokeColor = _options$accuracyStro === undefined ? 'hsla(200, 70%, 40%, 0.5)' : _options$accuracyStro;

  if (!enabled) {
    return [];
  }

  var locationSource = new __WEBPACK_IMPORTED_MODULE_0_ol_source_Vector__["a" /* default */]();

  var locationLayer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__["a" /* default */]({
    name: 'geolocation',
    displayInLayerList: false,
    style: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["b" /* Style */]({
      image: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["c" /* RegularShape */]({
        fill: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["d" /* Fill */]({ color: locationFillColor }),
        stroke: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["e" /* Stroke */]({ color: locationStrokeColor, width: 2 }),
        points: 16,
        radius: 5
      })
    }),
    source: locationSource
  });

  var accuracySource = new __WEBPACK_IMPORTED_MODULE_0_ol_source_Vector__["a" /* default */]();
  var accuracyLayer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__["a" /* default */]({
    name: 'geolocation-accuracy',
    displayInLayerList: false,
    style: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["b" /* Style */]({
      fill: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["d" /* Fill */]({ color: accuracyFillColor }),
      stroke: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["e" /* Stroke */]({ color: accuracyStrokeColor, width: 1 })
    }),
    source: accuracySource
  });
  var geolocation = new __WEBPACK_IMPORTED_MODULE_3_ol_Geolocation__["a" /* default */]({
    projection: map.getView().getProjection(),
    tracking: true
  });
  var locationFeature = void 0,
      accuracyFeature = void 0;

  geolocation.on('change', function (e) {
    var coordinates = geolocation.getPosition();
    if (!locationFeature) {
      locationFeature = new __WEBPACK_IMPORTED_MODULE_5_ol_Feature__["a" /* default */](new __WEBPACK_IMPORTED_MODULE_4_ol_geom_Point__["a" /* default */](coordinates));
      locationSource.addFeature(locationFeature);
      accuracyFeature = new __WEBPACK_IMPORTED_MODULE_5_ol_Feature__["a" /* default */](geolocation.getAccuracyGeometry());
      accuracySource.addFeature(accuracyFeature);
    } else {
      locationFeature.getGeometry().setCoordinates(coordinates);
      accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
    }
  });

  return [locationLayer, accuracyLayer];
}

/***/ }),

/***/ "7OTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    icon: { type: String, required: false, default: 'help' },
    title: { type: String, required: false, default: 'About' },
    headline: { type: String, required: false, default: 'About Wegue' },
    content: { type: String, required: false, default: '<h3>WebGIS with OpenLayers and Vue.js</h3> Template and re-usable components for webmapping applications with OpenLayers and Vue.js' },
    infoLink: { type: String, required: false, default: 'https://github.com/meggsimum/wegue' },
    infoLinkText: { type: String, required: false, default: 'More info' }
  },
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    onWinXClose: function onWinXClose() {
      this.$emit('winxclose');
    }
  }
});

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8lRV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8nIO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_format_GeoJSON__ = __webpack_require__("aUhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__("t4zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_togpx__ = __webpack_require__("G6HG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_togpx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_togpx__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-downloadlayers-btn',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__src_mixins_Mapable__["a" /* Mapable */]],
  props: {
    dark: { type: Boolean, required: false, default: false },
    icon: { type: String, required: false, default: 'cloud_download' },
    hoverText: { type: String, required: false, default: 'Download all active layers as GPX' }
  },
  data: function data() {
    return {
      state: false
    };
  },
  methods: {
    click: function click() {
      console.log(this.map);
      var geojson = new __WEBPACK_IMPORTED_MODULE_4_ol_format_GeoJSON__["a" /* default */]();
      var layers = this.map.getLayers().getArray().filter(function (l) {
        return l.getVisible() && l.get('displayInLayerList') !== false && l.getSource().getFeatures;
      });
      var features = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(layers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var layer = _step.value;

          features.push.apply(features, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(layer.getSource().getFeatures()));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var featureCollection = geojson.writeFeaturesObject(features, { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' });
      featureCollection.features = featureCollection.features.filter(function (f) {
        return f.geometry.type !== 'Polygon' && f.geometry.type !== 'MultiPolygon';
      });
      var gpx = __WEBPACK_IMPORTED_MODULE_6_togpx___default()(featureCollection, {
        creator: 'Wegue',
        metadata: {
          name: this.$t('Wegue layers')
        }
      });
      var blob = new Blob([gpx], { type: 'application/gpx+xml' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_file_saver__["saveAs"])(blob, 'layers.gpx');
    }
  }
});

/***/ }),

/***/ "97QL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "98Q5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9OlX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = json;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

// TODO: may use Axios/Axios-jsonp
function json(obj) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var url = encodeUrlXhr(obj.url, obj.data);
    var config = {
      method: 'GET',
      mode: 'cors',
      credentials: 'same-origin'
    };

    if (obj.jsonp) {
      jsonp(url, obj.callbackName, resolve);
    } else {
      fetch(url, config).then(function (r) {
        return r.json();
      }).then(resolve).catch(reject);
    }
  });
}

function toQueryString(obj) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).reduce(function (a, k) {
    a.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[k]) === 'object' ? toQueryString(obj[k]) : encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]));
    return a;
  }, []).join('&');
}

function encodeUrlXhr(url, data) {
  if (data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) === 'object') {
    url += (/\?/.test(url) ? '&' : '?') + toQueryString(data);
  }
  return url;
}

function jsonp(url, key, callback) {
  // https://github.com/Fresheyeball/micro-jsonp/blob/master/src/jsonp.js
  var head = document.head;
  var script = document.createElement('script');
  // generate minimally unique name for callback function
  var callbackName = 'f' + Math.round(Math.random() * Date.now());

  // set request url
  script.setAttribute('src',
  /*  add callback parameter to the url
        where key is the parameter key supplied
        and callbackName is the parameter value */
  url + (url.indexOf('?') > 0 ? '&' : '?') + key + '=' + callbackName);

  /*  place jsonp callback on window,
      the script sent by the server should call this
      function as it was passed as a url parameter */
  window[callbackName] = function (data) {
    window[callbackName] = undefined;

    // clean up script tag created for request
    setTimeout(function () {
      return head.removeChild(script);
    }, 0);

    // hand data back to the user
    callback(data);
  };

  // actually make the request
  head.appendChild(script);
}

/***/ }),

/***/ "AFLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routingLayers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_format_GeoJSON__ = __webpack_require__("aUhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_geom_LineString__ = __webpack_require__("grfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_style__ = __webpack_require__("beD/");






function routingLayers(routingOptions, map) {
  if (!routingOptions) {
    return;
  }
  var _routingOptions$start = routingOptions.startLabel,
      startLabel = _routingOptions$start === undefined ? 'Start' : _routingOptions$start,
      _routingOptions$endLa = routingOptions.endLabel,
      endLabel = _routingOptions$endLa === undefined ? 'Finish' : _routingOptions$endLa,
      _routingOptions$$t = routingOptions.$t,
      $t = _routingOptions$$t === undefined ? function (x) {
    return x;
  } : _routingOptions$$t;

  var stopsSource = new __WEBPACK_IMPORTED_MODULE_2_ol_source_Vector__["a" /* default */]({});
  var labelStyle = new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
    text: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["f" /* Text */]({
      font: 'bold 14px "Open Sans", "Arial Unicode MS", "sans-serif"',
      fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["d" /* Fill */]({
        color: 'black'
      })
    })
  });

  var stopStyle = new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
    image: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["c" /* RegularShape */]({
      fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["d" /* Fill */]({ color: 'white' }),
      stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({ color: 'black', width: 2 }),
      points: 20,
      radius: 10,
      angle: 0
    })
  });
  var stopsLayer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__["a" /* default */]({
    name: 'route-stops',
    displayInLayerList: false,
    style: function style(feature) {
      labelStyle.getText().setText('' + feature.get('changeId'));
      // return [stopStyle]; // /* , labelStyle */
      return [stopStyle, labelStyle];
    },
    source: stopsSource
  });
  var endpointLabelStyle = new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
    text: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["f" /* Text */]({
      font: 'bold 18px "Open Sans", "Arial Unicode MS", "sans-serif"',
      // offsetY: -15,
      textAlign: 'left',
      offsetX: 12,
      fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["d" /* Fill */]({
        color: 'white'
      }),
      stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({
        color: 'black',
        width: 2
      })
    })
  });
  var startSource = new __WEBPACK_IMPORTED_MODULE_2_ol_source_Vector__["a" /* default */]({});
  var startLayer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__["a" /* default */]({
    name: 'route-start',
    displayInLayerList: false,
    style: function style(feature) {
      return [new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["c" /* RegularShape */]({
          fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["d" /* Fill */]({ color: 'hsl(120,80%,40%)' }),
          stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({ color: 'black', width: 2 }),
          points: 40,
          radius: 10,
          angle: 3.14159 / 4
        })
      }), (endpointLabelStyle.getText().setText($t(startLabel)), endpointLabelStyle)];
    },
    source: startSource
  });
  var endSource = new __WEBPACK_IMPORTED_MODULE_2_ol_source_Vector__["a" /* default */]({});
  var endLayer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__["a" /* default */]({
    name: 'route-end',
    displayInLayerList: false,
    source: endSource,
    style: function style(feature) {
      return [new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["c" /* RegularShape */]({
          fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["d" /* Fill */]({ color: 'hsl(0,80%,40%)' }),
          stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({ color: 'black', width: 2 }),
          points: 4,
          radius: 12,
          angle: 3.14159 / 4
        })
      }), (endpointLabelStyle.getText().setText($t(endLabel)), endpointLabelStyle)];
    }
  });
  var waypointsSource = new __WEBPACK_IMPORTED_MODULE_2_ol_source_Vector__["a" /* default */]({});
  var waypointsLayer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__["a" /* default */]({
    name: 'route-waypoints',
    displayInLayerList: false,
    source: waypointsSource,
    style: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
      image: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["c" /* RegularShape */]({
        fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["d" /* Fill */]({ color: 'white' }),
        stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({ color: 'black', width: 2 }),
        points: 40,
        radius: 6
      })
    })
  });
  var routeSource = new __WEBPACK_IMPORTED_MODULE_2_ol_source_Vector__["a" /* default */]({});
  var routeLayer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Vector__["a" /* default */]({
    name: 'route',
    displayInLayerList: false,
    style: function style(feature) {
      if (feature.getProperties().type === 'PrivateTransportManeuverType' || feature.getProperties().type === 'pedestrian') {
        return [new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
          stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({
            width: 8,
            color: 'hsla(250,100%,20%,0.9)',
            lineDash: [2, 10]
          })
        }), new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
          stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({
            width: 4,
            color: 'white',
            lineDash: [2, 10]
          })
        })];
      } else {
        return [new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
          stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({
            width: 12,
            color: 'hsla(250,50%,20%,0.4)'
          })
        }), new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
          stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({
            width: 8,
            color: 'hsla(250,100%,20%,0.9)'
          })
        }), new __WEBPACK_IMPORTED_MODULE_5_ol_style__["b" /* Style */]({
          stroke: new __WEBPACK_IMPORTED_MODULE_5_ol_style__["e" /* Stroke */]({
            width: 4,
            color: 'white'
          })
        })];
      }
    },
    source: routeSource
  });
  __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('route-update', function (_ref) {
    var routeGeometry = _ref.routeGeometry,
        startGeometry = _ref.startGeometry,
        waypointsGeometry = _ref.waypointsGeometry,
        endGeometry = _ref.endGeometry,
        stopsGeometry = _ref.stopsGeometry,
        boundingBox = _ref.boundingBox;

    var featureProjection = map.getView().getProjection();
    var geojson = new __WEBPACK_IMPORTED_MODULE_3_ol_format_GeoJSON__["a" /* default */]({ featureProjection: featureProjection });

    [routeSource, startSource, waypointsSource, endSource, stopsSource].forEach(function (s) {
      return s.clear();
    });
    if (routeGeometry) {
      routeSource.addFeatures(geojson.readFeatures(routeGeometry));
    }
    if (startGeometry) {
      startSource.addFeatures(geojson.readFeatures(startGeometry));
    }
    if (waypointsGeometry) {
      waypointsSource.addFeatures(geojson.readFeatures(waypointsGeometry));
    }
    if (endGeometry) {
      endSource.addFeatures(geojson.readFeatures(endGeometry));
    }
    if (stopsGeometry) {
      stopsSource.addFeatures(geojson.readFeatures(stopsGeometry));
    }
    if (boundingBox) {
      // map.zoomToExtent(new OpenLayers.Bounds(...boundingBox).transform('EPSG:4326', featureProjection);
      var line = new __WEBPACK_IMPORTED_MODULE_4_ol_geom_LineString__["a" /* default */]([[boundingBox[0], boundingBox[1]], [boundingBox[2], boundingBox[3]]]);
      map.getView().fit(line.transform('EPSG:4326', featureProjection), {
        padding: [50, 80, 80, 350],
        maxZoom: 14
      });
    }
  });
  __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('locale-changed', function () {
    startSource.changed();
    endSource.changed();
  });
  return [routeLayer, stopsLayer, startLayer, waypointsLayer, endLayer];
}

/***/ }),

/***/ "B0Sl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.onClick}},tooltip),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Reset map')))])])}
var staticRenderFns = []


/***/ }),

/***/ "B0ph":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BHAw":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Public transport directions":"Wegbeschreibung für öffentliche Verkehrsmittel","Driving directions":"Wegbeschreibung","Bicycle directions":"Wegbeschreibung","Walking directions":"Wegbeschreibung","Duration":"Dauer","Departure":"Abfahrt","depart":"ab","Arrival":"Ankunft","arrive":"an","Distance":"Entfernung","Hour(s)":"Stunde(n)","Minute(s)":"Minuten(n)","Routes":"Routen","Instructions":"Anweisungen","km":"km","Section":"Abschnitt","TakeVehicleTo":"Nehmen Sie den <span class=\\"transit-name\\">{mode} {name}</span> Richtung <span class=\\"transit-headsign\\">{transportHeadsign}</span> nach <span class=\\"transit-headsign\\">{transportTailsign}</span>.","regionalTrain":"Regionalzug","bus":"Bus","WalkTo":"Gehen Sie {metres} Meter nach {destination}."},"en":{"TakeVehicleTo":"Take the <span class=\\"transit-name\\">{mode} {name}</span> direction <span class=\\"transit-headsign\\">{transportHeadsign}</span> to <span class=\\"transit-headsign\\">{transportTailsign}</span>.","bus":"bus","regionalTrain":"regional train","WalkTo":"Walk {metres} metres to {destination}.","depart":"de","arrive":"ar"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "BeCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{class:{'wgu-layer-list-tabs': true, 'wgu-layer-no-header': _vm.tabs.length < 2},attrs:{"dark":_vm.dark,"sliderColor":_vm.sliderColor,"grow":""}},[_vm._l((_vm.tabs),function(tab){return [_c('v-tab',{key:tab.title},[_vm._v("\n      "+_vm._s(_vm.$t(tab.title))+"\n    ")]),_vm._v(" "),_c('v-tab-item',{key:tab.title},[_c('v-list',[_c('v-treeview',{staticClass:"wgu-layer-treeview ",attrs:{"items":tab.items,"load-children":tab.loadFunc,"open":tab.unfolded},on:{"update:open":function($event){return _vm.$set(tab, "unfolded", $event)}},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.visible),expression:"item.visible"}],key:item.lid,staticClass:"wgu-layer-viz-cb",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.visible)?_vm._i(item.visible,null)>-1:(item.visible)},on:{"change":[function($event){var $$a=item.visible,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "visible", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "visible", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "visible", $$c)}},function($event){return _vm.onItemChanged(item)}]}}),_vm._v(" "),(item.category === 'poi')?_c('img',{staticClass:"poi-icon",attrs:{"src":item.icon,"alt":"POI Icon"}}):_vm._e(),_vm._v(" "),(item.category === 'route')?_c('v-card',{staticClass:"mr-2",style:({
                borderTopColor: item.stroke.getColor(),
                borderTopWidth: 3,
                borderTopStyle: {'6,12':'dashed', '1,8': 'dotted', null: 'solid'}[item.stroke.getLineDash()] || 'dashed'
              }),attrs:{"width":"30","height":"4"}}):_vm._e(),_vm._v(" "),(item.category === 'area')?_c('v-card',{staticClass:"mr-2",style:({
                background: item.fill.getColor(),
                borderWidth: '3px',
                borderStyle: {'6,12':'dashed', '1,8': 'dotted', null: 'solid'}[item.stroke.getLineDash()] || 'dashed',
                borderColor: item.stroke.getColor()
              }),attrs:{"width":"30","height":"30"}}):_vm._e()]}}],null,true)})],1)],1)]})],2)}
var staticRenderFns = []


/***/ }),

/***/ "Bik2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Photon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


// Code modified from: https://github.com/jonataswalker/ol-geocoder version: Aug 01, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//

/**
 * Photon Provider. See https://photon.komoot.de.
 *
 * @class Photon
 */
var Photon = function () {
  /**
   * @constructor
   */
  function Photon() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Photon);

    this.settings = {
      url: 'https://photon.komoot.de/api/',
      params: {
        q: '',
        limit: 10,
        lang: 'en'
      },
      langs: ['de', 'it', 'fr', 'en']
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Photon, [{
    key: 'getParameters',
    value: function getParameters(options) {
      options.lang = options.lang.toLowerCase();

      return {
        url: this.settings.url,
        params: {
          q: options.query,
          limit: options.limit || this.settings.params.limit,
          lang: this.settings.langs.indexOf(options.lang) > -1 ? options.lang : this.settings.params.lang
        }
      };
    }
  }, {
    key: 'handleResponse',
    value: function handleResponse(results) {
      if (!results.features.length) return;
      return results.features.map(function (feature) {
        // Response is GeoJSON
        var geometry = feature.geometry;
        var properties = feature.properties;
        var displayName = properties.name + ' ' + (properties.city || '') + ' ' + (properties.postcode || '') + ' ' + (properties.state || '') + ' ' + (properties.country || '');
        var result = {
          lon: geometry.coordinates[0],
          lat: geometry.coordinates[1],
          address: {
            name: displayName,
            postcode: properties.postcode || '',
            city: properties.city || '',
            state: properties.state || '',
            country: properties.country || ''
          },
          original: {
            formatted: displayName,
            details: properties
          }
        };
        // Sometimes has bbox
        if (properties.extent) {
          result.boundingbox = properties.extent;
        }
        return result;
      });
    }
  }]);

  return Photon;
}();

/***/ }),

/***/ "C3SY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-app-tpl')}
var staticRenderFns = []


/***/ }),

/***/ "CCtF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),

/***/ "CFm3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"wgu-helpwin"},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{on:{"click":_vm.onWinXClose}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('div',{},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])]),_vm._v(" "),_c('v-card-actions',[_c('a',{staticClass:"info-link red--text darken3",attrs:{"href":_vm.infoLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.infoLinkText))])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "CrNA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"grey--text",attrs:{"color":_vm.color,"app":""}},[_c('span',{staticClass:"wgu-footer-left",domProps:{"innerHTML":_vm._s(_vm.footerTextLeft)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"wgu-footer-right"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.footerTextRight)}}),_vm._v(" "),(_vm.showCopyrightYear)?_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear()))]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),

/***/ "Dam3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DcW1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-infoclick-btn',
  props: {
    icon: { type: String, required: false, default: 'info' },
    text: { type: String, required: false, default: '' },
    dark: { type: Boolean, required: false, default: false }
  },
  data: function data() {
    return {
      moduleName: 'wgu-infoclick'
    };
  },
  created: function created() {
    var me = this;
    // TODO move to a father class
    __WEBPACK_IMPORTED_MODULE_1__WguEventBus__["a" /* WguEventBus */].$on('app-mounted', function () {
      me.win = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.cmpLookup[me.moduleName + '-win'];
    });
  },

  methods: {
    toggleUi: function toggleUi() {
      // TODO move to a father class
      this.win.show = !this.win.show;
    }
  }
});

/***/ }),

/***/ "DlRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{staticClass:"px-2",attrs:{"items":_vm.timeModes,"label":_vm.$t('Arrival or departure time'),"box":"","prepend-icon":"start"},model:{value:(_vm.timeMode),callback:function ($$v) {_vm.timeMode=$$v},expression:"timeMode"}}),_vm._v(" "),(_vm.timeMode)?_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"return-value":_vm.time,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.time=$event},"update:return-value":function($event){_vm.time=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({staticClass:"px-2",attrs:{"label":_vm.$t('Time'),"readonly":"","box":"","prepend-icon":"schedule"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},'v-text-field',attrs,false),on))]}}],null,false,2286003465),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),(_vm.menu)?_c('v-time-picker',{attrs:{"full-width":"","format":"24hr"},on:{"click:minute":function($event){return _vm.$refs.menu.save(_vm.time)}},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.timeMode)?_c('v-menu',{ref:"dateMenu",attrs:{"close-on-content-click":false,"return-value":_vm.date,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({staticClass:"px-2",attrs:{"label":_vm.$t('Date'),"readonly":"","box":"","prepend-icon":"today"},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}},'v-text-field',attrs,false),on))]}}],null,false,4270946690),model:{value:(_vm.dateMenu),callback:function ($$v) {_vm.dateMenu=$$v},expression:"dateMenu"}},[_c('v-date-picker',{attrs:{"label":_vm.$t('Date'),"locale":"de-de","first-day-of-week":"1"},on:{"input":function($event){_vm.dateMenu = false}},model:{value:(_vm.rawDate),callback:function ($$v) {_vm.rawDate=$$v},expression:"rawDate"}})],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "Es/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadLayersButton_vue__ = __webpack_require__("8nIO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd4564c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadLayersButton_vue__ = __webpack_require__("RYc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("8lRV")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadLayersButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd4564c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadLayersButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd4564c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadLayersButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("y056")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F+zM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_geom_LineString__ = __webpack_require__("grfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_geom_Polygon__ = __webpack_require__("ZYQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__ = __webpack_require__("1avf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measure-result',
  props: {
    measureGeom: { type: Object }
  },
  data: function data() {
    return {
      area: ' -- ',
      distance: ' -- '
    };
  },

  watch: {
    measureGeom: function measureGeom() {
      var me = this;
      var geom = me.measureGeom.geom;
      var output = void 0;
      if (geom instanceof __WEBPACK_IMPORTED_MODULE_1_ol_geom_Polygon__["a" /* default */]) {
        output = me.formatArea(geom);
        me.area = output;
      } else if (geom instanceof __WEBPACK_IMPORTED_MODULE_0_ol_geom_LineString__["a" /* default */]) {
        output = me.formatLength(geom);
        me.distance = output;
      } else {
        me.area = ' -- ';
        me.distance = ' -- ';
      }
    }
  },
  methods: {
    /**
     * Calculates and formats the length of the given line.
     *
     * @param  {ol.geom.LineString} line The LineString object to calculate length for
     */
    formatLength: function formatLength(line) {
      var length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__["c" /* getLength */])(line);
      var output = void 0;
      if (length > 100) {
        output = Math.round(length / 1000 * 100) / 100 + ' ' + 'km';
      } else {
        output = Math.round(length * 100) / 100 + ' ' + 'm';
      }
      return output;
    },

    /**
     * Calculates and formats the area of the given polygon.
     *
     * @param  {ol.geom.Polygon} polygon The Polygon object to calculate area for
     */
    formatArea: function formatArea(polygon) {
      var area = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__["d" /* getArea */])(polygon);
      var output = void 0;
      if (area > 10000) {
        output = Math.round(area / 1000000 * 100) / 100 + ' ' + 'km²';
      } else {
        output = Math.round(area * 100) / 100 + ' ' + 'm²';
      }
      return output;
    }
  }
});

/***/ }),

/***/ "FO/s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fhxr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G6Sb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapboxAttribution_vue__ = __webpack_require__("SRNx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164097ba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapboxAttribution_vue__ = __webpack_require__("gEbC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("acV0")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-164097ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapboxAttribution_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164097ba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapboxAttribution_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164097ba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapboxAttribution_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GKWk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSelector_vue__ = __webpack_require__("+XPA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338c45da_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSelector_vue__ = __webpack_require__("mJpz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("m7M/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338c45da_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSelector_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338c45da_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSelector_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("sXiz")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GgOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguAppTemplate_vue__ = __webpack_require__("c0QU");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-wgu-app',
  components: {
    'wgu-app-tpl': __WEBPACK_IMPORTED_MODULE_0__WguAppTemplate_vue__["a" /* default */]
    // add Vue methods and hooks here
  } });

/***/ }),

/***/ "Gwjn":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Reset map":"Karte zurücksetzen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "J8V5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LayerList__ = __webpack_require__("zZik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist-panel',
  components: {
    'wgu-layerlist': __WEBPACK_IMPORTED_MODULE_0__LayerList__["a" /* default */]
  },
  props: {
    right: { type: Boolean, required: false, default: false },
    width: { type: Number, required: false, default: 360 },
    height: { type: String, required: false, default: '100%' },
    dark: { type: Boolean, required: false, default: false },
    icon: { type: String, required: false, default: 'layers' },
    color: { type: String, required: false, default: 'red darken-3' },
    active: { type: Boolean, required: false, default: false },
    options: { type: Object, required: false, default: {} },
    toggleGroup: { type: String, required: false, default: undefined }
  },
  data: function data() {
    return {
      moduleName: 'wgu-layerlist',
      drawerOpen: this.active
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$on('toggle-layerlist-panel', function (state) {
      _this.drawerOpen = state === undefined ? !_this.drawerOpen : state;
    });

    __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$on('close-layer-menu', function (state) {
      _this.drawerOpen = false;
    });

    __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$on('open-layer-menu', function (state) {
      _this.drawerOpen = true;
    });

    // When member of toggle group: close if any other panel active
    if (this.toggleGroup) {
      __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$on(this.toggleGroup, function (_ref) {
        var moduleName = _ref.moduleName,
            state = _ref.state;

        _this.drawerOpen = moduleName === _this.moduleName && state;
      });
    }
  },

  methods: {
    closePanel: function closePanel() {
      if (this.drawerOpen === false) {
        // Already closed
        return;
      }
      this.drawerOpen = false;
      __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$emit('close-layer', this.drawerOpen);
    }
  }
});

/***/ }),

/***/ "Kz2t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitLineString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_extent__ = __webpack_require__("/LWt");


// adapted from https://gis.stackexchange.com/questions/306976/add-image-along-the-linestring
// returns a set of points spaced along a line, for symbol placement.
// options:
//   alwaysUp: don't rotate symbols
//   extent: area within which to operate
//   midPoints: place symbols only at midpoints, not along the whole way.
function splitLineString(geometry, minSegmentLength) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  function calculatePointsDistance(coord1, coord2) {
    var dx = coord1[0] - coord2[0];
    var dy = coord1[1] - coord2[1];
    return Math.sqrt(dx * dx + dy * dy);
  };

  function calculateSplitPointCoords(startNode, nextNode, distanceBetweenNodes, distanceToSplitPoint) {
    var d = distanceToSplitPoint / distanceBetweenNodes;
    var x = nextNode[0] + (startNode[0] - nextNode[0]) * d;
    var y = nextNode[1] + (startNode[1] - nextNode[1]) * d;
    return [x, y];
  };

  function calculateAngle(startNode, nextNode, alwaysUp) {
    var x = startNode[0] - nextNode[0];
    var y = startNode[1] - nextNode[1];
    var angle = Math.atan(x / y);
    var offset = y > 0 ? Math.PI : x < 0 ? Math.PI * 2 : 0;
    return alwaysUp ? angle : angle + offset;
  };

  var splitPoints = [];
  var coords = geometry.getCoordinates();

  var coordIndex = 0;

  var _coords$slice = coords.slice(coordIndex, coordIndex + 2),
      _coords$slice2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_coords$slice, 2),
      startPoint = _coords$slice2[0],
      nextPoint = _coords$slice2[1];

  var angle = calculateAngle(startPoint, nextPoint, options.alwaysUp);

  var n = Math.ceil(geometry.getLength() / minSegmentLength);
  var segmentLength = geometry.getLength() / n;
  var currentSegmentLength = options.midPoints ? segmentLength / 2 : segmentLength;

  for (var i = 0; i <= n; i++) {
    var distanceBetweenPoints = calculatePointsDistance(startPoint, nextPoint);
    currentSegmentLength += distanceBetweenPoints;

    if (currentSegmentLength < segmentLength) {
      coordIndex++;
      if (coordIndex < coords.length - 1) {
        var _coords$slice3 = coords.slice(coordIndex, coordIndex + 2);

        var _coords$slice4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_coords$slice3, 2);

        startPoint = _coords$slice4[0];
        nextPoint = _coords$slice4[1];

        angle = calculateAngle(startPoint, nextPoint, options.alwaysUp);
        i--;
        continue;
      } else {
        if (!options.midPoints) {
          var splitPointCoords = nextPoint;
          if (!options.extent || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ol_extent__["e" /* containsCoordinate */])(options.extent, splitPointCoords)) {
            splitPointCoords.push(angle);
            splitPoints.push(splitPointCoords);
          }
        }
        break;
      }
    } else {
      var distanceToSplitPoint = currentSegmentLength - segmentLength;
      var _splitPointCoords = calculateSplitPointCoords(startPoint, nextPoint, distanceBetweenPoints, distanceToSplitPoint);
      startPoint = _splitPointCoords.slice();
      if (!options.extent || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ol_extent__["e" /* containsCoordinate */])(options.extent, _splitPointCoords)) {
        _splitPointCoords.push(angle);
        splitPoints.push(_splitPointCoords);
      }
      currentSegmentLength = 0;
    }
  }

  return splitPoints;
};

/***/ }),

/***/ "L1xf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors__ = __webpack_require__("IHMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Color__ = __webpack_require__("nF/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_proj_js__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_coordinate__ = __webpack_require__("IZoy");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-coords-table',
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    coordsData: { type: Object },
    showMapPos: { type: Boolean, required: false, default: true },
    showWgsPos: { type: Boolean, required: false, default: true },
    showHdms: { type: Boolean, required: false, default: true }
  },
  data: function data() {
    return {
      coordRows: null
    };
  },
  computed: {
    tableStyles: function tableStyles() {
      // calculate border color of tables due to current color property
      var borderColor = this.color;
      if (!__WEBPACK_IMPORTED_MODULE_2__util_Color__["a" /* default */].isCssColor(this.color)) {
        var _color$toString$trim$ = this.color.toString().trim().split(' ', 2),
            _color$toString$trim$2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_color$toString$trim$, 2),
            colorName = _color$toString$trim$2[0],
            colorModifier = _color$toString$trim$2[1];

        borderColor = __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default.a[colorName];
        if (colorModifier) {
          colorModifier = colorModifier.replace('-', '');
          borderColor = __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default.a[colorName][colorModifier];
        }
      }
      return {
        'border': '2px solid ' + borderColor
      };
    }
  },
  methods: {},
  watch: {
    coordsData: function coordsData() {
      var me = this;
      var coordinate = me.coordsData.coordinate;
      var projection = me.coordsData.projection;
      var coordinateWgs84 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj_js__["a" /* transform */])(coordinate, projection, 'EPSG:4326');
      var coordRows = {};

      if (me.showMapPos) {
        // show coordinate in map' SRS
        coordRows['MAP PROJ'] = coordinate[1].toFixed(2) + ' ' + coordinate[0].toFixed(2);
      }
      if (me.showWgsPos) {
        // show coordinate in WGS 84
        var _coordinateWgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj_js__["a" /* transform */])(coordinate, projection, 'EPSG:4326');
        coordRows['WGS 84'] = _coordinateWgs[1].toFixed(7) + '° ' + _coordinateWgs[0].toFixed(7) + '°';
      }
      if (me.showHdms) {
        // show coordinate in WGS 84 as formatted degree / min / secs
        var hdms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_coordinate__["c" /* toStringHDMS */])(coordinateWgs84);
        coordRows['HDMS'] = hdms;
      }

      me.coordRows = coordRows;
    }
  }
});

/***/ }),

/***/ "Lg3E":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Map Click Info":"Kartenklickinfo","Click on the map to get information for the clicked map position.":"Klicken Sie auf die Karte, um Informationen zur angeklickten Kartenposition zu erhalten."}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "MGEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pinSvg;
function pinSvg(_ref) {
  var _ref$strokeColor = _ref.strokeColor,
      strokeColor = _ref$strokeColor === undefined ? 'black' : _ref$strokeColor,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === undefined ? 'white' : _ref$fillColor,
      _ref$fillOpacity = _ref.fillOpacity,
      fillOpacity = _ref$fillOpacity === undefined ? 1 : _ref$fillOpacity,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === undefined ? 30 : _ref$strokeWidth;

  return 'data:image/svg+xml,' + encodeURIComponent('\n    <svg xmlns:osb="http://www.openswatchbook.org/uri/2009/osb"\n      xmlns:dc="http://purl.org/dc/elements/1.1/"\n      xmlns:cc="http://creativecommons.org/ns#"\n      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n      xmlns:svg="http://www.w3.org/2000/svg"\n      xmlns="http://www.w3.org/2000/svg"\n      xmlns:xlink="http://www.w3.org/1999/xlink"\n      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"\n      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" id="Capa_1" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" xml:space="preserve" class="" inkscape:version="0.48.5 r10040" sodipodi:docname="blue-white-center-hollow.svg">\n\n      <g id="g3" transform="matrix(0.06260921,0,0,0.0565501,-0.02795756,0.905589)">\n        <path d="M 256,0 C 167.641,0 96,71.625 96,160 c 0,24.75 5.625,48.219 15.672,69.125 C 112.234,230.313 256,512 256,512 L 398.594,232.625 C 409.719,210.844 416,186.156 416,160 416,71.625 344.375,0 256,0 z"\n          class="active-path"\n          id="path7"\n          style="fill:' + fillColor + ';fill-opacity:' + fillOpacity + ';stroke:' + strokeColor + ';stroke-width:' + strokeWidth + ';stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none"\n        />\n      </g>\n    </svg>\n  ');
}

/***/ }),

/***/ "MPh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DraggableWin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/**
 * Directive to make a window component draggable by dragging it's header.
 * Proudly inspired by and most of the essential code taken from
 * https://github.com/branu-ws/v-drag/blob/master/src/index.js
 */
var DraggableWin = {
  dragConfig: {
    // if this is present, only a specific area of the draggable will respond to
    // dragging (e. g. header bar).
    draggableElementSelector: null,
    down: false,
    height: 0,
    width: 0,
    initialX: 0,
    initialY: 0,
    constraintToWindow: true,
    cursorPreviousX: 0,
    cursorPreviousY: 0,
    draggerOffsetLeft: 0,
    draggerOffsetTop: 0,
    overlay: null,
    draggableEl: null,
    initialZIndex: undefined
  },

  bind: function bind(elmnt, binding, vnode) {
    if (binding.value === false) {
      // disable this directive if set to v-draggable-win="false"
      return;
    }
    // get the header element to bind the events on it
    var header = elmnt.querySelector('div.wgu-win-title');
    if (!header) {
      return;
    }
    var dragConfig = DraggableWin.dragConfig;

    // restrict the dragging at least to window title
    dragConfig.draggableElementSelector = binding.arg || 'wgu-win-title';

    // set cursor so it's signal that the user can drag the window
    header.style.cursor = 'move';

    elmnt.addEventListener('mouseup', function (e) {
      return DraggableWin.mouseup(e, elmnt, dragConfig);
    });
    elmnt.addEventListener('mousedown', function (e) {
      return DraggableWin.mousedown(e, elmnt, dragConfig);
    });
    elmnt.addEventListener('mousemove', function (e) {
      return DraggableWin.mousemove(e, elmnt, dragConfig);
    });
    setDraggerOffset(elmnt, dragConfig);
    dragConfig.initialZIndex = elmnt.style.zIndex;

    /**
     * Creates an overlay in order to bind the mouse events to it.
     * @private
     */
    function createOverlay(e, el, _data) {
      var overlay = document.createElement('div');
      overlay.setAttribute('style', '\n        width: 100vw;\n        height: 100vh;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 10000;\n      ');
      overlay.addEventListener('mouseup', function (e) {
        return mouseup(e, el, _data);
      });
      overlay.addEventListener('mousedown', function (e) {
        return mousedown(e, el, _data);
      });
      overlay.addEventListener('mousemove', function (e) {
        return mousemove(e, el, _data);
      });
      document.body.appendChild(overlay);

      return overlay;
    }

    /**
     * Checks if the given selector (id or class) occurs in the given path
     */
    function checkIfSelectorInPath(selector, path) {
      for (var i = 0; i < path.length; i++) {
        // check for ID
        if (path[i].id === selector) {
          return true;
        }
        // also check for a class name
        if (path[i].classList && path[i].classList.contains(selector)) {
          return true;
        }
      }
      return false;
    }

    /**
     * Adjusts element's z-index.
     */
    function adjustElementZIndex(el, index) {
      el.style.zIndex = index;
    }

    /**
     * Event handler for mouse down.
     */
    function mousedown(e, el, _data) {
      // if the user set a argument to v-drag,
      // it means they only want a specific area to be draggable
      // eg: `v-drag:drag-header` means only the element with
      // id="drag-header" or class="drag-header" should be draggable.
      // If the user clicked another area, do nothing.
      // By default it is restricted to class="wgu-win-title"
      if (_data.draggableElementSelector && !checkIfSelectorInPath(_data.draggableElementSelector, e.path)) {
        return;
      }

      if (_data.overlay) {
        _data.overlay.remove();
      }
      // set the width each click
      // just in case it changed since last time (by external plugin, for example)
      _data.width = el.offsetWidth;
      _data.height = el.offsetHeight;
      _data.down = true;
      _data.initialX = e.clientX;
      _data.initialY = e.clientY;
      var overlay = createOverlay(e, el, _data);
      _data.overlay = overlay;
      adjustElementZIndex(el, 10001);
    }
    DraggableWin.mousedown = mousedown;

    /**
     * Event handler for mouse up.
     */
    function mouseup(e, el, _data) {
      _data.down = false;
      if (!_data.overlay) {
        return;
      }

      _data.overlay.removeEventListener('mouseup', mouseup);
      _data.overlay.removeEventListener('mousedown', mousedown);
      _data.overlay.removeEventListener('mousemove', mousemove);
      _data.overlay.remove();
      adjustElementZIndex(el, _data.initialZIndex);

      setDraggerOffset(el, _data);

      // preserve the current position as property of the vue / Wegue window
      // so it can be restored when the window is re-opened
      vnode.componentInstance.$parent.top = _data.draggerOffsetTop + 'px';
      vnode.componentInstance.$parent.left = _data.draggerOffsetLeft + 'px';
    }
    DraggableWin.mouseup = mouseup;

    /**
     * Checks if left window boundary is reached.
     */
    function reachedLeft(el, _data, movingLeft) {
      return el.offsetLeft + _data.width >= window.innerWidth && !movingLeft;
    }

    /**
     * Checks if right window boundary is reached.
     */
    function reachedRight(el, _data, movingRight) {
      return el.offsetLeft <= 0 && !movingRight;
    }

    /**
     * Checks if top window boundary is reached.
     */
    function reachedTop(el, _data, movingUp) {
      return el.offsetTop <= 0 && !movingUp;
    }

    /**
     * Checks if bottom window boundary is reached.
     */
    function reachedBottom(el, _data, movingDown) {
      return el.offsetTop + _data.height >= window.innerHeight && !movingDown;
    }

    /**
     * Event handler for mouse move.
     */
    function mousemove(e, el, _data) {
      if (_data.down) {
        var movingLeft = _data.cursorPreviousX > e.clientX;
        var movingRight = _data.cursorPreviousX < e.clientX;
        var movingUp = _data.cursorPreviousY < e.clientY;
        var movingDown = _data.cursorPreviousY > e.clientY;

        if (_data.constraintToWindow && (reachedLeft(el, _data, movingLeft) || reachedRight(el, _data, movingRight))) {
          // do now allow moving outside the window horizontally
        } else {
          el.style.left = _data.draggerOffsetLeft + (e.clientX - _data.initialX) + 'px';
        }
        if (_data.constraintToWindow && (reachedTop(el, _data, movingUp) || reachedBottom(el, _data, movingDown))) {
          // do now allow moving outside the window vertically
        } else {
          el.style.top = _data.draggerOffsetTop + (e.clientY - _data.initialY) + 'px';
        }
      }
      _data.cursorPreviousX = e.clientX;
      _data.cursorPreviousY = e.clientY;
    }
    DraggableWin.mousemove = mousemove;

    /**
     * Applies the offset values of the element.
     */
    function setDraggerOffset(el, _data) {
      _data.draggerOffsetLeft = el.offsetLeft;
      _data.draggerOffsetTop = el.offsetTop;
    }
  }
};

// Make directive available globally
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('draggable-win', DraggableWin);

/***/ }),

/***/ "N/yJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_ol_ol_css__ = __webpack_require__("ktr9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_ol_ol_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_ol_ol_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_WguApp__ = __webpack_require__("y+0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Url__ = __webpack_require__("v9hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_i18n__ = __webpack_require__("TXmL");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_i18n__["a" /* default */]);

__webpack_require__("SPmS");

// try to load an optional app specific CSS file (set project-specific styles)
try {
  __webpack_require__("Op2c");
} catch (e) {}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// Detect isEmbedded state by attribute embedded and
// make accessible for all components
// recommended by https://vuejs.org/v2/cookbook/adding-instance-properties.html
var appEl = document.querySelector('#app');
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isEmbedded = appEl.hasAttribute('embedded');

// Detect an URL parameter for a custom app context
var appCtx = __WEBPACK_IMPORTED_MODULE_4__util_Url__["a" /* default */].getQueryParam('appCtx');
var appCtxFile = '';
if (appCtx) {
  // simple aproach to avoid path traversal
  appCtxFile = '-' + appCtx.replace(/(\.\.[/])+/g, '');
}
var lang = (navigator.languages || [])[0] || navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
var locale = lang.match(/^de/i) ? 'de' : 'en';

var createApp = function createApp(appConfig) {
  // make app config accessible for all components
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$appConfig = appConfig;
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    template: '<wgu-app/>',
    components: { WguApp: __WEBPACK_IMPORTED_MODULE_3__app_WguApp__["a" /* default */] },
    i18n: new __WEBPACK_IMPORTED_MODULE_6_vue_i18n__["a" /* default */]({
      locale: locale,
      silentTranslationWarn: true
    })
  });
};

fetch('app/static/app-conf' + appCtxFile + '.json').then(function (response) {
  return response.json().then(function (appConfig) {
    // console.log('app', appConfig);
    createApp(appConfig);
  });
}).catch(function () {
  fetch('static/app-conf' + appCtxFile + '.json').then(function (response) {
    return response.json().then(function (appConfig) {
      // console.log('static', appConfig);
      createApp(appConfig);
    });
  });
});

/***/ }),

/***/ "NkLf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("DcW1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa472a4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("mNnC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("N/yJ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa472a4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa472a4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nkpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PropertyTable__ = __webpack_require__("ZY9t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CoordsTable__ = __webpack_require__("R3+W");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-infoclick-win',
  components: {
    'wgu-property-table': __WEBPACK_IMPORTED_MODULE_1__PropertyTable__["a" /* default */],
    'wgu-coords-table': __WEBPACK_IMPORTED_MODULE_2__CoordsTable__["a" /* default */]
  },
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    icon: { type: String, required: false, default: 'info' },
    title: { type: String, required: false, default: 'Map Click Info' },
    draggable: { type: Boolean, required: false, default: true },
    initPos: { type: Object, required: false }
  },
  data: function data() {
    return {
      show: false,
      left: this.initPos ? this.initPos.left + 'px' : '0',
      top: this.initPos ? this.initPos.top + 'px' : '0',
      attributeData: null,
      coordsData: null
    };
  },
  created: function created() {
    var me = this;
    // Listen to the ol-map-mounted event and receive the OL map instance
    __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
      // make the OL map accessible in this component
      me.map = olMap;
    });
  },

  methods: {
    toggleUi: function toggleUi() {
      this.show = !this.show;
    },
    registerMapClick: function registerMapClick(unregister) {
      var me = this;

      if (unregister === true) {
        me.map.un('singleclick', me.onMapClick);
      } else {
        me.map.on('singleclick', me.onMapClick);
      }
    },

    /**
     * Handler for 'singleclick' on the map.
     * Collects data and passes it to corresponding objects.
     *
     * @param  {ol/MapBrowserEvent} evt The OL event of 'singleclick' on the map
     */
    onMapClick: function onMapClick(evt) {
      var me = this;
      var featureLayer = me.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        return [feature, layer];
      });

      // collect feature attributes --> PropertyTable
      if (featureLayer) {
        var feat = featureLayer[0];
        var props = feat.getProperties();
        // do not show geometry property
        delete props.geometry;

        me.attributeData = props;
      } else {
        me.attributeData = null;
      }

      // collect click coordinate + projection --> CoordsTable
      me.coordsData = {
        coordinate: evt.coordinate,
        projection: me.map.getView().getProjection().getCode()
      };
    }
  },
  watch: {
    show: function show() {
      var me = this;
      if (this.show === true) {
        me.registerMapClick();
      } else {
        // cleanup old data
        me.attributeData = null;
        me.coordsData = null;
      }
    }
  }
});

/***/ }),

/***/ "OUY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("t4zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_togpx__ = __webpack_require__("G6HG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_togpx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_togpx__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['transportMode', 'routeGeometry'],
  methods: {
    clickSaveGpx: function clickSaveGpx() {
      if (!this.routeGeometry) {
        return;
      }
      var geom = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.routeGeometry));
      geom.features.forEach(function (line) {
        line.properties = {
          name: line.properties.instruction
        };
      });
      var gpx = __WEBPACK_IMPORTED_MODULE_2_togpx___default()(geom, {
        creator: 'Wegue',
        metadata: {
          name: this.transportMode + ' directions'
        }
      });
      var blob = new Blob([gpx], { type: 'application/gpx+xml' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_file_saver__["saveAs"])(blob, 'route.gpx');
    }
  }
});

/***/ }),

/***/ "OUzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayerFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_layer_Tile__ = __webpack_require__("Mdwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_source_TileWMS__ = __webpack_require__("DwLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_source_OSM__ = __webpack_require__("WiOa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_layer_VectorTile__ = __webpack_require__("fZPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_source_VectorTile__ = __webpack_require__("hGhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_format_MVT__ = __webpack_require__("fGhu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_format_GeoJSON__ = __webpack_require__("aUhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_format_TopoJSON__ = __webpack_require__("UjZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_format_KML__ = __webpack_require__("srNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_source_XYZ__ = __webpack_require__("irp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OlStyle__ = __webpack_require__("fT5P");

















/**
 * Factory, which creates OpenLayers layer instances according to a given config
 * object.
 */
var LayerFactory = {

  /**
   * Maps the format literal of the config to the corresponding OL module.
   * @type {Object}
   */
  formatMapping: {
    'MVT': __WEBPACK_IMPORTED_MODULE_8_ol_format_MVT__["a" /* default */],
    'GeoJSON': __WEBPACK_IMPORTED_MODULE_9_ol_format_GeoJSON__["a" /* default */],
    'TopoJSON': __WEBPACK_IMPORTED_MODULE_10_ol_format_TopoJSON__["a" /* default */],
    'KML': __WEBPACK_IMPORTED_MODULE_11_ol_format_KML__["a" /* default */]
  },

  /**
   * Returns an OpenLayers layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Base} OL layer instance
   */
  getInstance: function getInstance(lConf) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // apply LID (Layer ID) if not existent
              if (!lConf.lid) {
                // Make a unique layerId from Layer name and URL so contexts
                // like permalinks can be reapplied.
                lConf.lid = btoa(lConf.url + lConf.name).substr(0, 6);
              }

              // create correct layer type

              if (!(lConf.type === 'WMS')) {
                _context.next = 5;
                break;
              }

              return _context.abrupt('return', _this.createWmsLayer(lConf));

            case 5:
              if (!(lConf.type === 'XYZ')) {
                _context.next = 9;
                break;
              }

              return _context.abrupt('return', _this.createXyzLayer(lConf));

            case 9:
              if (!(lConf.type === 'OSM')) {
                _context.next = 13;
                break;
              }

              return _context.abrupt('return', _this.createOsmLayer(lConf));

            case 13:
              if (!(lConf.type === 'VECTOR')) {
                _context.next = 17;
                break;
              }

              return _context.abrupt('return', _this.createVectorLayer(lConf));

            case 17:
              if (!(lConf.type === 'VECTORTILE')) {
                _context.next = 21;
                break;
              }

              return _context.abrupt('return', _this.createVectorTileLayer(lConf));

            case 21:
              if (!(lConf.type === 'LAYERCOLLECTION')) {
                _context.next = 25;
                break;
              }

              return _context.abrupt('return', _this.createLayersFromCollection(lConf, options));

            case 25:
              return _context.abrupt('return', null);

            case 26:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  /**
   * Returns an OpenLayers WMS layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL WMS layer instance
   */
  createWmsLayer: function createWmsLayer(lConf) {
    var layer = new __WEBPACK_IMPORTED_MODULE_3_ol_layer_Tile__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      selectable: lConf.selectable || false,
      extent: lConf.extent,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_4_ol_source_TileWMS__["a" /* default */]({
        url: lConf.url,
        params: {
          'LAYERS': lConf.layers,
          'TILED': lConf.tiled
        },
        serverType: lConf.serverType,
        attributions: lConf.attributions,
        crossOrigin: 'Anonymous'
      })
    });

    return layer;
  },


  /**
   * Returns an XYZ based tile layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL XYZ layer instance
   */
  createXyzLayer: function createXyzLayer(lConf) {
    var xyzLayer = new __WEBPACK_IMPORTED_MODULE_3_ol_layer_Tile__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      selectable: lConf.selectable || false,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_14_ol_source_XYZ__["a" /* default */]({
        url: lConf.url,
        crossOrigin: 'Anonymous',
        attributions: lConf.attributions
      })
    });

    return xyzLayer;
  },


  /**
   * Returns an OpenLayers OSM layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL OSM layer instance
   */
  createOsmLayer: function createOsmLayer(lConf) {
    var layer = new __WEBPACK_IMPORTED_MODULE_3_ol_layer_Tile__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      selectable: lConf.selectable || false,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_5_ol_source_OSM__["b" /* default */]({ crossOrigin: 'Anonymous' })
    });

    return layer;
  },


  /**
   * Returns an OpenLayers vector layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Vector} OL vector layer instance
   */
  createVectorLayer: function createVectorLayer(lConf) {
    var vectorLayer = new __WEBPACK_IMPORTED_MODULE_12_ol_layer_Vector__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      tags: lConf.tags,
      displayInLayerList: lConf.displayInLayerList,
      selectable: lConf.selectable || false,
      routable: lConf.routable || false,
      extent: lConf.extent,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_13_ol_source_Vector__["a" /* default */]({
        url: lConf.url,
        format: new this.formatMapping[lConf.format](lConf.formatConfig),
        attributions: lConf.attributions
      }),
      style: __WEBPACK_IMPORTED_MODULE_15__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      styleSelected: __WEBPACK_IMPORTED_MODULE_15__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.styleSelected),
      hoverable: lConf.hoverable,
      hoverAttribute: lConf.hoverAttribute
    });

    return vectorLayer;
  },


  /**
   * Returns an OpenLayers vector tile layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.VectorTile} OL vector tile layer instance
   */
  createVectorTileLayer: function createVectorTileLayer(lConf) {
    var vtLayer = new __WEBPACK_IMPORTED_MODULE_6_ol_layer_VectorTile__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      selectable: lConf.selectable || false,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_7_ol_source_VectorTile__["a" /* default */]({
        url: lConf.url,
        format: new this.formatMapping[lConf.format](),
        attributions: lConf.attributions
      }),
      style: __WEBPACK_IMPORTED_MODULE_15__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      hoverable: lConf.hoverable,
      hoverAttribute: lConf.hoverAttribute
    });

    return vtLayer;
  },


  /**
   * Returns an array of Wegue Layer objects from given config.
   *
   * @param  {Object} lConf Wegue Layer list config object
   * @return {Array} array of layer instances
   */
  createLayersFromCollection: function createLayersFromCollection(lConf, _ref) {
    var _this2 = this;

    var _ref$locale = _ref.locale,
        locale = _ref$locale === undefined ? '' : _ref$locale;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = lConf.url.replace(/\{locale\}/, locale);
              _context3.next = 3;
              return fetch(url);

            case 3:
              _context3.next = 5;
              return _context3.sent.json();

            case 5:
              response = _context3.sent;
              return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(response.map(function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(layerDef) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          return _context2.abrupt('return', _this2.getInstance(layerDef));

                        case 1:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }())));

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  }
};

/***/ }),

/***/ "Op2c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Or23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTimePicker_vue__ = __webpack_require__("bDnn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ab0d8d0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTimePicker_vue__ = __webpack_require__("DlRS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("3F8v")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ab0d8d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTimePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ab0d8d0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTimePicker_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ab0d8d0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTimePicker_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("qxrc")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ow/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadGPX_vue__ = __webpack_require__("OUY5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c8f8f8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadGPX_vue__ = __webpack_require__("R8ss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("xGdD")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59c8f8f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadGPX_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c8f8f8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadGPX_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c8f8f8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadGPX_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("Van3")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P5f+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-logo',
  data: function data() {
    return {
      logoSrc: this.$appConfig.logo,
      logoSize: this.$appConfig.logoSize,
      logoText: this.$appConfig.logoText
    };
  }
});

/***/ }),

/***/ "PBAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("5URF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00850051_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("oqg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("5F3B")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00850051_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00850051_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("3REv")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R3+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoordsTable_vue__ = __webpack_require__("L1xf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6834c7f5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__ = __webpack_require__("2Jr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("6ANF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoordsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6834c7f5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6834c7f5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R8ss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routeGeometry)?_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.clickSaveGpx}},[_c('v-icon',[_vm._v("cloud_download")]),_vm._v("\n      "+_vm._s(_vm.$t('Save as GPX file'))+".\n")],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "RAvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_source___ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_layer_Group__ = __webpack_require__("0uY1");
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-maploading-status',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__["a" /* Mapable */]],
  props: {
    color: { type: String, default: 'red darken-3' }
  },
  data: function data() {
    return {
      loading: 0,
      visible: false
    };
  },

  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     * and registers the current map layers.
     */
    onMapBound: function onMapBound() {
      var me = this;
      me.registerLayers(me.map.getLayerGroup());
    },


    /**
     * Registers the needed events for the passed layer and takes care
     * of layer groups by calling itself recursively.
     *
     * @param  {ol/layer/Base | ol/layer/Group} layer Layer or group to register
     */
    registerLayers: function registerLayers(layer) {
      var me = this;

      if (layer instanceof __WEBPACK_IMPORTED_MODULE_2_ol_layer_Group__["a" /* default */]) {
        // call ourself recursively
        var layers = layer.getLayers();
        layers.forEach(function (child) {
          me.registerLayers(child);
        });
        // handle future changes to this group or stop doing so
        layers.on('add', me.onLayerAddedToGroup, me);
        layers.on('remove', me.onLayerRemovedFromGroup, me);
      } else {
        var source = layer.getSource();
        me.bindLoadHandlers(source, true);
        // reacting on a changed source in a layer
        layer.on('change:source', function (evt) {
          me.bindLoadHandlers(evt.target.getSource(), true);
          me.bindLoadHandlers(evt.oldValue, false);
        });
      }
    },


    /**
     * Registers needed events for the passed source and takes care
     * of sources which do not naturally support load events (`vector`-sources).
     *
     * @param  {ol/source/Source} source The layer source to register
     */
    bindLoadHandlers: function bindLoadHandlers(source, register) {
      var me = this;
      var eventPrefix = '';
      var method = register ? 'on' : 'un';

      if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source___["a" /* Image */]) {
        // includes ImageWms, also e.g. ImageArcGISRest, OSM …
        eventPrefix = 'image';
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source___["b" /* TileImage */]) {
        // includes TileWMS, Bing and more
        eventPrefix = 'tile';
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source___["c" /* Vector */]) {
        if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source___["d" /* Cluster */]) {
          source = source.getSource();
        }
        eventPrefix = 'vector';
      }

      if (eventPrefix) {
        source[method](eventPrefix + 'loadstart', me.incrementLoading, me);
        source[method](eventPrefix + 'loadend', me.decrementLoading, me);
        source[method](eventPrefix + 'loaderror', me.decrementLoading, me);
      }
    },


    /**
     * Called whenever loading of a layer starts.
     * This will increment the internal counter and show this loading indicator.
     */
    incrementLoading: function incrementLoading() {
      var me = this;
      me.loading++;
      me.visible = true;
    },


    /**
     * Called whenever loading stops or errors.
     * This will decrement the internal counter and if nothing is currently
     * loading the counter is reset and the loading indicator is hidden.
     */
    decrementLoading: function decrementLoading() {
      var me = this;
      me.loading--;

      if (me.loading <= 0) {
        me.visible = false;
        me.resetLoading();
      }
    },


    /**
     * Helper method to reset the internal loading counter.
     */
    resetLoading: function resetLoading() {
      this.loading = 0;
    },


    /**
     * Takes care of added layers to any `ol/layer/Group`. These need to get
     * registered to the appropriate handlers.
     *
     * @param {ol/events/Event} evt The add event of the `ol/layer/Group`.
     */
    onLayerAddedToGroup: function onLayerAddedToGroup(evt) {
      this.registerLayers(evt.element);
    },

    /**
     * Takes care of removed layers to any `ol/layer/Group`. These need to get
     * unregistered from the appropriate handlers.
     *
     * @param {ol/events/Event} evt The remove event of the `ol/layer/Group`.
     */
    onLayerRemovedFromGroup: function onLayerRemovedFromGroup(evt) {
      this.registerLayers(evt.element);
    }
  }
});

/***/ }),

/***/ "RWxf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","dark":_vm.dark,"disabled":_vm.processing},on:{"click":_vm.click}},Object.assign({}, tooltip)),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.hoverText)))])])}
var staticRenderFns = []


/***/ }),

/***/ "RYc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.click}},Object.assign({}, tooltip)),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.hoverText)))])])}
var staticRenderFns = []


/***/ }),

/***/ "SPmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SRNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MapboxAttribution'
});

/***/ }),

/***/ "T1eq":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Share permalink":"Link zur Kartenansicht teilen","Copy Hyperlink":"Link zur Kartenansicht kopieren","Copy HTML Embed Code":"HTML-Einbettungscode kopieren","Email Hyperlink":"Link zur Kartenansicht per Email versenden","An error occurred":"Ein Fehler ist aufgetreten","Copied":"Kopiert"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "TooU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measure-type-chooser',
  props: {
    measureType: { type: String, default: 'distance' }
  },
  data: function data() {
    return {
      measureTypeData: this.measureType
    };
  },

  watch: {
    // listen to changed measurement type and forward to parent component
    measureTypeData: function measureTypeData(newVal, oldVal) {
      this.$emit('wgu-measuretype-change', newVal, oldVal);
    }
  }
});

/***/ }),

/***/ "TtH7":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Distance":"Entfernung","Area":"Fläche"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "Tvpq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U/WD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavePdfButton_vue__ = __webpack_require__("j6LV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eff3598_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavePdfButton_vue__ = __webpack_require__("RWxf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Y51g")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavePdfButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eff3598_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavePdfButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eff3598_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavePdfButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("bvBh")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UNZ/":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Search for a place":"Suche nach einem Ort"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "UZyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UdpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_Map__ = __webpack_require__("trid");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_View__ = __webpack_require__("Lfyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_control_Attribution__ = __webpack_require__("bAyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_control_Zoom__ = __webpack_require__("Lmaf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_interaction_Select__ = __webpack_require__("gsgi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_interaction__ = __webpack_require__("TDso");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_control_Rotate__ = __webpack_require__("lZ2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_proj_Projection__ = __webpack_require__("7rnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ol_proj_proj4__ = __webpack_require__("4Asb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_proj4__ = __webpack_require__("nvAS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ol_Overlay__ = __webpack_require__("kZ1N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__factory_Layer_js__ = __webpack_require__("OUzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_Color__ = __webpack_require__("nF/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PermalinkController__ = __webpack_require__("1l2W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_ol_format_GeoJSON__ = __webpack_require__("aUhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_ol_Feature__ = __webpack_require__("nq2H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_ol_geom_LineString__ = __webpack_require__("grfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_ol_style__ = __webpack_require__("beD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__routing_routingLayers__ = __webpack_require__("AFLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__geolocation_geolocationLayers__ = __webpack_require__("7NXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_ol_events_condition__ = __webpack_require__("MJuv");






//
//
//
//
//
//
//

/* eslint-disable */













// import the app-wide EventBus















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-map',
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    collapsibleAttribution: { type: Boolean, default: false },
    rotateableMap: { type: Boolean, required: false, default: false }
  },
  data: function data() {
    return {
      zoom: this.$appConfig.mapZoom,
      center: this.$appConfig.mapCenter,
      initialExtent: this.$appConfig.mapInitialExtent,
      projection: this.$appConfig.mapProjection,
      projectionObj: null,
      projectionDefs: this.$appConfig.projectionDefs,
      permalink: this.$appConfig.permalink
    };
  },
  mounted: function mounted() {
    var _this = this;

    // Make the OL map accessible for Mapable mixin even 'ol-map-mounted' has
    // already been fired. Don not use directly in cmps, use Mapable instead.
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$map = this.map;
    // Send the event 'ol-map-mounted' with the OL map as payload
    __WEBPACK_IMPORTED_MODULE_18__WguEventBus_js__["a" /* WguEventBus */].$emit('ol-map-mounted', this.map);

    // resize the map, so it fits to parent, may need to wait
    // until map container element is ready.
    var timer = setInterval(function () {
      var mapTarget = document.getElementById('ol-map-container');
      if (!mapTarget) {
        return;
      }
      clearInterval(timer);
      _this.map.setTarget(mapTarget);
      _this.map.updateSize();

      // adjust the bg color of the OL buttons (like zoom, rotate north, ...)
      _this.setOlButtonColor();

      // initialize map hover functionality
      _this.setupMapHover();
      _this.resetBounds();
    }, 100);
    __WEBPACK_IMPORTED_MODULE_18__WguEventBus_js__["a" /* WguEventBus */].$on('reset-bounds', function () {
      return _this.resetBounds();
    });
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var interactions, controls, layers;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // make map rotateable according to property
              interactions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_ol_interaction__["a" /* defaults */])({
                altShiftDragRotate: _this2.rotateableMap,
                pinchRotate: _this2.rotateableMap
              });
              controls = [new __WEBPACK_IMPORTED_MODULE_10_ol_control_Zoom__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_9_ol_control_Attribution__["a" /* default */]({
                collapsible: _this2.collapsibleAttribution
              })];
              // add a button control to reset rotation to 0, if map is rotateable

              if (_this2.rotateableMap) {
                controls.push(new __WEBPACK_IMPORTED_MODULE_13_ol_control_Rotate__["a" /* default */]());
              }

              // Optional projection (EPSG) definitions for Proj4
              if (_this2.projectionDefs) {
                // Add all (array of array)
                __WEBPACK_IMPORTED_MODULE_16_proj4__["a" /* default */].defs(_this2.projectionDefs);
                // Register with OpenLayers
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_ol_proj_proj4__["a" /* register */])(__WEBPACK_IMPORTED_MODULE_16_proj4__["a" /* default */]);
              }

              // Projection for Map, default is Web Mercator
              if (!_this2.projection) {
                _this2.projection = { code: 'EPSG:3857', units: 'm' };
              }

              _this2.map = new __WEBPACK_IMPORTED_MODULE_7_ol_Map__["a" /* default */]({
                layers: [],
                controls: controls,
                interactions: interactions,
                view: new __WEBPACK_IMPORTED_MODULE_8_ol_View__["a" /* default */]({
                  center: _this2.center,
                  zoom: _this2.zoom,
                  projection: new __WEBPACK_IMPORTED_MODULE_14_ol_proj_Projection__["a" /* default */](_this2.projection)
                })
              });

              // create layers from config and add them to map
              _context.next = 8;
              return _this2.createLayers();

            case 8:
              layers = _context.sent;

              _this2.map.getLayers().extend(layers);

              if (_this2.$appConfig.permalink) {
                _this2.permalinkController = _this2.createPermalinkController();
                _this2.map.set('permalinkcontroller', _this2.permalinkController, true);
                _this2.permalinkController.apply();
                _this2.permalinkController.setup();
              }
              window.map = _this2.map;
              _this2.map.once('rendercomplete', function () {
                return __WEBPACK_IMPORTED_MODULE_18__WguEventBus_js__["a" /* WguEventBus */].$emit('ol-map-rendered');
              });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },


  methods: {
    /**
     * Creates the OL layers due to the "mapLayers" array in app config.
     * @return {ol.layer.Base[]} Array of OL layer instances
     */
    createLayers: function createLayers() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var self, addInteraction, layers, mapLayersConfig, routingOptions, options;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = _this3;

                addInteraction = function addInteraction(layer) {
                  // if layer is selectable register a select interaction
                  if (layer.get('selectable') === false) {
                    return;
                  }
                  var selectClick = new __WEBPACK_IMPORTED_MODULE_11_ol_interaction_Select__["a" /* default */]({
                    layers: [layer],
                    style: layer.get('styleSelected') || undefined,
                    condition: function condition(e) {
                      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32_ol_events_condition__["d" /* singleClick */])(e) && !(self.cmpLookup['wgu-measuretool-win'] && self.cmpLookup['wgu-measuretool-win'].show);
                    },
                    multi: false
                  });
                  // forward an event if feature selection changes
                  selectClick.on('select', function (evt) {
                    // TODO use identifier for layer (once its implemented)
                    __WEBPACK_IMPORTED_MODULE_18__WguEventBus_js__["a" /* WguEventBus */].$emit('map-selectionchange', layer.get('lid'), evt.selected, evt.deselected);
                  });
                  // register/activate interaction on map
                  _this3.map.addInteraction(selectClick);
                };

                layers = [];
                mapLayersConfig = _this3.$appConfig.mapLayers;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(mapLayersConfig.reverse().map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(lConf) {
                    var layersToAdd;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_19__factory_Layer_js__["a" /* LayerFactory */].getInstance(lConf, { locale: _this3.$i18n.locale });

                          case 2:
                            layersToAdd = _context2.sent;

                            // One layer definition can lead to several layer instances being created
                            if (Array.isArray(layersToAdd) === false) {
                              layersToAdd = [layersToAdd];
                            }

                            // Add interactions for each Layer (but before reversing).
                            layersToAdd.forEach(function (layer) {
                              return addInteraction(layer);
                            });

                            // Reverse like main config to have Layers added in right stacking order.
                            layersToAdd = layersToAdd.reverse();
                            layers.push.apply(layers, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(layersToAdd));

                          case 7:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 6:
                routingOptions = _this3.$appConfig.modules['wgu-routing'];
                options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, routingOptions, {
                  startLabel: _this3.$t(routingOptions.startLabel || 'Start'),
                  endLabel: _this3.$t(routingOptions.endLabel || 'Finish'),
                  $t: _this3.$t.bind(_this3)
                });
                return _context3.abrupt('return', [].concat(layers, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__routing_routingLayers__["a" /* routingLayers */])(options, _this3.map)), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__geolocation_geolocationLayers__["a" /* geolocationLayers */])(_this3.$appConfig.geolocation, _this3.map))));

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    /**
     * Creates a PermalinkController, override in subclass for specializations.
     *
     * @return {PermalinkController} PermalinkController instance.
     */
    createPermalinkController: function createPermalinkController() {
      return new __WEBPACK_IMPORTED_MODULE_21__PermalinkController__["a" /* default */](this.map, this.$appConfig.permalink);
    },


    /**
     * Sets the background color of the OL buttons to the color property.
     */
    setOlButtonColor: function setOlButtonColor() {
      var me = this;

      if (__WEBPACK_IMPORTED_MODULE_20__util_Color__["a" /* default */].isCssColor(me.color)) {
        // directly apply the given CSS color
        if (document.querySelector('.ol-zoom')) {
          document.querySelector('.ol-zoom .ol-zoom-in').style.backgroundColor = me.color;
          document.querySelector('.ol-zoom .ol-zoom-out').style.backgroundColor = me.color;
        }
        if (document.querySelector('.ol-rotate')) {
          document.querySelector('.ol-rotate .ol-rotate-reset').style.backgroundColor = me.color;
        }
      } else {
        // apply vuetify color by transforming the color to the corresponding
        // CSS class (see https://vuetifyjs.com/en/framework/colors)
        var _me$color$toString$tr = me.color.toString().trim().split(' ', 2),
            _me$color$toString$tr2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_me$color$toString$tr, 2),
            colorName = _me$color$toString$tr2[0],
            colorModifier = _me$color$toString$tr2[1];

        if (document.querySelector('.ol-zoom')) {
          document.querySelector('.ol-zoom .ol-zoom-in').classList.add(colorName);
          document.querySelector('.ol-zoom .ol-zoom-in').classList.add(colorModifier);
          document.querySelector('.ol-zoom .ol-zoom-out').classList.add(colorName);
          document.querySelector('.ol-zoom .ol-zoom-out').classList.add(colorModifier);
        }
        if (document.querySelector('.ol-rotate')) {
          document.querySelector('.ol-rotate .ol-rotate-reset').classList.add(colorName);
          document.querySelector('.ol-rotate .ol-rotate-reset').classList.add(colorModifier);
        }
      }
    },

    /**
     * Initializes the map hover functionality:
     * Adds a little tooltip like DOM element, wrapped as OL Overlay to the
     * map.
     * Registers a 'pointermove' event on the map and shows the layer's
     * 'hoverAttribute' if the layer is configured as 'hoverable'
     */
    setupMapHover: function setupMapHover() {
      var map = this.map;
      var overlayEl = void 0;

      // create a span to show map tooltip
      overlayEl = document.createElement('span');
      overlayEl.classList.add('wgu-hover-tooltiptext');
      map.getTarget().append(overlayEl);

      this.overlayEl = overlayEl;

      // wrap the tooltip span in a OL overlay and add it to map
      this.overlay = new __WEBPACK_IMPORTED_MODULE_17_ol_Overlay__["a" /* default */]({
        element: overlayEl,
        autoPan: true,
        autoPanAnimation: {
          duration: 250
        }
      });
      map.addOverlay(this.overlay);

      // show tooltip if a hoverable feature gets hit with the mouse
      map.on('pointermove', this.onPointerMove, this);
    },


    /**
     * Shows the hover tooltip on the map if an appropriate feature of a
     * 'hoverable' layer was hit with the mouse.
     *
     * @param  {Object} event The OL event for pointermove
     */
    onPointerMove: function onPointerMove(event) {
      function setCursor() {
        var hit = map.hasFeatureAtPixel(event.pixel, { layerFilter: function layerFilter(l) {
            return l.get('selectable');
          } }) && !(me.cmpLookup['wgu-measuretool-win'] && me.cmpLookup['wgu-measuretool-win'].show);
        map.getViewport().style.cursor = hit ? 'pointer' : map.wguDefaultCursor || '';
      }
      var me = this;
      var map = me.map;
      var overlayEl = me.overlayEl;
      var hoverAttr = void 0;
      setCursor();

      var features = map.getFeaturesAtPixel(event.pixel, { layerFilter: function layerFilter(layer) {
          if (layer.get('hoverable')) {
            hoverAttr = layer.get('hoverAttribute');
          }
          return layer.get('hoverable');
        } });
      if (!features || features.length === 0 || !hoverAttr) {
        hoverAttr = null;
        overlayEl.innerHTML = null;
        me.overlay.setPosition(undefined);
        return;
      }
      var feature = features[0];
      var attr = feature.get(hoverAttr);
      overlayEl.innerHTML = attr;
      me.overlay.setPosition(event.coordinate);
    },
    resetBounds: function resetBounds() {
      if (this.initialExtent) {
        var extent3857 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_ol_proj__["e" /* transformExtent */])(this.initialExtent, 'EPSG:4326', 'EPSG:3857');
        this.map.getView().fit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28_ol_extent__["t" /* boundingExtent */])([extent3857.slice(0, 2), extent3857.slice(2, 4)]));
      } else {
        this.map.getView().setCenter(this.center);
        this.map.getView().setZoom(this.zoom);
      }
    }
  }
});

/***/ }),

/***/ "UkhJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpWin_vue__ = __webpack_require__("7OTJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8511bc56_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__ = __webpack_require__("CFm3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Tvpq")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8511bc56_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8511bc56_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VNHm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeocoderController__ = __webpack_require__("qbcg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_proj__ = __webpack_require__("yGLh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-geocoder-input',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__["a" /* Mapable */]],
  props: {
    buttonIcon: { type: String, required: false, default: 'search' },
    rounded: { type: Boolean, required: false, default: true },
    autofocus: { type: Boolean, required: false, default: true },
    clearable: { type: Boolean, required: false, default: true },
    dark: { type: Boolean, required: false, default: false },
    persistentHint: { type: Boolean, required: false, default: true }
  },
  data: function data() {
    return {
      placeHolder: '',
      results: [],
      lastQueryStr: '',
      noFilter: true,
      search: null,
      selecting: false,
      selected: null,
      hideSearch: true,
      timeout: null
    };
  },

  computed: {
    resultItems: function resultItems() {
      var _this = this;

      var items = [];
      if (!this.results) {
        return items;
      }
      this.trace('computed.resultItems() - cur results len=' + this.results.length);

      // Convert results to v-combobox (text, value) Items
      this.results.forEach(function (result) {
        _this.trace('add to this.items: ' + result.address.name);
        items.push({ text: result.address.name, value: result });
      });

      return items;
    }
  },
  methods: {
    trace: function trace(str) {
      this.debug && console && console.info(str);
    },
    toggle: function toggle() {
      // Show/hide search combobox
      this.hideSearch = !this.hideSearch;
    },

    // Query by string - should return list of selection items (adresses) for ComboBox
    querySelections: function querySelections(queryStr) {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        // Let Geocoder Provider do the query
        // items (item.text fields) will be shown in combobox dropdown suggestions
        _this2.trace('geocoderController.query: ' + queryStr);
        _this2.geocoderController.query(queryStr).then(function (results) {
          return _this2.onQueryResults(results);
        }).catch(function (err) {
          return _this2.onQueryError(err);
        });
      }, this.queryDelay);
    },
    onQueryResults: function onQueryResults(results) {
      // Handle query results from GeocoderController
      this.timeout && clearTimeout(this.timeout);
      this.timeout = null;
      this.results = null;

      if (!results || results.length === 0) {
        return;
      }

      // ASSERT: results is defined and at least one result
      this.trace('results ok: len=' + results.length);
      this.results = results;
    },
    onQueryError: function onQueryError(err) {
      if (err) {
        this.trace('onQueryResult error: ' + err);
      }
    }
  },
  watch: {
    // Input string value changed
    search: function search(queryStr) {
      if (this.timeout || this.selecting) {
        // Query or selection in progress
        this.trace('query or selection in progress...');
        return;
      }
      if (!queryStr || queryStr.length === 0) {
        // Query reset
        this.trace('queryStr none');
        this.results = null;
        return;
      }

      // ASSERTION: queryStr is valid
      queryStr = queryStr.trim();

      // Only query if minimal number chars typed and querystring has changed
      queryStr.length >= this.minChars && queryStr !== this.lastQueryStr && this.querySelections(queryStr);
      this.lastQueryStr = queryStr;
    },

    // User has selected entry from suggested items
    selected: function selected(item) {
      if (!item || !item.hasOwnProperty('text') || !item.hasOwnProperty('value')) {
        return;
      }
      this.selecting = true;
      this.trace('selected=' + item.text);

      // Position Map on result
      var result = item.value;
      var mapProjection = this.map.getView().getProjection();
      var coords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj__["m" /* fromLonLat */])([result.lon, result.lat], mapProjection);

      // Prefer zooming to bounding box if present in result
      if (result.hasOwnProperty('boundingbox')) {
        // Result with bounding box.
        // bbox is in EPSG:4326, needs to be transformed to Map Projection (e.g. EPSG:3758)
        var extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_extent__["a" /* applyTransform */])(result.boundingbox, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj__["h" /* getTransform */])('EPSG:4326', mapProjection));
        this.map.getView().fit(extent);
      } else {
        // No bbox in result: center on lon/lat from result and zoom in
        this.map.getView().setZoom(this.selectZoom);
      }
      this.map.getView().setCenter(coords);
      this.selecting = false;
    }
  },
  mounted: function mounted() {
    var config = this.$appConfig.modules['wgu-geocoder'] || {};
    this.debug = config.debug || false;
    this.minChars = config.minChars || 3;
    this.queryDelay = config.queryDelay || 300;
    this.selectZoom = config.selectZoom || 16;
    this.placeHolder = config.placeHolder || 'Search for an address';

    // Setup GeocoderController to which we delegate Provider and query-handling
    this.geocoderController = new __WEBPACK_IMPORTED_MODULE_1__GeocoderController__["a" /* GeocoderController */](config.provider || 'osm', config.providerOptions || {}, this);
  }
});

/***/ }),

/***/ "VP8h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DestinationSelector__ = __webpack_require__("49tN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RoutingInstructions__ = __webpack_require__("ZI5b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DateTimePicker__ = __webpack_require__("Or23");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DownloadGPX__ = __webpack_require__("Ow/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hereRoutingApi__ = __webpack_require__("rz2l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__routingUtils__ = __webpack_require__("2nff");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-routing-panel',
  directives: {},
  props: {
    right: { type: Boolean, required: false, default: false },
    width: { type: Number, required: false, default: 360 },
    height: { type: String, required: false, default: '100%' },
    icon: { type: String, required: false, default: 'directions' },
    dark: { type: Boolean, required: false, default: false },
    color: { type: String, required: false, default: 'red darken-3' },
    active: { type: Boolean, required: false, default: false },
    options: { type: Object, required: false, default: {} },
    toggleGroup: { type: String, required: false, default: undefined }
  },
  components: {
    DestinationSelector: __WEBPACK_IMPORTED_MODULE_7__DestinationSelector__["a" /* default */], // The autocomplete component with places to route to/from
    RoutingInstructions: __WEBPACK_IMPORTED_MODULE_8__RoutingInstructions__["a" /* default */], // Shows the instructions as returned by the routing API
    DateTimePicker: __WEBPACK_IMPORTED_MODULE_9__DateTimePicker__["a" /* default */], // Allows choosing departure/arrival time and optionally date, for public transit trips
    DownloadGPX: __WEBPACK_IMPORTED_MODULE_10__DownloadGPX__["a" /* default */]
  },
  data: function data() {
    return {
      moduleName: 'wgu-routing',
      drawerOpen: this.active,
      from: undefined,
      to: undefined,
      waypoints: [],
      localSuggestions: [],
      transportMode: 'transit',
      errorMessage: undefined,
      dev: location.hash.match(/dev/),
      routeGeometry: undefined,
      stopsGeometry: undefined,
      boundingBox: undefined,
      route: undefined,
      timeDate: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loadLocalSuggestions();
              window.RoutingPanel = _this;
              __WEBPACK_IMPORTED_MODULE_6__WguEventBus_js__["a" /* WguEventBus */].$on('toggle-routing-panel', function (state) {
                _this.drawerOpen = state === undefined ? !_this.drawerOpen : state;
              });
              __WEBPACK_IMPORTED_MODULE_6__WguEventBus_js__["a" /* WguEventBus */].$on('directions-to-feature', function (feature) {
                _this.drawerOpen = true;
                if (_this.toggleGroup) {
                  __WEBPACK_IMPORTED_MODULE_6__WguEventBus_js__["a" /* WguEventBus */].$emit(_this.toggleGroup, { moduleName: _this.moduleName, state: _this.drawerOpen });
                }
                _this.$refs.toSelector.setTargetById(feature.get('id'));
              });

              // When member of toggle group: close if any other panel active
              if (_this.toggleGroup) {
                __WEBPACK_IMPORTED_MODULE_6__WguEventBus_js__["a" /* WguEventBus */].$on(_this.toggleGroup, function (_ref) {
                  var moduleName = _ref.moduleName,
                      state = _ref.state;

                  _this.drawerOpen = moduleName === _this.moduleName && state;
                });
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    transportModes: function transportModes() {
      var _this2 = this;

      // transportOptions is an array of strings which are treated as regexes: 'car' matches car-fast or car-short
      var matchesOptions = function matchesOptions(value) {
        return (_this2.options.transportModes || []).find(function (modeTest) {
          return value.match(modeTest);
        });
      };
      return [{
        text: this.$t('Car (fastest)'),
        value: 'car-fast'
      }, {
        text: this.$t('Car (shortest distance)'),
        value: 'car-short'
      }, {
        text: this.$t('Public transport (new)'),
        value: 'transit'
      }, {
        text: this.$t('Heide-Shuttle Connections'),
        value: 'bus'
      }, {
        text: this.$t('Public transport (old)'),
        value: 'fastest;publicTransport'
      }, {
        text: this.$t('Bicycle (fastest)'),
        value: 'fastest;bicycle'
      }, {
        text: this.$t('Bicycle (shortest distance)'),
        value: 'shortest;bicycle'
      }, {
        text: this.$t('Pedestrian'),
        value: 'shortest;pedestrian'
      }].filter(function (_ref2) {
        var value = _ref2.value;
        return matchesOptions(value);
      });
    },

    // when anything changes that was used to calculate the route, we clear the route
    routeParameters: function routeParameters() {
      return [this.from, this.to, this.waypoints.map(function (w) {
        return w && w.geometry.coordinates;
      }), this.transportMode, this.timeDate.timeMode, this.timeDate.time, Date.now()];
    },
    waypointsGeometry: function waypointsGeometry() {
      return this.waypoints.filter(function (w) {
        return w && w.geometry && w.geometry.coordinates;
      });
    },
    allGeometry: function allGeometry() {
      return [this.from && this.from.geometry.coordinates, this.waypoints.map(function (w) {
        return w && w.geometry.coordinates;
      }), this.to && this.to.geometry.coordinates, this.routeGeometry];
    },
    responseTransportMode: function responseTransportMode() {
      if (!this.route || !this.route.mode || !this.route.mode.transportModes) {
        return this.transportMode.match(/^car/) ? 'Driving' : 'Public transport';
      } else {
        return {
          'transit': 'Public transport',
          'publicTransport': 'Public transport',
          'publicTransportTimeTable': 'Public transport',
          'bicycle': 'Bicycle',
          'pedestrian': 'Walking'
        }[this.route.mode.transportModes[0]];
      }
    },
    boundingBoxForStops: function boundingBoxForStops() {
      var bbox = void 0;
      var stops = [this.from && this.from.geometry.coordinates].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.waypoints.map(function (w) {
        return w && w.geometry.coordinates;
      })), [this.to && this.to.geometry.coordinates]);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(stops), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stop = _step.value;

          if (stop) {
            bbox = bbox || [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(stop), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(stop));
            bbox[0] = Math.min(bbox[0], stop[0]);
            bbox[1] = Math.min(bbox[1], stop[1]);
            bbox[2] = Math.max(bbox[2], stop[0]);
            bbox[3] = Math.max(bbox[3], stop[1]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return bbox;
    }
  },
  watch: {
    routeParameters: function routeParameters() {
      this.route = undefined;
      this.routeGeometry = undefined;
      this.stopsGeometry = undefined;
      this.boundingBox = undefined;
    },
    allGeometry: function allGeometry() {
      __WEBPACK_IMPORTED_MODULE_6__WguEventBus_js__["a" /* WguEventBus */].$emit('route-update', {
        routeGeometry: this.routeGeometry,
        startGeometry: this.from && this.from.geometry.coordinates ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__routingUtils__["a" /* point */])(this.from.geometry.coordinates) : undefined,
        waypointsGeometry: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__routingUtils__["b" /* featureCollection */])(this.waypointsGeometry),
        endGeometry: this.to && this.to.geometry.coordinates ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__routingUtils__["a" /* point */])(this.to.geometry.coordinates) : undefined,
        stopsGeometry: this.stopsGeometry,
        boundingBox: this.boundingBox || this.boundingBoxForStops
      });
    },
    route: function route() {
      if (this.route) {
        this.$nextTick(function () {
          return document.getElementById('route').scrollIntoView({ behavior: 'smooth' });
        });
      } else {
        this.routeGeometry = undefined;
      }
    },
    drawerOpen: function drawerOpen() {
      // I'm undecided whether the panel should reset when it opens. There isn't another good way to clear it.
      // OTOH, it could take a while to set up all the parameters they want for the search, then they lose it all
      // because they temporarily went to the layers panel.
      // this.$refs.fromSelector.target = undefined;
      // this.showDirectionsControls = false;
    }
  },
  methods: {
    loadLocalSuggestions: function loadLocalSuggestions() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-rendered', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var layerUrls, featureCollections, localSuggestions, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref4, data;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Find layers that have been marked 'routable' in app config, and use them as routing targets
                layerUrls = _this3.$map.getLayers().getArray().filter(function (l) {
                  return l.getProperties().routable;
                }).map(function (l) {
                  return l.getSource().getUrl();
                });
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(layerUrls.map(__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get));

              case 3:
                featureCollections = _context2.sent;
                localSuggestions = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 8;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(featureCollections); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _ref4 = _step2.value;
                  data = _ref4.data;

                  localSuggestions.push.apply(localSuggestions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(data.features.map(function (poi) {
                    return { text: poi.properties.name, value: poi, source: 'local' };
                  })));
                }
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](8);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 16:
                _context2.prev = 16;
                _context2.prev = 17;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 19:
                _context2.prev = 19;

                if (!_didIteratorError2) {
                  _context2.next = 22;
                  break;
                }

                throw _iteratorError2;

              case 22:
                return _context2.finish(19);

              case 23:
                return _context2.finish(16);

              case 24:
                localSuggestions.sort(function (a, b) {
                  return a.text < b.text ? -1 : 1;
                });
                _this3.localSuggestions = localSuggestions;

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[8, 12, 16, 24], [17,, 19, 23]]);
      })));
    },
    toChange: function toChange(newTo) {
      this.to = newTo;
    },
    search: function search() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.errorMessage = undefined;
                _this4.route = undefined;

                if (!_this4.transportMode.match(/^car|transit|bus/)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt('return', _this4.getRouteV8());

              case 6:
                return _context3.abrupt('return', _this4.getRouteV7());

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    getRouteV8: function getRouteV8() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__hereRoutingApi__["a" /* getRouteV8 */])({
                  from: _this5.from,
                  waypoints: _this5.waypoints,
                  to: _this5.to,
                  transportMode: _this5.transportMode,
                  timeDate: _this5.timeDate,
                  locale: _this5.$i18n.locale,
                  extraAttributes: _this5.options.modeAttributes && _this5.options.modeAttributes[_this5.transportMode]
                });

              case 2:
                response = _context4.sent;

                if (response !== 'No route found.') {
                  _this5.route = response.route;
                  _this5.routeGeometry = response.routeGeometry;
                  _this5.stopsGeometry = response.stopsGeometry;
                } else {
                  _this5.errorMessage = _this5.$t('No route found. Please try other options.');
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    getRouteV7: function getRouteV7() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__hereRoutingApi__["b" /* getRouteV7 */])({
                  from: _this6.from,
                  waypoints: _this6.waypoints,
                  to: _this6.to,
                  transportMode: _this6.transportMode,
                  timeDate: _this6.timeDate,
                  locale: _this6.$i18n.locale,
                  extraAttributes: _this6.options.modeAttributes && _this6.options.modeAttributes[_this6.transportMode]
                });

              case 2:
                response = _context5.sent;


                if (response.errorMessage) {
                  _this6.errorMessage = response.errorMessage;
                } else {
                  _this6.route = response.route;
                  _this6.boundingBox = response.boundingBox;
                  _this6.routeGeometry = response.routeGeometry;
                  _this6.stopsGeometry = response.stopsGeometry;
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },

    closePanel: function closePanel() {
      if (this.drawerOpen === false) {
        // Already closed
        return;
      }
      this.drawerOpen = false;
      __WEBPACK_IMPORTED_MODULE_6__WguEventBus_js__["a" /* WguEventBus */].$emit('close-direction-menu', this.drawerOpen);
    }
  }
});

/***/ }),

/***/ "VPG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.route)?_c('div',{staticClass:"px-2",attrs:{"id":"route"}},[_vm._l(((_vm.sections)),function(section,sectionNo){return _c('div',{key:sectionNo},[(sectionNo === 0)?_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.transportModeTitle + ' directions')))]):_vm._e(),_vm._v(" "),(_vm.transportModeTitle === 'Driving')?[(_vm.route.sections.length > 1)?_c('h3',[_vm._v("\n        "+_vm._s(((_vm.$t('Section')) + " " + (sectionNo + 1)))+" ("+_vm._s(Math.round((section.summary || section.travelSummary).length/100)/10)+" "+_vm._s(_vm.$t('km'))+")\n      ")]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"route-summary"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Duration'))+":")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.routeDuration(sectionNo)))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Distance'))+":")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.routeDistance(sectionNo)))])])])]:_vm._e(),_vm._v(" "),(_vm.transportModeTitle === 'Public transport' && sectionNo === 0)?[_c('table',{staticClass:"route-summary"},[(_vm.sectionStartTime(sectionNo))?_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Departure'))+":")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.routeDepTime(_vm.sections)))])]):_vm._e(),_vm._v(" "),(_vm.sectionStartTime(sectionNo))?_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.$t('Arrival'))+":")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.routeArrTime(_vm.sections)))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.$t('Duration'))+":")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.calculateRouteDuration(_vm.sections)))])])])]:_vm._e(),_vm._v(" "),(_vm.transportModeTitle === 'Public transport')?[(!section.actions)?_c('div',{staticClass:"actions"},[(section.type === 'pedestrian')?_c('table',[_c('tr',[_c('td',{staticClass:"time"},[_vm._v(_vm._s(section.departure.time.slice(11, 16)))]),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.$t('WalkTo', { destination: section.arrival.place.name, minutes: Math.round(section.travelSummary.duration / 120), metres: section.travelSummary.length.toLocaleString()} ))}}),_vm._v(" "),_c('td',{staticClass:"changeId"},[_c('span',[_vm._v(_vm._s(sectionNo))])])])]):_vm._e(),_vm._v(" "),(section.type === 'transit')?_c('table',[_c('tr',[_c('td',{staticClass:"time"},[_vm._v(_vm._s(_vm.$t('depart'))+" "+_vm._s(section.departure.time.slice(11, 16))),_c('br'),_vm._v(" "+_vm._s(_vm.$t('arrive'))+" "+_vm._s(section.arrival.time.slice(11, 16)))]),_vm._v(" "),(section.type === 'transit')?_c('td',{domProps:{"innerHTML":_vm._s(_vm.$t('TakeVehicleTo', { name: section.transport.name, transportHeadsign: section.transportHeadsign, transportTailsign: section.arrival.place.name }))}}):_vm._e(),_vm._v(" "),_c('td',{staticClass:"changeId"},[_c('span',[_vm._v(_vm._s(sectionNo))])])])]):_vm._e()]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('table',_vm._l((section.actions),function(action,actionNo){return _c('tr',{key:actionNo},[_c('td',{staticClass:"time"},[_vm._v(" "+_vm._s(_vm.actionStartTime(sectionNo, actionNo))+" ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(action.instruction))]),_vm._v(" "),(sectionNo !== 0 && actionNo === 0)?_c('td',{staticClass:"changeId"},[_c('span',[_vm._v(_vm._s(sectionNo))])]):_vm._e()])}),0)])],2)}),_vm._v(" "),(_vm.routeLegs)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.transportModeTitle + ' directions')))]),_vm._v(" "),_c('table',{staticClass:"route-summary"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Duration'))+":")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.routeDuration()))])]),_vm._v(" "),(_vm.routeStartTime)?_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Start'))+":")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.routeStartDate && _vm.routeStartDate + ' at ')+" "+_vm._s(_vm.routeStartTime))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Distance'))+":")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.routeDistance()))])]),_vm._v(" "),(_vm.route.publicTransportLine)?_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('Routes'))+":")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.route.publicTransportLine.map(function (l) { return l.lineName; }).join(',  ')))])]):_vm._e()]),_vm._v(" "),_vm._l((_vm.routeLegs),function(leg){return _c('div',[_c('table',{staticClass:"maneuvers"},_vm._l((leg.maneuver),function(maneuver){return _c('tr',[(_vm.isScheduled && maneuver.time)?_c('td',{staticClass:"time"},[_vm._v(" "+_vm._s(maneuver.time.slice(11, 19))+" ")]):_vm._e(),_vm._v(" "),(!_vm.isScheduled && maneuver.cumulative)?_c('td',{staticClass:"time"},[_vm._v(" "+_vm._s(maneuver.cumulative)+" ")]):_vm._e(),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(maneuver.instruction)}},[_vm._v(_vm._s(maneuver.instruction))]),_vm._v(" "),(_vm.hasChangeIds)?_c('td',{staticClass:"changeId"},[(maneuver.changeId !== undefined)?_c('span',[_vm._v(_vm._s(maneuver.changeId))]):_vm._e()]):_vm._e()])}),0)])})],2):_vm._e()],2):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "VT4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_interaction_Draw__ = __webpack_require__("aUJj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_Observable_js__ = __webpack_require__("nxYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_style_Style__ = __webpack_require__("Mjwz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_style_Stroke__ = __webpack_require__("00zS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_style_Circle__ = __webpack_require__("uli1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_style_Fill__ = __webpack_require__("lUmj");












/**
 * Class holding the OpenLayers related logic for the measure tool.
 */

var OlMeasureController = function () {
  function OlMeasureController(olMap, measureConf) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OlMeasureController);

    this.map = null;

    this.map = olMap;
    this.measureConf = measureConf || {};
  }

  /**
   * Creates a vector layer for the measurement results and adds it to the
   * map.
   */

  /* the OL map we want to measure on */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(OlMeasureController, [{
    key: 'createMeasureLayer',
    value: function createMeasureLayer() {
      var me = this;
      var measureConf = me.measureConf;
      // create a vector layer to
      var source = new __WEBPACK_IMPORTED_MODULE_4_ol_source_Vector__["a" /* default */]();
      var vector = new __WEBPACK_IMPORTED_MODULE_5_ol_layer_Vector__["a" /* default */]({
        name: 'Measure Layer',
        displayInLayerList: false,
        source: source,
        style: new __WEBPACK_IMPORTED_MODULE_6_ol_style_Style__["a" /* default */]({
          fill: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Fill__["a" /* default */]({
            color: measureConf.fillColor || 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new __WEBPACK_IMPORTED_MODULE_7_ol_style_Stroke__["a" /* default */]({
            color: measureConf.strokeColor || 'rgba(0, 0, 0, 0.5)',
            width: 2
          })
        })
      });

      me.map.addLayer(vector);

      // make vector source available as member
      me.source = source;
    }

    /**
     * Creates and adds the necessary draw interaction and adds it to the map.
     */

  }, {
    key: 'addInteraction',
    value: function addInteraction(measureType, mapClickCb) {
      var me = this;
      var measureConf = me.measureConf;
      // cleanup possible old draw interaction
      if (me.draw) {
        me.removeInteraction();
      }

      var type = measureType === 'area' ? 'Polygon' : 'LineString';
      var draw = new __WEBPACK_IMPORTED_MODULE_2_ol_interaction_Draw__["a" /* default */]({
        source: me.source,
        type: type,
        style: new __WEBPACK_IMPORTED_MODULE_6_ol_style_Style__["a" /* default */]({
          fill: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Fill__["a" /* default */]({
            color: measureConf.sketchFillColor || 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new __WEBPACK_IMPORTED_MODULE_7_ol_style_Stroke__["a" /* default */]({
            color: measureConf.sketchStrokeColor || 'rgba(0, 0, 0, 0.5)',
            lineDash: [10, 10],
            width: 2
          }),
          image: new __WEBPACK_IMPORTED_MODULE_8_ol_style_Circle__["a" /* default */]({
            radius: 5,
            stroke: new __WEBPACK_IMPORTED_MODULE_7_ol_style_Stroke__["a" /* default */]({
              color: measureConf.sketchVertexStrokeColor || 'rgba(0, 0, 0, 0.7)'
            }),
            fill: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Fill__["a" /* default */]({
              color: measureConf.sketchVertexFillColor || 'rgba(255, 255, 255, 0.2)'
            })
          })
        })
      });
      me.map.addInteraction(draw);

      var listener;
      var sketch;
      draw.on('drawstart', function (evt) {
        // clear old measure features
        me.source.clear();
        // preserve sketch
        sketch = evt.feature;

        listener = me.map.on('click', function (evt) {
          var geom = sketch.getGeometry();
          // execute given callback
          mapClickCb(geom);
        });
      }, me);

      draw.on('drawend', function () {
        // unset sketch
        sketch = null;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_Observable_js__["b" /* unByKey */])(listener);
      }, me);

      // make draw interaction available as member
      me.draw = draw;
    }

    /**
     * Removes the current interaction and clears the values.
     */

  }, {
    key: 'removeInteraction',
    value: function removeInteraction() {
      var me = this;
      if (me.draw) {
        me.map.removeInteraction(me.draw);
      }
      if (me.source) {
        me.source.clear();
      }
    }
  }]);

  return OlMeasureController;
}();

/* harmony default export */ __webpack_exports__["a"] = (OlMeasureController);

/***/ }),

/***/ "Van3":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Save as GPX file":"Als GPX-Datei speichern"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "W0OM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListPanel_vue__ = __webpack_require__("J8V5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f2a4fa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListPanel_vue__ = __webpack_require__("m3TE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fqsr")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f2a4fa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListPanel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f2a4fa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListPanel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("3j7A")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WFjz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mapable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__ = __webpack_require__("ZkkH");


/**
 * Mixin, which binds the OL map to the target component.
 * Executes the onMapBound function of the target component, if available.
 */
var Mapable = {
  created: function created() {
    var _this = this;

    // if the OL map is not present in the vue prototype we have to wait until
    // it is mounted. Otherwise apply OL map as member var.
    if (!this.$map) {
      // apply OL map once OL map is mounted
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
        // make the OL map accessible in this component
        _this.map = olMap;

        if (_this.onMapBound) {
          _this.onMapBound();
        }
      });
    } else {
      // OL map is already mounted --> directly apply as member
      this.map = this.$map;
      if (this.onMapBound) {
        this.onMapBound();
      }
    }
  }
};

/***/ }),

/***/ "WaAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelpWin__ = __webpack_require__("UkhJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-helpwin-btn',
  components: {
    'wgu-helpwin': __WEBPACK_IMPORTED_MODULE_0__HelpWin__["a" /* default */]
  },
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    icon: { type: String, required: false, default: 'help' },
    text: { type: String, required: false },
    dark: { type: Boolean, required: false, default: false },
    headline: { type: String, required: false },
    content: { type: String, required: false },
    infoLink: { type: String, required: false },
    infoLinkText: { type: String, required: false }
  },
  data: function data() {
    return {
      show: false
    };
  }
});

/***/ }),

/***/ "Y51g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YX3o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"300","hide-overlay":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":_vm.dark},slot:"activator"},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")],1),_vm._v(" "),_c('wgu-helpwin',{ref:"helpwin",attrs:{"color":_vm.color,"icon":_vm.icon,"title":_vm.text,"headline":_vm.headline,"content":_vm.content,"infoLink":_vm.infoLink,"infoLinkText":_vm.infoLinkText},on:{"winxclose":function($event){_vm.show=false}}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "ZI5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingInstructions_vue__ = __webpack_require__("iMa3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e247c2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingInstructions_vue__ = __webpack_require__("VPG7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("mhME")
  __webpack_require__("k+L9")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18e247c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingInstructions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e247c2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingInstructions_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e247c2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingInstructions_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("BHAw")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZKPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenStreetMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

/**
 * OpenStreetMap Nominatim Provider. See https://nominatim.openstreetmap.org.
 *
 * @class OpenStreetMap
 */
var OpenStreetMap = function () {
  /**
   * @constructor
   */
  function OpenStreetMap() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OpenStreetMap);

    this.settings = {
      url: 'https://nominatim.openstreetmap.org/search/',
      params: {
        q: '',
        format: 'json',
        addressdetails: 1,
        limit: 10,
        countrycodes: '',
        'accept-language': 'en-US'
      }
    };
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OpenStreetMap, [{
    key: 'getParameters',
    value: function getParameters(opt) {
      return {
        url: this.settings.url,
        params: {
          q: opt.query,
          format: this.settings.params.format,
          addressdetails: this.settings.params.addressdetails,
          limit: opt.limit || this.settings.params.limit,
          countrycodes: opt.countrycodes || this.settings.params.countrycodes,
          'accept-language': opt.lang || this.settings.params['accept-language']
        }
      };
    }
  }, {
    key: 'handleResponse',
    value: function handleResponse(results) {
      if (!results || results.length === 0) {
        return;
      }
      return results.map(function (result) {
        result = {
          lon: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(result.lon),
          lat: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(result.lat),
          boundingbox: result.boundingbox.map(function (x) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(x);
          }),
          address: {
            name: result.display_name,
            road: result.address.road || '',
            houseNumber: result.address.house_number || '',
            postcode: result.address.postcode || '',
            city: result.address.city || result.address.town || '',
            state: result.address.state || '',
            country: result.address.country || ''
          },
          original: {
            formatted: result.display_name,
            details: result.address
          }
        };
        // Make bbox llx,lly,urx,ury
        var bbox = result.boundingbox;
        result.boundingbox = [bbox[2], bbox[0], bbox[3], bbox[1]];
        return result;
      });
    }
  }]);

  return OpenStreetMap;
}();

/***/ }),

/***/ "ZY9t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyTable_vue__ = __webpack_require__("v4OI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564685d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__ = __webpack_require__("vPiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("FO/s")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564685d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564685d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZfcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__("kJWX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a0adb81_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__("CrNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("B0ph")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a0adb81_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a0adb81_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("cEem")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZkkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WguEventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");



// Vue instance acting as app-wide event-bus
var WguEventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "aAia":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Get directions":"Ort suchen / Route berechnen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "aQLT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aTZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-share-btn',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__["a" /* Mapable */]],
  props: {
    icon: { type: String, required: false, default: 'share' },
    text: { type: String, required: false, default: '' },
    hoverText: { type: String, required: false, default: 'Share permalink' },
    alertTimeMillis: { type: Number, required: false, default: 1000 },
    alertCopiedText: { type: String, required: false, default: 'Copied' },
    alertErrorText: { type: String, required: false, default: 'An error occurred' },
    dark: { type: Boolean, required: false, default: false },
    copyUrlText: { type: String, required: false, default: 'Copy Hyperlink' },
    copyEmbedHtmlText: { type: String, required: false, default: 'Copy HTML Embed Code' },
    emailUrlText: { type: String, required: false, default: 'Email Hyperlink' },
    emailSubjectText: { type: String, required: false, default: 'Naturpark Lüneburger Heide: Link zur Karte' }
  },
  data: function data() {
    return {
      alert: false,
      alertText: this.alertCopiedText,
      mailToUrl: this.emailUrlText
    };
  },
  mounted: function mounted() {
    var _this = this;

    // Listen to the ol-map-mounted event and receive the OL map instance
    __WEBPACK_IMPORTED_MODULE_1__WguEventBus__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
      // Listen to map state changes (pan, zoom)
      _this.map.on('moveend', function () {
        _this.onMapChange();
      });
    });
  },

  methods: {
    showAlert: function showAlert(text) {
      var _this2 = this;

      // Show short alert
      this.alertText = text || this.alertCopiedText;
      this.alert = true;
      window.setTimeout(function () {
        _this2.alert = false;
      }, this.alertTimeMillis);
    },
    copyToClipboard: function copyToClipboard(text) {
      var textArea = this.$refs.textstore;
      // Show and select  textarea
      textArea.style.display = 'block';
      textArea.value = text;
      textArea.select();

      // Copy to clipboard
      document.execCommand('copy');

      // Hide textarea
      textArea.value = '';
      textArea.style.display = 'none';
    },
    onCopyUrl: function onCopyUrl() {
      // Get permalink URL and copy to clipboard
      try {
        // Copy to clipboard: selected text needs to be visible so
        // toggle textarea short time
        var permalinkController = this.map.get('permalinkcontroller');
        this.copyToClipboard(permalinkController.getShareUrl());
        this.showAlert();
      } catch (error) {
        this.showAlert(this.alertErrorText);
      }
    },
    onCopyEmbedHTML: function onCopyEmbedHTML() {
      // Get permalink URL and copy to clipboard
      try {
        var permalinkController = this.map.get('permalinkcontroller');
        this.copyToClipboard(permalinkController.getEmbedHTML());
        this.showAlert();
      } catch (error) {
        this.showAlert(this.alertErrorText);
      }
    },

    setMailtoUrl: function setMailtoUrl() {
      // if (!this.map) {
      //   return 'Waiting for Map...';
      // }
      // https://css-tricks.com/snippets/html/mailto-links/
      // Get permalink URL and add to email Body
      try {
        var permalinkController = this.map.get('permalinkcontroller');
        var url = encodeURIComponent(permalinkController.getShareUrl());
        this.mailToUrl = 'mailto:?subject=' + this.emailSubjectText + '&body=' + url;
      } catch (error) {
        this.showAlert(this.alertErrorText);
      }
    },
    /**
     * Callback when Map View has changed, e.g. 'moveend'.
     */
    onMapChange: function onMapChange() {
      this.setMailtoUrl();
    }
  }
});

/***/ }),

/***/ "acV0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "azNP":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"LENGTH":"LÄNGE","AREA":"FLÄCHE"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "bDnn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routingUtils__ = __webpack_require__("2nff");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      timeMode: 'departure',
      rawDate: undefined,
      time: null,
      menu: false,
      dateMenu: false
    };
  },
  mounted: function mounted() {
    var today = new Date();
    var hours = today.getHours() <= 10 ? '0' + today.getHours() : today.getHours();
    var minutes = today.getMinutes() <= 10 ? '0' + today.getMinutes() : today.getMinutes();
    this.time = hours + ':' + minutes;
  },

  computed: {
    timeModes: function timeModes() {
      return [{ text: this.$t('Arrive by'), value: 'arrival' }, { text: this.$t('Depart at'), value: 'departure' }];
    },
    selectedDate: function selectedDate() {
      return this.formatDate(this.date);
    },
    date: function date() {
      if (!this.isDateSpecified) {
        var now = new Date();
        var todayDate = now.getFullYear() + '-' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__routingUtils__["c" /* pad2 */])(now.getMonth() + 1) + '-' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__routingUtils__["c" /* pad2 */])(now.getDate());
        return todayDate;
      }
      return this.rawDate;
    },
    isDateSpecified: function isDateSpecified() {
      return this.rawDate;
    },
    isTimeValid: function isTimeValid() {
      return !(this.hour !== undefined && this.minute === undefined);
    },
    anything: function anything() {
      return [this.timeMode, this.time, this.date, this.isDateSpecified, this.isTimeValid];
    }
  },
  watch: {
    anything: function anything() {
      console.log(this.date, this.isTimeValid, this.isDateSpecified, 'timetime');
      this.$emit('change', {
        timeMode: this.timeMode,
        time: this.time,
        date: this.date,
        isDateSpecified: this.isDateSpecified,
        isTimeValid: this.isTimeValid
      });
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '.' + month + '.' + year;
    }
  }
});

/***/ }),

/***/ "bSi1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bTWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


/* eslint-disable */
//https://raw.githubusercontent.com/heremaps/flexible-polyline/master/javascript/index.js
// not published on npm yet?
/*
 * Copyright (C) 2019 HERE Europe B.V.
 * Licensed under MIT, see full license in LICENSE
 * SPDX-License-Identifier: MIT
 * License-Filename: LICENSE
 */
var DEFAULT_PRECISION = 5;

var ENCODING_TABLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

var DECODING_TABLE = [62, -1, -1, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, 63, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51];

var FORMAT_VERSION = 1;

var ABSENT = 0;
var LEVEL = 1;
var ALTITUDE = 2;
var ELEVATION = 3;
// Reserved values 4 and 5 should not be selectable
var CUSTOM1 = 6;
var CUSTOM2 = 7;

var Num = typeof BigInt !== "undefined" ? BigInt : Number;

function decode(encoded) {
    var decoder = decodeUnsignedValues(encoded);
    var header = decodeHeader(decoder[0], decoder[1]);

    var factorDegree = Math.pow(10, header.precision);
    var factorZ = Math.pow(10, header.thirdDimPrecision);
    var thirdDim = header.thirdDim;


    var lastLat = 0;
    var lastLng = 0;
    var lastZ = 0;
    var res = [];

    var i = 2;
    for (; i < decoder.length;) {
        var deltaLat = toSigned(decoder[i]) / factorDegree;
        var deltaLng = toSigned(decoder[i + 1]) / factorDegree;
        lastLat += deltaLat;
        lastLng += deltaLng;

        if (thirdDim) {
            var deltaZ = toSigned(decoder[i + 2]) / factorZ;
            lastZ += deltaZ;
            res.push([lastLat, lastLng, lastZ]);
            i += 3;
        } else {
            res.push([lastLat, lastLng]);
            i += 2;
        }
    }

    if (i !== decoder.length) {
        throw new Error('Invalid encoding. Premature ending reached');
    }

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, header, {
        polyline: res
    });
}

function decodeChar(char) {
    var charCode = char.charCodeAt(0);
    return DECODING_TABLE[charCode - 45];
}

function decodeUnsignedValues(encoded) {
    var result = Num(0);
    var shift = Num(0);
    var resList = [];

    encoded.split('').forEach(function (char) {
        var value = Num(decodeChar(char));
        result |= (value & Num(0x1F)) << shift;
        if ((value & Num(0x20)) === Num(0)) {
            resList.push(result);
            result = Num(0);
            shift = Num(0);
        } else {
            shift += Num(5);
        }
    });

    if (shift > 0) {
        throw new Error('Invalid encoding');
    }

    return resList;
}

function decodeHeader(version, encodedHeader) {
    if (+version.toString() !== FORMAT_VERSION) {
        throw new Error('Invalid format version');
    }
    var headerNumber = +encodedHeader.toString();
    var precision = headerNumber & 15;
    var thirdDim = headerNumber >> 4 & 7;
    var thirdDimPrecision = headerNumber >> 7 & 15;
    return { precision: precision, thirdDim: thirdDim, thirdDimPrecision: thirdDimPrecision };
}

function toSigned(val) {
    // Decode the sign from an unsigned value
    var res = val;
    if (res & Num(1)) {
        res = ~res;
    }
    res >>= Num(1);
    return +res.toString();
}

function encode(_ref) {
    var _ref$precision = _ref.precision,
        precision = _ref$precision === undefined ? DEFAULT_PRECISION : _ref$precision,
        _ref$thirdDim = _ref.thirdDim,
        thirdDim = _ref$thirdDim === undefined ? ABSENT : _ref$thirdDim,
        _ref$thirdDimPrecisio = _ref.thirdDimPrecision,
        thirdDimPrecision = _ref$thirdDimPrecisio === undefined ? 0 : _ref$thirdDimPrecisio,
        polyline = _ref.polyline;

    // Encode a sequence of lat,lng or lat,lng(,{third_dim}). Note that values should be of type BigNumber
    //   `precision`: how many decimal digits of precision to store the latitude and longitude.
    //   `third_dim`: type of the third dimension if present in the input.
    //   `third_dim_precision`: how many decimal digits of precision to store the third dimension.

    var multiplierDegree = Math.pow(10, precision);
    var multiplierZ = Math.pow(10, thirdDimPrecision);
    var encodedHeaderList = encodeHeader(precision, thirdDim, thirdDimPrecision);
    var encodedCoords = [];

    var lastLat = Num(0);
    var lastLng = Num(0);
    var lastZ = Num(0);
    polyline.forEach(function (location) {
        var lat = Num(Math.round(location[0] * multiplierDegree));
        encodedCoords.push(encodeScaledValue(lat - lastLat));
        lastLat = lat;

        var lng = Num(Math.round(location[1] * multiplierDegree));
        encodedCoords.push(encodeScaledValue(lng - lastLng));
        lastLng = lng;

        if (thirdDim) {
            var z = Num(Math.round(location[2] * multiplierZ));
            encodedCoords.push(encodeScaledValue(z - lastZ));
            lastZ = z;
        }
    });

    return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(encodedHeaderList), encodedCoords).join('');
}

function encodeHeader(precision, thirdDim, thirdDimPrecision) {
    // Encode the `precision`, `third_dim` and `third_dim_precision` into one encoded char
    if (precision < 0 || precision > 15) {
        throw new Error('precision out of range. Should be between 0 and 15');
    }
    if (thirdDimPrecision < 0 || thirdDimPrecision > 15) {
        throw new Error('thirdDimPrecision out of range. Should be between 0 and 15');
    }
    if (thirdDim < 0 || thirdDim > 7 || thirdDim === 4 || thirdDim === 5) {
        throw new Error('thirdDim should be between 0, 1, 2, 3, 6 or 7');
    }

    var res = thirdDimPrecision << 7 | thirdDim << 4 | precision;
    return encodeUnsignedNumber(FORMAT_VERSION) + encodeUnsignedNumber(res);
}

function encodeUnsignedNumber(val) {
    // Uses variable integer encoding to encode an unsigned integer. Returns the encoded string.
    var res = '';
    var numVal = Num(val);
    while (numVal > 0x1F) {
        var pos = numVal & Num(0x1F) | Num(0x20);
        res += ENCODING_TABLE[pos];
        numVal >>= Num(5);
    }
    return res + ENCODING_TABLE[numVal];
}

function encodeScaledValue(value) {
    // Transform a integer `value` into a variable length sequence of characters.
    //   `appender` is a callable where the produced chars will land to
    var numVal = Num(value);
    var negative = numVal < 0;
    numVal <<= Num(1);
    if (negative) {
        numVal = ~numVal;
    }

    return encodeUnsignedNumber(numVal);
}

// module.exports = {
//     encode,
//     decode,

//     ABSENT,
//     LEVEL,
//     ALTITUDE,
//     ELEVATION,
// };
/* harmony default export */ __webpack_exports__["a"] = ({
    encode: encode,
    decode: decode,

    ABSENT: ABSENT,
    LEVEL: LEVEL,
    ALTITUDE: ALTITUDE,
    ELEVATION: ELEVATION
});

/***/ }),

/***/ "bmfb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card',{directives:[{name:"draggable-win",rawName:"v-draggable-win",value:(_vm.draggable),expression:"draggable"}],staticClass:"wgu-infoclick-win",style:({ left: _vm.left, top: _vm.top })},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{on:{"click":function($event){_vm.show = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"wgu-infoclick-win-title",attrs:{"primary-title":""}},[(!this.attributeData && !this.coordsData)?_c('div',{staticClass:"no-data"},[_vm._v("\n      "+_vm._s(_vm.$t('Click on the map to get information for the clicked map position.'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('wgu-property-table',{attrs:{"properties":_vm.attributeData,"color":_vm.color}}),_vm._v(" "),_c('wgu-coords-table',{attrs:{"coordsData":_vm.coordsData,"color":_vm.color}})],1)],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "bvBh":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Save as PDF":"Als PDF speichern"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "c0QU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguAppTemplate_vue__ = __webpack_require__("04/i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad765cf_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__ = __webpack_require__("1gMf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguAppTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad765cf_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad765cf_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cEem":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":null}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "cUGT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"wgu-feature-info-panel",staticStyle:{"overflow":"hidden"},attrs:{"value":_vm.drawerOpen,"dark":_vm.dark,"right":_vm.right,"width":_vm.width,"height":_vm.height,"hide-overlay":"","disable-resize-watcher":"","disable-route-watcher":"","absolute":"","stateless":""},model:{value:(_vm.drawerOpen),callback:function ($$v) {_vm.drawerOpen=$$v},expression:"drawerOpen"}},[(_vm.feature)?_c('v-card',{directives:[{name:"draggable-win",rawName:"v-draggable-win",value:(_vm.draggable),expression:"draggable"}],staticClass:"wgu-feature-info-card info-card",staticStyle:{"overflow-y":"scroll","height":"100%"},attrs:{"elevation":"0"}},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":_vm.dark}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{on:{"click":_vm.closePanel}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.attributes[_vm.imageProp])?_c('v-img',{staticStyle:{"margin":"10px auto 0 auto"},attrs:{"src":_vm.attributes[_vm.imageProp],"width":_vm.imageWidth,"height":_vm.imageHeight}}):_vm._e(),_vm._v(" "),(_vm.attributes[_vm.titleProp])?_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.attributes[_vm.titleProp]))])]):_vm._e(),_vm._v(" "),(_vm.attributes[_vm.descProp])?_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._v(" "),_c('v-card-actions',[(_vm.attributes[_vm.infoUrlProp])?_c('v-btn',{attrs:{"flat":"","color":"blue","href":_vm.attributes[_vm.infoUrlProp],"target":"_blank"}},[_vm._v(_vm._s(_vm.infoUrlText))]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.feature.getGeometry().getType() === 'Point')?_c('v-fab-transition',[_c('v-tooltip',{attrs:{"top":"","color":"pink"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({staticClass:"v-btn--example pa-4",staticStyle:{"bottom":"100px","left":"280px"},attrs:{"color":"pink","fab":"","small":"","dark":""},on:{"click":_vm.clickDirections}},tooltip),[_c('v-icon',[_vm._v(_vm._s(_vm.directionIcon))])],1)]}}],null,false,201669050)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Get directions')))])])],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "cUvf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cspx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureResult_vue__ = __webpack_require__("F+zM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cd0378_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__ = __webpack_require__("vDSi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("0zZl")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cd0378_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cd0378_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("azNP")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dgnq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingPanel_vue__ = __webpack_require__("VP8h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_473caec3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingPanel_vue__ = __webpack_require__("eu9W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("4a9O")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_473caec3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingPanel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_473caec3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingPanel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("itIQ")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eTap":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eu9W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"unset-height",class:{'hide-drawer': _vm.drawerOpen === false},staticStyle:{"z-index":"3","box-shadow":"unset"},attrs:{"value":_vm.drawerOpen,"dark":_vm.dark,"width":"350","hide-overlay":"","disable-resize-watcher":"","disable-route-watcher":"","absolute":"","stateless":"","height":"unset","right":_vm.right,"temporary":""},model:{value:(_vm.drawerOpen),callback:function ($$v) {_vm.drawerOpen=$$v},expression:"drawerOpen"}},[_c('v-card',{staticClass:"pb-2"},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":_vm.dark}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.$t('Get directions')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{on:{"click":_vm.closePanel}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"overflow":"auto","height":"calc(100vh - 165px)"}},[_c('v-form',[_c('v-select',{staticClass:"mt-4 px-2",attrs:{"items":_vm.transportModes,"label":_vm.$t('Mode'),"box":"","prepend-icon":"mode_of_travel"},model:{value:(_vm.transportMode),callback:function ($$v) {_vm.transportMode=$$v},expression:"transportMode"}}),_vm._v(" "),_c('DestinationSelector',{ref:"fromSelector",attrs:{"label":_vm.$t('from'),"localSuggestions":_vm.localSuggestions},on:{"change":function($event){_vm.from = $event}}}),_vm._v(" "),_vm._l((_vm.waypoints),function(waypoint,i){return _c('DestinationSelector',{key:i,ref:("way" + i + "selector"),refInFor:true,attrs:{"label":"via","localSuggestions":_vm.localSuggestions},on:{"change":function($event){return _vm.$set(_vm.waypoints, i, $event)}}})}),_vm._v(" "),(_vm.from && _vm.to && (_vm.waypoints.length === 0 || _vm.waypoints.length <= 8 && _vm.waypoints.slice(-1)[0]))?_c('v-btn',{staticClass:"d-block mx-auto mb-4 mt-0",attrs:{"color":"primary","outline":"","flat":""},on:{"click":function($event){return _vm.waypoints.push(undefined)}}},[_vm._v("\n        "+_vm._s(_vm.$t('Add stop'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.waypoints.length)?_c('v-btn',{staticClass:"d-block mx-auto mb-4 mt-0",attrs:{"color":"primary","outline":"","flat":""},on:{"click":function($event){return _vm.waypoints.splice(-1)}}},[_vm._v(_vm._s(_vm.$t('Remove stop')))]):_vm._e(),_vm._v(" "),_c('DestinationSelector',{ref:"toSelector",attrs:{"label":_vm.$t('to'),"localSuggestions":_vm.localSuggestions},on:{"change":_vm.toChange}}),_vm._v(" "),(_vm.transportMode.match(/fastest;publicTransport|transit|bus/))?_c('div',[_c('DateTimePicker',{on:{"change":function($event){_vm.timeDate=$event}}})],1):_vm._e(),_vm._v(" "),_c('v-container',{attrs:{"justify-center":"true"}},[(_vm.from && _vm.to && !(_vm.timeDate.time && _vm.timeDate.timeIsInvalid))?_c('v-btn',{staticClass:"d-block mx-auto ",attrs:{"color":"primary"},on:{"click":_vm.search}},[_vm._v("\n          "+_vm._s(_vm.$t('Get directions'))+"\n        ")]):_vm._e()],1),_vm._v(" "),_c('v-alert',{staticClass:"ma-3",attrs:{"value":_vm.errorMessage,"outline":"","type":"error"}},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.errorMessage))+"\n      ")]),_vm._v(" "),_c('DownloadGPX',{attrs:{"routeGeometry":_vm.routeGeometry,"transportMode":_vm.transportMode}}),_vm._v(" "),(_vm.route)?_c('RoutingInstructions',{attrs:{"route":_vm.route,"dateSpecified":_vm.timeDate.isDateSpecified,"transportModeTitle":_vm.responseTransportMode}}):_vm._e()],2)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "f54h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenCage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

/**
 * OpenCage Provider, needs key. See https://opencagedata.com.
 *
 * @class OpenCage
 *
 */
var OpenCage = function () {
  /**
   * @constructor
   */
  function OpenCage() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OpenCage);

    this.settings = {
      url: 'https://api.opencagedata.com/geocode/v1/json?',
      params: {
        q: '',
        key: '',
        limit: 10,
        countrycodes: '',
        language: 'en-US',
        pretty: 1,
        no_annotations: 1
      }
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(OpenCage, [{
    key: 'getParameters',
    value: function getParameters(options) {
      return {
        url: this.settings.url,
        params: {
          q: options.query,
          key: options.key,
          limit: options.limit || this.settings.params.limit,
          countrycode: options.countrycodes || this.settings.params.countrycodes,
          language: options.language || this.settings.params.language
        }
      };
    }
  }, {
    key: 'handleResponse',
    value: function handleResponse(results) {
      if (!results.results || results.results.length === 0) {
        return;
      }
      return results.results.map(function (result) {
        return {
          lon: result.geometry.lng,
          lat: result.geometry.lat,
          boundingbox: result.bounds && [result.bounds.southwest.lng, result.bounds.southwest.lat, result.bounds.northeast.lng, result.bounds.northeast.lat],
          address: {
            name: result.formatted,
            road: result.components.road || '',
            houseNumber: result.components.house_number || '',
            postcode: result.components.postcode || '',
            city: result.components.city || result.components.town || '',
            state: result.components.state || '',
            country: result.components.country || ''
          },
          original: {
            formatted: result.formatted,
            details: result.components
          }
        };
      });
    }
  }]);

  return OpenCage;
}();

/***/ }),

/***/ "fIFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Util class for OL layers
 */
var LayerUtil = {
  /**
   * Returns a set of map layers which matches the given key value pair.
   *
   * @param {String} key - Key to filter layers
   * @param {Object} value - Value to filter layers
   * @param  {ol.Map} olMap  The OL map to search in
   * @return {ol.layer.Base[]} Array of matching layers
   */
  getLayersBy: function getLayersBy(key, value, olMap) {
    if (!olMap) {
      console.warn('No OL map passed to LayerUtil.getLayersBy - ' + 'no layer detection possible!');
      return [];
    }

    var layerMatches = [];
    olMap.getLayers().forEach(function (layer) {
      if (layer.get(key) === value) {
        layerMatches.push(layer);
      }
    });

    return layerMatches;
  },


  /**
   * Returns a map layer with the given LID (Layer ID)
   *
   * @param  {String} lid    The LID of the layer to query
   * @param  {ol.Map} olMap  The OL map to search in
   * @return {ol.layer.Base} The OL layer instance or undefined
   */
  getLayerByLid: function getLayerByLid(lid, olMap) {
    return LayerUtil.getLayersBy('lid', lid, olMap)[0];
  },


  /**
   * Zooms to the given layer's extent.
   * Will only work if the layer has kind of vector source.
   *
   * @param  {ol.layer.Base} vecLayer OL vector layer
   * @param  {ol.Map} olMap           The map to perform the zoom on
   */
  zoomToLayerExtent: function zoomToLayerExtent(vecLayer, olMap) {
    if (!vecLayer || !vecLayer.getSource().getExtent || !olMap) {
      return;
    }
    var extent = vecLayer.getSource().getExtent();
    olMap.getView().fit(extent);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (LayerUtil);

/***/ }),

/***/ "fT5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OlStyleFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_style__ = __webpack_require__("beD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_geom_Point__ = __webpack_require__("T18w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__markerPin__ = __webpack_require__("MGEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__splitLineString__ = __webpack_require__("Kz2t");








/**
 * Factory, which creates OpenLayers style instances according to a given config
 * object.
 * This only covers a minimal subset of the OpenLayers style capabilities.
 * It allows to create simple styles for points, line and polygons.
 * For advanced styling use a custom style function or
 * GeoStyler<https://github.com/terrestris/geostyler>
 */
var OlStyleFactory = {

  /**
   * Returns an OpenLayers Style instance due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL Style instance
   */
  getInstance: function getInstance(styleConf) {
    if (!styleConf) {
      return;
    } else if (styleConf.radius || styleConf.iconUrl) {
      return OlStyleFactory.createPointStyle(styleConf);
    } else if (styleConf.fillColor) {
      return OlStyleFactory.createPolygonStyle(styleConf);
    } else if (styleConf.strokeColor || styleConf.strokeWidth) {
      return OlStyleFactory.createLineStyle(styleConf);
    }
  },


  /**
   * Returns an OpenLayers style instance for point due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createPointStyle: function createPointStyle(styleConf) {
    var pointStyle = void 0;
    if (styleConf.iconUrl && styleConf.iconPlacement !== 'line') {
      // create a customised marker pin with the icon in it.
      var _ref = styleConf.iconAnchor || [0.5, 0.5],
          _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          anchorX = _ref2[0],
          anchorY = _ref2[1];

      var svgImage = new Image();
      svgImage.src = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__markerPin__["a" /* pinSvg */])({ strokeColor: styleConf.color || 'blue' });
      var outer = new __WEBPACK_IMPORTED_MODULE_3_ol_style__["b" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_3_ol_style__["a" /* Icon */]({
          img: svgImage,
          imgSize: [32, 32],
          anchor: [anchorX, anchorY - 0.2],
          anchorXUnits: styleConf.iconAnchorXUnits,
          anchorYUnits: styleConf.iconAnchorYUnits,
          crossOrigin: 'Anonymous'
        })
      });
      var inner = new __WEBPACK_IMPORTED_MODULE_3_ol_style__["b" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_3_ol_style__["a" /* Icon */]({
          src: styleConf.iconUrl,
          scale: styleConf.scale || 1,
          anchor: styleConf.iconAnchor,
          anchorXUnits: styleConf.iconAnchorXUnits,
          anchorYUnits: styleConf.iconAnchorYUnits,
          crossOrigin: 'Anonymous'
        })
      });
      pointStyle = [outer, inner];
    } else {
      pointStyle = new __WEBPACK_IMPORTED_MODULE_3_ol_style__["b" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_3_ol_style__["g" /* Circle */]({
          radius: styleConf.radius,
          fill: OlStyleFactory.createFill(styleConf),
          stroke: OlStyleFactory.createStroke(styleConf)
        })
      });
    }

    return pointStyle;
  },


  /**
   * Returns an OpenLayers style instance for lines due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createLineStyle: function createLineStyle(styleConf) {
    var lineStyle = new __WEBPACK_IMPORTED_MODULE_3_ol_style__["b" /* Style */]({
      stroke: OlStyleFactory.createStroke(styleConf)
    });
    if (styleConf.iconPlacement === 'line' || styleConf.arrowColor /* to be removed */) {
        var compositeStyle = OlStyleFactory.createLineSymbols(styleConf, lineStyle);

        // we add the getStroke function so that it behaves more like a regular line, for LayerList etc.
        compositeStyle.getStroke = function () {
          return lineStyle.getStroke();
        };
        return compositeStyle;
      } else {
      return lineStyle;
    }
  },


  /**
   * Returns an OpenLayers style instance for polygons due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createPolygonStyle: function createPolygonStyle(styleConf) {
    var olStyle = new __WEBPACK_IMPORTED_MODULE_3_ol_style__["b" /* Style */]({ stroke: OlStyleFactory.createStroke(styleConf) }); // OlStyleFactory.createLineStyle(styleConf);
    olStyle.setFill(OlStyleFactory.createFill(styleConf));

    return olStyle;
  },
  createLineSymbols: function createLineSymbols() {
    var styleConf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var lineStyle = arguments[1];

    return function (feature, resolution) {
      var iconSpacing = styleConf.iconSpacing || 64;

      // can be used to only calculate icons within current area
      // const mapSize = window.map.getSize();
      // const extent = window.map.getView().calculateExtent([mapSize[0] + iconSpacing * 2, mapSize[1] + iconSpacing * 2]);

      var geometry = feature.getGeometry();
      var lineStrings = geometry.getType() === 'MultiLineString' ? geometry.getLineStrings() : [geometry];
      var splitPoints = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lineStrings), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lineString = _step.value;

          splitPoints.push.apply(splitPoints, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__splitLineString__["a" /* splitLineString */])(lineString, iconSpacing * resolution)));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return [lineStyle].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(splitPoints.map(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 3),
            x = _ref4[0],
            y = _ref4[1],
            rotation = _ref4[2];

        return new __WEBPACK_IMPORTED_MODULE_3_ol_style__["b" /* Style */]({
          geometry: new __WEBPACK_IMPORTED_MODULE_4_ol_geom_Point__["a" /* default */]([x, y]),
          image: new __WEBPACK_IMPORTED_MODULE_3_ol_style__["a" /* Icon */]({
            src: styleConf.iconUrl || 'static/icon/arrow-up-thin-64.png',
            scale: styleConf.scale || 0.15,
            // for some reason opacity has no effect?
            rotation: styleConf.iconRotate === false ? 0 : rotation,
            crossOrigin: 'Anonymous'
          })
        });
      })));
    };
  },


  /**
   * Creates an OL Stroke object due to given config.
   *
   * @param  {Object} styleConf Style config object
   * @return {Stroke}           OL Stroke instance
   */
  createStroke: function createStroke(styleConf) {
    var lineStyle = new __WEBPACK_IMPORTED_MODULE_3_ol_style__["e" /* Stroke */]({
      color: styleConf.strokeColor,
      width: styleConf.strokeWidth,
      lineDash: styleConf.strokeLineDash,
      lineDashOffset: styleConf.strokeLineDashOffset,
      lineCap: styleConf.strokeLineCap,
      lineJoin: styleConf.strokeLineJoin
    });
    return lineStyle;
  },


  /**
   * Creates an OL Fill object due to given config.
   *
   * @param  {Object} styleConf Style config object
   * @return {Fill}             OL Fill instance
   */
  createFill: function createFill(styleConf) {
    return new __WEBPACK_IMPORTED_MODULE_3_ol_style__["d" /* Fill */]({
      color: styleConf.fillColor
    });
  }
};

/***/ }),

/***/ "fo1/":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Start":"Anfang","Finish":"Ziel"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "fqsr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g1uR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gEbC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"mapbox-wordmark",attrs:{"href":"http://mapbox.com/about/maps","target":"_blank"}},[_vm._v("Mapbox")])}
var staticRenderFns = []


/***/ }),

/***/ "gxed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layerlist_ToggleButton__ = __webpack_require__("PBAA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_helpwin_ToggleButton__ = __webpack_require__("1SaT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_measuretool_ToggleButton__ = __webpack_require__("uwYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_infoclick_ToggleButton__ = __webpack_require__("NkLf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_sharebutton_ShareButton__ = __webpack_require__("iS5T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_components_maxextentbutton_ZoomToMaxExtentButton__ = __webpack_require__("qqRY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_components_routing_RoutingToggleButton__ = __webpack_require__("mU5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_components_downloadlayers_DownloadLayersButton__ = __webpack_require__("Es/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_components_language_LanguageSelector__ = __webpack_require__("GKWk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_components_savepdf_SavePdfButton__ = __webpack_require__("U/WD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_components_geocoder_Geocoder__ = __webpack_require__("kyCG");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-header',
  components: {
    'wgu-share-btn': __WEBPACK_IMPORTED_MODULE_7__src_components_sharebutton_ShareButton__["a" /* default */],
    'wgu-geocoder-btn': __WEBPACK_IMPORTED_MODULE_13__src_components_geocoder_Geocoder__["a" /* default */],
    'wgu-zoomtomaxextent-btn': __WEBPACK_IMPORTED_MODULE_8__src_components_maxextentbutton_ZoomToMaxExtentButton__["a" /* default */],
    'wgu-layerlist-btn': __WEBPACK_IMPORTED_MODULE_3__layerlist_ToggleButton__["a" /* default */],
    'wgu-helpwin-btn': __WEBPACK_IMPORTED_MODULE_4__src_components_helpwin_ToggleButton__["a" /* default */],
    'wgu-measuretool-btn': __WEBPACK_IMPORTED_MODULE_5__src_components_measuretool_ToggleButton__["a" /* default */],
    'wgu-infoclick-btn': __WEBPACK_IMPORTED_MODULE_6__src_components_infoclick_ToggleButton__["a" /* default */],
    'wgu-language-btn': __WEBPACK_IMPORTED_MODULE_11__src_components_language_LanguageSelector__["a" /* default */],
    'wgu-routing-btn': __WEBPACK_IMPORTED_MODULE_9__src_components_routing_RoutingToggleButton__["a" /* default */],
    'wgu-savepdf-btn': __WEBPACK_IMPORTED_MODULE_12__src_components_savepdf_SavePdfButton__["a" /* default */],
    'wgu-downloadlayers-btn': __WEBPACK_IMPORTED_MODULE_10__src_components_downloadlayers_DownloadLayersButton__["a" /* default */]
  },
  props: {
    color: { type: String, required: false, default: 'red darken-3' }
  },
  data: function data() {
    return {
      menuCloseOnContentClick: this.noSubMenus(),
      title: this.$appConfig.title,
      menuButtons: this.getModuleButtonData() || [],
      tbButtons: this.getToolbarButtons() || [],
      subMenus: false
    };
  },

  methods: {
    smallScreen: function smallScreen() {
      return window.innerWidth < 800;
    },
    noSubMenus: function noSubMenus() {
      return this.subMenus === false;
    },

    /**
     * Determines the module menu button configuration objects from app-config:
     *    menuButtons: [
     *      {type: 'wgu-layerlist-toggle-btn'},
     *      {type: 'wgu-helpwin-toggle-btn'},
     *      {type: 'wgu-measuretool-toggle-btn'}
     *    ]
     * @return {Array} module button configuration objects for the menu
     */
    getModuleButtonData: function getModuleButtonData() {
      var appConfig = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig || {};
      var modulesConfs = appConfig.modules || {};
      var moduleButtons = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(modulesConfs)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var moduleOpts = appConfig.modules[key];
          // Remember if any of the Butoons has an in-place sub-menu/dropdown.
          if (moduleOpts.hasSubMenu === true) {
            this.subMenus = true;
          }
          if (moduleOpts.target === 'menu' || moduleOpts.mobileTarget === 'menu' && this.smallScreen() === true) {
            moduleButtons.push({
              type: key + '-btn',
              target: moduleOpts.target,
              dark: moduleOpts.darkLayout,
              active: moduleOpts.mobileActive !== undefined && window.innerWidth <= 800 ? moduleOpts.mobileActive : moduleOpts.active,
              toggleGroup: moduleOpts.toggleGroup
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return moduleButtons;
    },

    /**
     * Determines the module toolbar button configuration objects from app-config:
     *    menuButtons: [
     *      {type: 'wgu-layerlist-toggle-btn'},
     *      {type: 'wgu-helpwin-toggle-btn'},
     *      {type: 'wgu-measuretool-toggle-btn'}
     *    ]
     * @return {Array} module button configuration objects for the toolbar
     */
    getToolbarButtons: function getToolbarButtons() {
      var appConfig = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig || {};
      var modulesConfs = appConfig.modules || {};
      var moduleButtons = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(modulesConfs)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          var moduleOpts = appConfig.modules[key];
          if (moduleOpts.target === 'toolbar' && !(moduleOpts.mobileTarget === 'menu' && this.smallScreen() === true)) {
            moduleButtons.push({
              type: key + '-btn',
              target: moduleOpts.target,
              dark: moduleOpts.darkLayout,
              active: moduleOpts.mobileActive !== undefined && window.innerWidth <= 800 ? moduleOpts.mobileActive : moduleOpts.active,
              toggleGroup: moduleOpts.toggleGroup
            });
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return moduleButtons;
    }
  }
});

/***/ }),

/***/ "h0fj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_util_Layer__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_WguEventBus__ = __webpack_require__("ZkkH");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__src_mixins_Mapable__["a" /* Mapable */]],
  props: {
    dark: { type: Boolean, required: false, default: false },
    sliderColor: { type: String, required: false, default: 'grey' },
    categoriesTitle: { type: String, required: false, default: 'Categories' },
    tagsTitle: { type: String, required: false, default: 'Tags' },
    hideCategories: { type: Boolean, required: false, default: false },
    hideTags: { type: Boolean, required: false, default: false }
  },
  data: function data() {
    return {
      categoryItems: [],
      tagItems: [],
      unfoldCategories: [],
      unfoldTags: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a()
    };
  },

  computed: {
    categoriesTree: function categoriesTree() {
      return this.categoryItems;
    },
    tagsTree: function tagsTree() {
      return this.tagItems;
    },
    tabs: function tabs() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.hideTags ? [] : [{ title: this.tagsTitle, items: this.tagsTree, loadFunc: this.fetchTagItems, unfolded: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.unfoldTags)) }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.hideCategories ? [] : [{ title: this.categoriesTitle, items: this.categoriesTree, loadFunc: this.fetchCategoryItems, unfolded: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.unfoldCategories)) }]));
    }
  },
  methods: {
    /**
     * Executed after the map is bound (see mixins/Mapable)
     */
    onMapBound: function onMapBound() {
      var _this = this;

      // Only render LayerList when Map fully rendered
      __WEBPACK_IMPORTED_MODULE_4__src_WguEventBus__["a" /* WguEventBus */].$on('ol-map-rendered', function (evt) {
        _this.createLayerItems();
        // React on added / removed layers
        _this.map.getLayers().on('change:length', function (evt) {
          _this.createLayerItems();
        });

        // React on changed Locale
        __WEBPACK_IMPORTED_MODULE_4__src_WguEventBus__["a" /* WguEventBus */].$on('locale-changed', function (language) {
          _this.$i18n.locale = language;
          _this.createLayerItems();
        });
      });
    },

    /**
     * Creates single layer (tree) item from an OpenLayers Layer.
     */
    createLayerItem: function createLayerItem(layer, childId) {
      var layerId = layer.get('lid');
      var layerCategory = layerId.split('_')[0];
      var layerStyle = layer.getStyle();
      var icon = void 0; // , lineColor, fillColor;
      if (layerCategory === 'poi') {
        if (Array.isArray(layerStyle)) {
          layerStyle = layerStyle[1];
        }
        icon = layerStyle.getImage().getSrc();
      }
      return {
        id: childId,
        name: layer.get('name'),
        lid: layerId,
        category: layerCategory,
        tags: layer.get('tags'),
        icon: icon,
        stroke: layerStyle.getStroke && layerStyle.getStroke(),
        fill: layerStyle.getFill && layerStyle.getFill(),
        visible: layer.getVisible()
      };
    },

    /**
     * Creates the layer items from the OpenLayers map.
     */
    createLayerItems: function createLayerItems() {
      var _this2 = this;

      // Get applicable layers: displayInLayerList enabled and Vector Layers
      var layers = this.map.getLayers().getArray().slice(0).reverse().filter(function (l) {
        return l.get('displayInLayerList') !== false && l.getSource().getFeatures;
      });

      var nodeId = 0;
      function nextId() {
        return ++nodeId;
      }

      // Predefined Categories TODO make smarter
      var categoryItems = ['POIs', 'Routes', 'Areas'].map(function (category) {
        return {
          id: nextId(),
          name: _this2.$i18n.t(category),
          lid: undefined,
          visible: false,
          children: []
        };
      });
      var getCategoryNode = function getCategoryNode(type) {
        return categoryItems[{ route: 1, area: 2 }[type] || 0];
      };
      // Tag defs come from the tags added to Layers
      var tagItems = [];
      this.unfoldTags = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      this.unfoldCategories = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      layers.forEach(function (layer, idx) {
        var layerItem = _this2.createLayerItem(layer, nextId());

        // First add to Categories tree
        var categoryNode = getCategoryNode(layerItem.category);
        categoryNode.children.push(layerItem);
        if (layerItem['visible'] === true) {
          _this2.unfoldCategories.add(categoryNode['id']);
        }

        var tags = layerItem.tags || [_this2.$t('_untagged')];
        // One or more Tags avail: add to the Tags tree
        // Must be existing layer item: reuse for common visibility state
        tags.forEach(function (tag, idx) {
          var tagNode = tagItems.find(function (tagItem) {
            return tagItem.name === tag;
          });
          if (!tagNode) {
            // Create new tag parent node and push to tree
            tagNode = {
              id: nextId(),
              name: tag,
              lid: undefined,
              visible: false,
              children: []
            };
            tagItems.push(tagNode);
          }
          // Add LayerItem to TagNode
          tagNode.children.push(layerItem);
          if (layerItem['visible'] === true) {
            _this2.unfoldTags.add(tagNode['id']);
          }
        });
      });

      this.categoryItems = categoryItems;
      this.tagItems = tagItems;
    },
    fetchCategoryItems: function fetchCategoryItems() {
      return this.categoryItems;
    },
    fetchTagItems: function fetchTagItems() {
      return this.tagItems;
    },


    /**
     * Handles the 'change' event of the visibility checkboxes in order to
     * apply the current visibility state in 'data' to the OL layers, recursive.
     */
    onItemChanged: function onItemChanged(item) {
      var _this3 = this;

      if (!item.children) {
        // Child node clicked or changed via parent
        var layer = __WEBPACK_IMPORTED_MODULE_3__src_util_Layer__["a" /* default */].getLayerByLid(item.lid, this.map);
        if (layer) {
          layer.setVisible(item.visible);
        }
        return;
      }
      // Parent node clicked
      item.children.forEach(function (child, idx) {
        child.visible = item.visible;
        _this3.onItemChanged(child);
      });
    }
  }
});

/***/ }),

/***/ "i8bC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("UdpQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c82cf2a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("CCtF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("/Y57")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c82cf2a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c82cf2a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("fo1/")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iMa3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_duration__ = __webpack_require__("Xpx/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_duration__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function pad2(x) {
  return ('0' + x).slice(-2);
}
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['route', 'dateSpecified', 'transportModeTitle'],
  data: function data() {
    return {};
  },
  name: 'RoutingInstructions',
  mounted: function mounted() {
    window.RoutingInstructions = this;
  },

  computed: {
    routeStartDate: function routeStartDate() {
      if (!this.dateSpecified) {
        return '';
      }

      if (this.route && this.route.sections && this.route.sections[0] && this.route.sections[0].departure && this.route.sections[0].departure.time) {
        // public transit routes from v8 don't include an overall departure date and date-flag every section even if it's today.
        var startDate = new Date(this.route.sections[0].departure.time).toISOString().slice(0, 10);
        var now = new Date().toISOString().slice(0, 10);
        if (startDate !== now) {
          return startDate;
        } else {
          return '';
        }
      }
      if (!this.route || !this.route.summary.departure) {
        return '';
      }
      var date = new Date(this.route.summary.departure.slice(0, 10));
      return pad2(date.getDate() + 1) + '.' + pad2(date.getMonth() + 1) + '.' + date.getFullYear();
    },
    routeStartTime: function routeStartTime() {
      return this.route && this.route.summary.departure && this.route.summary.departure.slice(11, 19);
    },
    routeLegs: function routeLegs() {
      return this.route && this.route.leg;
    },
    hasChangeIds: function hasChangeIds() {
      return this.route && this.routeLegs.find(function (l) {
        return l.maneuver.find(function (m) {
          return m.changeId;
        });
      });
    },
    isScheduled: function isScheduled() {
      return this.route.mode && this.route.mode.transportModes[0] === 'publicTransportTimeTable';
    },
    sections: function sections() {
      if (!this.route.sections) {
        return [];
      }
      var sections = this.route.sections;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(sections), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var section = _step.value;

          if (section.arrival && section.arrival.place && section.arrival.place.name) {
            section.arrivalName = section.arrival.place.name.replace(/ \|.*/, '').replace(/\\:/, ':');
          }
          if (section.transport && section.transport.headsign) {
            section.transportHeadsign = section.transport.headsign.replace(/ \|.*/, '').replace(/\\:/, ':');
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return sections;
    }
  },
  methods: {
    routeDuration: function routeDuration(sectionNo) {
      return this.route && __WEBPACK_IMPORTED_MODULE_1_humanize_duration___default()(this.routeSummary(sectionNo).baseTime * 1000, { round: true, units: ['h', 'm'], language: this.$i18n.locale });
    },
    calculateRouteDuration: function calculateRouteDuration(sections) {
      var timeStart = new Date();
      var timeEnd = new Date();
      var firstTime = sections[0].departure.time.slice(11, 16).split(':');
      var lastTime = sections[sections.length - 1].departure.time.slice(11, 16).split(':');
      timeStart.setHours(firstTime[0], firstTime[1], 0);
      timeEnd.setHours(lastTime[0], lastTime[1], 0);
      var date = new Date(timeEnd - timeStart);
      var hours = ((timeEnd - timeStart) / (1000 * 60 * 60)).toFixed(1);
      console.log('' + date.getMinutes(), parseInt(hours));
      return parseInt(hours) + ' ' + this.$t('Hour(s)') + ', ' + ('' + date.getMinutes()) + ' ' + this.$t('Minute(s)');
    },
    routeDepTime: function routeDepTime(sections) {
      var firstTime = sections[0].departure.time.slice(11, 16);
      return firstTime;
    },
    routeArrTime: function routeArrTime(sections) {
      var lastTime = sections[sections.length - 1].departure.time.slice(11, 16);
      return lastTime;
    },
    routeDistance: function routeDistance(sectionNo) {
      return this.route && Math.round(this.routeSummary(sectionNo).distance * 10 / 1000) / 10 + ' ' + this.$t('km');
    },
    routeSummary: function routeSummary(sectionNo) {
      if (this.route && this.route.summary) {
        return this.route.summary;
      } else {
        var section = this.route.sections[sectionNo];
        return {
          baseTime: (section.summary || section.travelSummary).duration,
          distance: (section.summary || section.travelSummary).length
        };
      }
    },
    sectionStartTime: function sectionStartTime(sectionNo) {
      var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var end = short ? 16 : 19;
      return this.sections[sectionNo] && this.sections[sectionNo].arrival && this.sections[sectionNo].arrival.time.slice(11, end);
    },
    sectionArivalTime: function sectionArivalTime(sectionNo) {
      var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var end = short ? 16 : 19;
      return this.sections[sectionNo] && this.sections[sectionNo].arrival && this.sections[sectionNo].arrival.time.slice(11, end);
    },
    actionStartTime: function actionStartTime(sectionNo, actionNo) {
      // pedestrian steps in transit directions don't have directly encoded timestamps
      // new Date(new Date('2020-10-12T07:24:00Z').getTime() + 1035000).toISOString()
      var section = this.sections[sectionNo];
      // times are in local time. It's easiest just to pretend they're in UTC since Date can't give us non-UTC strings.
      var cumulative = new Date(section.departure.time.replace('+01:00', 'Z')).getTime();
      for (var precedingActionNo = 0; precedingActionNo < actionNo; precedingActionNo++) {
        cumulative += section.actions[precedingActionNo].duration;
      }
      return new Date(cumulative).toISOString().match(/\d\d:\d\d/)[0];
      // .replace(\
      // .replace(/\.\d\d\dZ$/, '')
    }
  }
});

/***/ }),

/***/ "iS5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareButton_vue__ = __webpack_require__("aTZJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50397a2a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareButton_vue__ = __webpack_require__("/mee");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("yi+M")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50397a2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50397a2a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50397a2a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("T1eq")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ijS0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureInfoPanel_vue__ = __webpack_require__("zFcG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0530602_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeatureInfoPanel_vue__ = __webpack_require__("cUGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("cUvf")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureInfoPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0530602_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeatureInfoPanel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0530602_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeatureInfoPanel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("0t1S")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "irkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MeasureWin__ = __webpack_require__("lgWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measuretool-btn',
  components: {
    'wgu-measuretool-win': __WEBPACK_IMPORTED_MODULE_1__MeasureWin__["a" /* default */]
  },
  props: {
    icon: { type: String, required: false, default: 'photo_size_select_small' },
    text: { type: String, required: false },
    dark: { type: Boolean, required: false, default: false }
  },
  data: function data() {
    return {
      moduleName: 'wgu-measuretool'
    };
  },
  created: function created() {
    var me = this;
    // TODO move to a father class
    __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$on('app-mounted', function () {
      me.win = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.cmpLookup[me.moduleName + '-win'];
    });
  },

  methods: {
    toggleUi: function toggleUi() {
      // TODO move to a father class
      this.win.show = !this.win.show;
    }
  }
});

/***/ }),

/***/ "itIQ":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Get directions":"Route berechnen","Public transport (new)":"Öffentliche Verkehrsmittel","Heide-Shuttle Connections":"Heide-Shuttle","Bicycle (fastest)":"Fahrrad (schnellste Route)","Bicycle (shortest distance)":"Fahrrad (kürzeste Route)","Pedestrian":"Fußgänger","Car (shortest distance)":"Auto (kürzeste Route)","Car (fastest)":"Auto (schnellste Route)","Mode":"Verkehrsmittel","from":"von","to":"nach","via":"über","Remove stop":"Zwischenstop entfernen","Add stop":"Zwischenstop hinzufügen","Sorry, you can specify a time, or multiple waypoints, but not both.":"Leider können Sie eine Zeit oder mehrere Wegpunkte angeben, aber nicht beides.","Sorry, directions are currently unavailable.":"Eine Wegbeschreibung ist derzeit leider nicht verfügbar.","No route found. Please try other options.":"Es wurde keine Route gefunden. Bitte versuchen Sie es mit anderen Einstellungen.","Find place":"Ort suchen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "j6LV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__("l9mu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-savepdf-btn',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__["a" /* Mapable */]],
  props: {
    dark: { type: Boolean, required: false, default: false },
    icon: { type: String, required: false, default: 'picture_as_pdf' },
    hoverText: { type: String, required: false, default: 'Save as PDF' }
  },
  data: function data() {
    return {
      processing: undefined
    };
  },
  methods: {
    click: function click() {
      var _this = this;

      this.processing = true;
      savePdf(this.map, 150, function () {
        return _this.processing = false;
      });
    }
  }
});

// Copy a canvas out of our map into the prep area
function copyCanvas(sourceCanvas, outputContext) {
  if (sourceCanvas.width > 0) {
    var opacity = sourceCanvas.parentNode.style.opacity;
    outputContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
    var transform = sourceCanvas.style.transform;
    // Get the transform parameters from the style's transform matrix
    var matrix = transform.match(/^matrix\(([^\(]*)\)$/)[1].split(',').map(Number);
    // Apply the transform to the export map context
    CanvasRenderingContext2D.prototype.setTransform.apply(outputContext, matrix);
    outputContext.drawImage(sourceCanvas, 0, 0);
  }
}

function createOutputCanvas(width, height) {
  var outputCanvas = document.createElement('canvas');
  var _ref = [width, height];
  outputCanvas.width = _ref[0];
  outputCanvas.height = _ref[1];


  var outputContext = outputCanvas.getContext('2d');
  document.querySelectorAll('.ol-layer canvas').forEach(function (canvas) {
    return copyCanvas(canvas, outputContext);
  });
  return outputCanvas;
}

function savePdf(map, resolution, doneCb) {
  // code adapted from here: https://openlayers.org/en/latest/examples/export-pdf.html
  map.once('rendercomplete', function () {
    var outputCanvas = createOutputCanvas.apply(undefined, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(pageDimensionsPixels));
    var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('landscape', undefined, 'a4');
    pdf.addImage.apply(pdf, [outputCanvas.toDataURL('image/jpeg'), 'JPEG', 0, headerBarMM].concat(pageDimensionsMM));
    [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(document.getElementsByClassName('logo'))).forEach(function (logoElement, i) {
      var scale = logoElement.clientWidth / logoElement.clientHeight;
      pdf.addImage(logoElement, 'JPEG', i * headerBarMM * 2 + 2, 2, headerBarMM * scale * 0.9, headerBarMM * 0.9);
    });
    pdf.save('map.pdf');

    // Reset original map size
    map.setSize(origSize);
    map.getView().setResolution(origResolution);
    doneCb();
  });

  var pageDimensionsMM = [297, 210]; // A4
  var pageDimensionsPixels = pageDimensionsMM.map(function (d) {
    return Math.round(d * resolution / 25.5);
  });
  var headerBarMM = 30;
  var mapDimensionsMM = [pageDimensionsMM[0], pageDimensionsMM[1] - headerBarMM];
  var mapDimensionsPixels = mapDimensionsMM.map(function (d) {
    return Math.round(d * resolution / 25.5);
  });
  var origSize = map.getSize();
  var origResolution = map.getView().getResolution();
  var mapScaling = Math.min(mapDimensionsPixels[0] / origSize[0], mapDimensionsPixels[1] / origSize[1]);

  // Resize map, triggering the handler above.
  map.setSize(mapDimensionsPixels);
  map.getView().setResolution(origResolution / mapScaling);
}

/***/ }),

/***/ "k+L9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-footer',
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    footerTextLeft: { type: String, required: false, default: 'Powered by <a href="https://meggsimum.de/wegue/" target="_blank">Wegue WebGIS</a>' },
    footerTextRight: { type: String, required: false, default: 'meggsimum' },
    showCopyrightYear: { type: Boolean, required: false, default: true }
  }
});

/***/ }),

/***/ "ktr9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kyCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geocoder_vue__ = __webpack_require__("VNHm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f37a8bd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geocoder_vue__ = __webpack_require__("rIWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("aQLT")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geocoder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f37a8bd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geocoder_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f37a8bd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geocoder_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("UNZ/")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lQeg":
/***/ (function(module, exports) {

module.exports = {"name":"proj4","version":"2.5.0","description":"Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.","main":"dist/proj4-src.js","module":"lib/index.js","directories":{"test":"test","doc":"docs"},"scripts":{"build":"grunt","build:tmerc":"grunt build:tmerc","test":"npm run build && istanbul test _mocha test/test.js"},"repository":{"type":"git","url":"git://github.com/proj4js/proj4js.git"},"author":"","license":"MIT","devDependencies":{"chai":"~4.1.2","curl-amd":"github:cujojs/curl","grunt":"^1.0.1","grunt-cli":"~1.2.0","grunt-contrib-connect":"~1.0.2","grunt-contrib-jshint":"~1.1.0","grunt-contrib-uglify":"~3.1.0","grunt-mocha-phantomjs":"~4.0.0","grunt-rollup":"^6.0.0","istanbul":"~0.4.5","mocha":"~4.0.0","rollup":"^0.50.0","rollup-plugin-json":"^2.3.0","rollup-plugin-node-resolve":"^3.0.0","tin":"~0.5.0"},"dependencies":{"mgrs":"1.0.0","wkt-parser":"^1.2.0"}}

/***/ }),

/***/ "lUVx":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Click on the map to choose a location.":"Klicken Sie auf die Karte, um einen Ort auszuwählen.","Point on map":"Punkt auf der Karte"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "lgWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureWin_vue__ = __webpack_require__("4z3x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da3ebcc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__ = __webpack_require__("phaG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("qxa+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da3ebcc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da3ebcc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("rEwg")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m3TE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"wgu-layer-list-panel",attrs:{"value":_vm.drawerOpen,"dark":_vm.dark,"right":_vm.right,"width":_vm.width,"height":_vm.height,"hide-overlay":"","disable-resize-watcher":"","disable-route-watcher":"","absolute":"","stateless":""},model:{value:(_vm.drawerOpen),callback:function ($$v) {_vm.drawerOpen=$$v},expression:"drawerOpen"}},[_c('v-card',{staticClass:"wgu-layer-list-card"},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":_vm.dark}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.$t('Layers')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{on:{"click":_vm.closePanel}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"overflow":"auto","height":"calc(100vh - 160px)"}},[_c('wgu-layerlist',_vm._b({},'wgu-layerlist',_vm.options,false))],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "m7M/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mJpz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"selector",attrs:{"prepend-icon":"flag","items":_vm.items,"dark":_vm.dark,"menu-props":{minWidth:'1'},"flat":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.value.toUpperCase())+"\n  ")]}}]),model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})}
var staticRenderFns = []


/***/ }),

/***/ "mNnC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.toggleUi}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []


/***/ }),

/***/ "mU5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingToggleButton_vue__ = __webpack_require__("5Ckq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43dd79dc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingToggleButton_vue__ = __webpack_require__("vo6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("98Q5")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43dd79dc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43dd79dc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("aAia")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mUig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("gxed");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba89ea2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("zbZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("97QL")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba89ea2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba89ea2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mcTj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mhME":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nF/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Util class for color related things.
 */
var ColorUtil = {
  /**
   * Detects whether a given string is a CSS color notation.
   *
   * @param {String} color (Color) string to test
   * @return {Boolean} true if given string is in CSS color notation
   */
  isCssColor: function isCssColor(color) {
    return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ColorUtil);

/***/ }),

/***/ "novK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLoadingStatus_vue__ = __webpack_require__("RAvm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73928fe2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__ = __webpack_require__("zqHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("1jdk")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLoadingStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73928fe2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73928fe2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oNNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routingConfig__ = __webpack_require__("xFgQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routingUtils__ = __webpack_require__("2nff");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DestinationSelector',
  props: {
    label: String,
    localSuggestions: Array
  },
  data: function data() {
    return {
      target: undefined,
      geocodeSuggestions: [],
      searchQuery: undefined
    };
  },
  watch: {
    target: function target() {
      this.$emit('change', this.target);
    },
    searchQuery: function searchQuery() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, result, results;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.geocodeSuggestions = [];

                if (!(!_this.searchQuery || !_this.searchQuery.trim())) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://autosuggest.search.hereapi.com/v1/autosuggest', {
                  params: {
                    at: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__routingUtils__["f" /* flip */])(_this.toEpsg4326(_this.$map.getView().getCenter())).join(','),
                    limit: 5,
                    q: _this.searchQuery,
                    apiKey: __WEBPACK_IMPORTED_MODULE_3__routingConfig__["a" /* default */].hereApiKey
                  }
                });

              case 5:
                _ref = _context.sent;
                result = _ref.data;
                results = result.items.map(function (item) {
                  return {
                    text: item.title,
                    source: 'geocode',
                    value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__routingUtils__["d" /* feature */])({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__routingUtils__["a" /* point */])([item.position.lng, item.position.lat]))
                  };
                });

                _this.geocodeSuggestions = results;

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    items: function items() {
      return [this.customPoint].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.localSuggestions.map(function (s) {
        s.value.properties.source = 'local';return s;
      })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.geocodeSuggestions.map(function (s) {
        s.value.properties.source = 'geocode';return s;
      })));
    },
    choosingPoint: function choosingPoint() {
      return this.target && this.target.properties.source === 'custom' && this.target.geometry.coordinates === null;
    },
    customPoint: function customPoint() {
      return {
        text: this.$t('Point on map'),
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__routingUtils__["d" /* feature */])({ name: 'Point on map', source: 'custom' }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__routingUtils__["a" /* point */])(null))
      };
    }
  },
  methods: {
    toEpsg4326: function toEpsg4326(coord) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["a" /* transform */])(coord, this.$map.getView().getProjection(), 'EPSG:4326');
    },
    changeRouteTarget: function changeRouteTarget() {
      var _this2 = this;

      console.log(this.target);
      if (this.target && this.target.properties.source === 'custom') {
        this.$map.wguDefaultCursor = 'crosshair';
        this.$map.once('click', function (e) {
          // just checking we're still in the same state
          if (_this2.target.properties.source === 'custom') {
            var coords = _this2.toEpsg4326(e.coordinate);
            _this2.$map.wguDefaultCursor = '';
            _this2.target.geometry.coordinates = coords;
          }
        });
      }
    },
    clearCustomTarget: function clearCustomTarget() {
      if (this.target.properties.source === 'custom') {
        this.target.geometry.coordinates = null;
      }
    },
    setTargetById: function setTargetById(id) {
      this.target = this.localSuggestions.find(function (s) {
        return s.value.properties.id === id;
      }).value;
    }
  }
});

/***/ }),

/***/ "oqg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.toggleUi}},tooltip),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Layers')))])])}
var staticRenderFns = []


/***/ }),

/***/ "phaG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card',{directives:[{name:"draggable-win",rawName:"v-draggable-win",value:(_vm.draggable),expression:"draggable"}],staticClass:"wgu-measurewin",style:({ left: _vm.left, top: _vm.top })},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":_vm.dark}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{on:{"click":function($event){_vm.show=false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('wgu-measure-type-chooser',{attrs:{"measureType":_vm.measureType},on:{"wgu-measuretype-change":_vm.applyMeasureType}})],1),_vm._v(" "),_c('v-card-actions',[_c('wgu-measure-result',{attrs:{"measureGeom":_vm.measureGeom}})],1)],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "qUL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClickWin_vue__ = __webpack_require__("Nkpt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff56e1b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__ = __webpack_require__("bmfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("tTN7")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClickWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff56e1b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff56e1b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("Lg3E")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qbcg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PROVIDERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeocoderController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__providers_osm__ = __webpack_require__("ZKPR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__providers_photon__ = __webpack_require__("Bik2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__providers_opencage__ = __webpack_require__("f54h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ajax__ = __webpack_require__("9OlX");




// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.






// Geocoder Provider types
var PROVIDERS = {
  'osm': __WEBPACK_IMPORTED_MODULE_4__providers_osm__["a" /* OpenStreetMap */],
  'photon': __WEBPACK_IMPORTED_MODULE_5__providers_photon__["a" /* Photon */],
  'opencage': __WEBPACK_IMPORTED_MODULE_6__providers_opencage__["a" /* OpenCage */]
};

/**
 * @class GeocoderController
 */
var GeocoderController = function () {
  /**
   * @constructor
   * @param {String} providerName name of Provider.
   * @param {Object} options config options for Provider
   * @param {Object} parent callback parent
   */
  function GeocoderController(providerName, options, parent) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GeocoderController);

    this.options = options;

    // Must have Provider class defined for name
    if (!PROVIDERS.hasOwnProperty(providerName)) {
      console.warn('No class defined for Geocoder Provider: \'' + providerName + '\'');
      return;
    }
    // Create Provider from name via Factory Method
    this.provider = new PROVIDERS[providerName]();
    this.parent = parent;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GeocoderController, [{
    key: 'query',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(q) {
        var parameters, ajax, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                parameters = this.provider.getParameters({
                  query: q,
                  key: this.options.key,
                  lang: this.options.lang,
                  countrycodes: this.options.countrycodes,
                  limit: this.options.limit
                });
                ajax = {
                  url: parameters.url,
                  data: parameters.params
                };

                // Optional XHR with JSONP (Provider-specific)

                if (parameters.callbackName) {
                  ajax.jsonp = true;
                  ajax.callbackName = parameters.callbackName;
                }

                _context.prev = 3;
                _context.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_ajax__["a" /* json */])(ajax);

              case 6:
                response = _context.sent;
                return _context.abrupt('return', this.provider.handleResponse(response));

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](3);
                return _context.abrupt('return', _context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 10]]);
      }));

      function query(_x) {
        return _ref.apply(this, arguments);
      }

      return query;
    }()
  }]);

  return GeocoderController;
}();

/***/ }),

/***/ "qq5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogo_vue__ = __webpack_require__("P5f+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3a3afd8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__ = __webpack_require__("01Ee");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("eTap")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3a3afd8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3a3afd8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qqRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomToMaxExtentButton_vue__ = __webpack_require__("ypcs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f7bcc2f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__ = __webpack_require__("B0Sl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("+5KU")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomToMaxExtentButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f7bcc2f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f7bcc2f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("Gwjn")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qxa+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qxrc":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Arrival or departure time":"Ankunfts- oder Abfahrtszeit","Arrive by":"Ankunft vor","Depart at":"Abfahrt um","Hour":"Stunde","Minute":"Minute","Today":"Heute","Another day":"Ein anderer Tag","Date":"Datum","Time":"Uhrzeit"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "rEwg":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Measure":"Messen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "rIWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-items',[_c('v-combobox',{style:({ display: (_vm.hideSearch ? "none" : "block" ) }),attrs:{"return-object":"","no-filter":_vm.noFilter,"autofocus":_vm.autofocus,"items":_vm.resultItems,"label":_vm.placeHolder,"clearable":_vm.clearable,"dark":_vm.dark,"color":_vm.dark ? 'white': '',"persistent-hint":_vm.persistentHint,"hidden":_vm.hideSearch,"rounded":_vm.rounded,"search-input":_vm.search},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"slot":"activator","icon":"","dark":_vm.dark},on:{"click":function($event){return _vm.toggle()}},slot:"activator"},tooltip),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.buttonIcon))])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Search for a place')))])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "rz2l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRouteV7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRouteV8; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routingConfig_js__ = __webpack_require__("xFgQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flexpolyline__ = __webpack_require__("bTWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__routingUtils__ = __webpack_require__("2nff");







// Note: you must create this file, following the format of routingConfig.js.example





var getRouteV7 = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2) {
    var _this = this;

    var from = _ref2.from,
        waypoints = _ref2.waypoints,
        to = _ref2.to,
        transportMode = _ref2.transportMode,
        timeDate = _ref2.timeDate,
        locale = _ref2.locale,
        _ref2$extraAttributes = _ref2.extraAttributes,
        extraAttributes = _ref2$extraAttributes === undefined ? {} : _ref2$extraAttributes;
    var makeRequest, stopsGeometryFromRoute, shapeToLineFeature, routeGeometryFromRoute, addCumulativeTimes, result, ret, route;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            addCumulativeTimes = function addCumulativeTimes(leg) {
              var total = 0;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(leg.maneuver), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var maneuver = _step3.value;

                  maneuver.cumulative = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["c" /* pad2 */])(Math.floor(total / 3600)) + ':' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["c" /* pad2 */])(Math.floor(total / 60) % 60);
                  total += maneuver.travelTime || 0;
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            };

            routeGeometryFromRoute = function routeGeometryFromRoute(route) {
              var fc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["b" /* featureCollection */])([]);
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(route.leg), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _fc$features;

                  var leg = _step2.value;

                  var lineFeatures = leg.maneuver.filter(function (m) {
                    return m.shape.length > 1;
                  }).map(function (m) {
                    return shapeToLineFeature(m.shape, m);
                  });
                  (_fc$features = fc.features).push.apply(_fc$features, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(lineFeatures));
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              return fc;
            };

            shapeToLineFeature = function shapeToLineFeature(shape, maneuver) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["d" /* feature */])({
                type: maneuver._type,
                instruction: maneuver.instruction.replace(/(<([^>]+)>)/g, '')
              }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["e" /* lineString */])(shape.map(function (coordString) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["f" /* flip */])(coordString.split(',').map(Number));
              })));
            };

            stopsGeometryFromRoute = function stopsGeometryFromRoute(route) {
              var stops = [];
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(route.leg), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var leg = _step.value;

                  var newStops = leg.maneuver.filter(function (m) {
                    return ['change', 'enter', 'leave'].indexOf(m.action) >= 0;
                  });
                  newStops.forEach(function (m, i) {
                    m.changeId = i + 1;
                  });
                  stops.push.apply(stops, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newStops));
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["b" /* featureCollection */])(stops.map(function (m) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["d" /* feature */])({ changeId: m.changeId }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["a" /* point */])([m.position.longitude, m.position.latitude]));
              }));
            };

            makeRequest = function () {
              var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                var timeParam, walkRadiusParam, toGeo, waypointParams, mode, alternatives, language, response;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        timeParam = {};
                        walkRadiusParam = {};

                        if (transportMode.match(/publicTransport/)) {
                          if (timeDate.time) {
                            timeParam = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, timeDate.timeMode, timeDate.date + 'T' + timeDate.time + ':00');
                          }
                          walkRadiusParam = { walkRadius: 3000 };
                        }

                        toGeo = function toGeo(point) {
                          return 'geo!' + point.geometry.coordinates[1] + ',' + point.geometry.coordinates[0];
                        };

                        waypointParams = {
                          waypoint0: toGeo(from)
                        };

                        waypoints.forEach(function (waypoint, i) {
                          waypointParams['waypoint' + (i + 1)] = toGeo(waypoint);
                        });
                        waypointParams['waypoint' + (waypoints.length + 1)] = toGeo(to);

                        mode = transportMode === 'fastest;publicTransport' && timeDate.time ? 'fastest;publicTransportTimeTable' : transportMode;
                        alternatives = waypoints.length > 0 ? 0 : 5; // API doesn't support alternatives with waypoints

                        language = locale.match(/de/) ? 'de-de' : locale;
                        _context.next = 12;
                        return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://route.ls.hereapi.com/routing/7.2/calculateroute.json', {
                          params: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
                            apiKey: __WEBPACK_IMPORTED_MODULE_7__routingConfig_js__["a" /* default */].hereApiKey
                          }, waypointParams, {
                            mode: mode,
                            lineattributes: 'all',
                            maneuverattributes: 'all', // TODO strip down to the ones we need.
                            routeattributes: 'all',
                            combineChange: true }, timeParam, walkRadiusParam, {
                            language: language,
                            alternatives: alternatives
                          }, extraAttributes)
                        });

                      case 12:
                        response = _context.sent;

                        console.log(response);
                        return _context.abrupt('return', response);

                      case 15:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function makeRequest() {
                return _ref3.apply(this, arguments);
              };
            }();

            result = void 0;
            ret = {};
            _context2.prev = 7;
            _context2.next = 10;
            return makeRequest();

          case 10:
            result = _context2.sent;
            route = result.data.response.route[0];

            route.leg.forEach(addCumulativeTimes);
            ret.route = route;
            ret.boundingBox = [route.boundingBox.topLeft.longitude, route.boundingBox.bottomRight.latitude, route.boundingBox.bottomRight.longitude, route.boundingBox.topLeft.latitude];
            ret.routeGeometry = routeGeometryFromRoute(route);
            ret.stopsGeometry = stopsGeometryFromRoute(route);
            _context2.next = 25;
            break;

          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2['catch'](7);

            console.log(_context2.t0);
            console.log(_context2.t0.response, _context2.t0.response.status, _context2.t0.response.responseText, _context2.t0.response.data.subtype);
            if (_context2.t0.response && _context2.t0.response.status === 400 && _context2.t0.response.data.subtype === 'NoRouteFound') {
              ret.errorMessage = 'No route was found.';
            } else if (_context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.details === 'Time Table Transit Routing is only supported for two StopOver waypoints') {
              ret.errorMessage = 'Sorry, you can specify a time, or multiple waypoints, but not both.';
            } else {
              ret.errorMessage = 'Sorry, directions are currently unavailable.';
            }
            if (_context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.details) {
              console.log(_context2.t0.response.data.details, _context2.t0.response.data.additionalData);
            }

          case 25:
            return _context2.abrupt('return', ret);

          case 26:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[7, 19]]);
  }));

  return function getRouteV7(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getRouteV8 = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5) {
    var from = _ref5.from,
        to = _ref5.to,
        waypoints = _ref5.waypoints,
        transportMode = _ref5.transportMode,
        locale = _ref5.locale,
        timeDate = _ref5.timeDate,
        _ref5$extraAttributes = _ref5.extraAttributes,
        extraAttributes = _ref5$extraAttributes === undefined ? {} : _ref5$extraAttributes;
    var polylineToGeoJSON, addCumulativeTimes, stopsGeometryFromRoute, via, transitSubdomain, routingMode, returnParam, timeParam, params, result, route, values, response;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            stopsGeometryFromRoute = function stopsGeometryFromRoute(route) {
              var stops = [];
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(route.sections.slice(1)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var section = _step5.value;

                  stops.push(section.departure.place.location);
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }

              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["b" /* featureCollection */])(stops.map(function (m, id) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["d" /* feature */])({ changeId: id + 1 }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["a" /* point */])([m.lng, m.lat]));
              }));
            };

            addCumulativeTimes = function addCumulativeTimes(section) {
              var total = 0;
              if (!section.actions) {
                return;
              }
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(section.actions), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var action = _step4.value;

                  action.cumulative = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["c" /* pad2 */])(Math.floor(total / 3600)) + ':' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["c" /* pad2 */])(Math.floor(total / 60) % 60);
                  total += action.duration || 0;
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            };

            polylineToGeoJSON = function polylineToGeoJSON(polyline, type) {
              var points = __WEBPACK_IMPORTED_MODULE_9__flexpolyline__["a" /* default */].decode(polyline).polyline;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["e" /* lineString */])(points.map(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["f" /* flip */]));
            };

            // https://developer.here.com/documentation/routing-api/api-reference-swagger.html
            // https://developer.here.com/documentation/routing/dev_guide/topics/resource-calculate-route.html
            // https://developer.here.com/documentation/public-transit/dev_guide/routing/route-example.html

            via = waypoints.filter(Boolean).map(function (w) {
              return w.geometry.coordinates;
            }).filter(Boolean).map(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["f" /* flip */]).map(function (c) {
              return c.join(',');
            });
            transitSubdomain = '';
            routingMode = void 0, returnParam = void 0;
            timeParam = void 0;

            if (transportMode.match(/transit|bus/)) {
              transitSubdomain = 'transit.';
              returnParam = 'polyline,actions,travelSummary'; // don't need summary, instructions? not supported by transit
              if (timeDate && timeDate.time) {
                timeParam = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, timeDate.timeMode + 'Time', timeDate.date + 'T' + timeDate.time + ':00'); // departureTime, arrivalTime
              }
            } else {
              routingMode = transportMode.split('-')[1];
              transportMode = transportMode === 'bus' ? 'bus' : 'car';
              returnParam = 'polyline,actions,summary,instructions';
            }

            params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
              origin: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["f" /* flip */])(from.geometry.coordinates).join(','),
              destination: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__routingUtils__["f" /* flip */])(to.geometry.coordinates).join(',')
            }, via ? { via: via } : {}, {
              return: returnParam,
              apiKey: __WEBPACK_IMPORTED_MODULE_7__routingConfig_js__["a" /* default */].hereApiKey,
              lang: locale
            }, routingMode ? { routingMode: routingMode } : undefined, transportMode ? { transportMode: transportMode } : undefined, timeParam, extraAttributes, transportMode === 'bus' ? { alternatives: 6 } : {});

            transportMode = transportMode === 'bus' ? params.transportMode = 'transit' : transportMode;
            _context3.next = 12;
            return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://' + transitSubdomain + 'router.hereapi.com/v8/routes', {
              params: params,
              // the API wants &via=x,y&via=x,y whereas Axios by default provides &via[]=x,y&via[]=x,y
              paramsSerializer: function paramsSerializer(params) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
                  var vals = Array.isArray(params[key]) ? params[key] : [params[key]];
                  return vals.map(function (val) {
                    return key + '=' + val;
                  }).join('&');
                }).join('&');
              }
            });

          case 12:
            result = _context3.sent;
            route = null;

            if (params.alternatives) {
              values = [{ name: 'HS 1' }, { name: 'HS 2' }, { name: 'HS 3' }, { name: 'HS 4' }, { name: 'HS 5' }];
              response = result.data.routes.filter(function (data) {
                if (data.sections[1]) {
                  return values.some(function (r) {
                    return data.sections[1].transport.name === r.name;
                  });
                } else {
                  return [];
                }
              });

              route = response[0];
              // const allDurations = result.data.routes.map(r => r.sections[0].summary.duration);
              // const minDuration = Math.min.apply(null, allDurations);
              // route = result.data.routes.find(r => r.sections[0].summary.duration === minDuration);
            } else {
              route = result.data.routes[0];
            }

            if (!(route !== undefined)) {
              _context3.next = 20;
              break;
            }

            route.sections.forEach(addCumulativeTimes);
            return _context3.abrupt('return', {
              route: route,
              routeGeometry: {
                type: 'FeatureCollection',
                features: route.sections.map(function (section) {
                  return {
                    type: 'Feature',
                    properties: {
                      type: section.type
                    },
                    geometry: polylineToGeoJSON(section.polyline)
                  };
                })
              },
              stopsGeometry: stopsGeometryFromRoute(route)
            });

          case 20:
            return _context3.abrupt('return', 'No route found.');

          case 21:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getRouteV8(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ "sXiz":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"German":"Deutsch","English":"Englisch"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "tTN7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uwYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("irkU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e7397d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("1cwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("UZyY")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e7397d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e7397d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("1JX6")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v4OI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors__ = __webpack_require__("IHMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Color__ = __webpack_require__("nF/d");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-property-table',
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    properties: { type: Object }
  },
  computed: {
    tableStyles: function tableStyles() {
      // calculate border color of tables due to current color property
      var borderColor = this.color;
      if (!__WEBPACK_IMPORTED_MODULE_2__util_Color__["a" /* default */].isCssColor(this.color)) {
        var _color$toString$trim$ = this.color.toString().trim().split(' ', 2),
            _color$toString$trim$2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_color$toString$trim$, 2),
            colorName = _color$toString$trim$2[0],
            colorModifier = _color$toString$trim$2[1];

        borderColor = __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default.a[colorName];
        if (colorModifier) {
          colorModifier = colorModifier.replace('-', '');
          borderColor = __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default.a[colorName][colorModifier];
        }
      }
      return {
        'border': '2px solid ' + borderColor
      };
    }
  }
});

/***/ }),

/***/ "v9hS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);



/**
 * URL related util methods
 */
var UrlUtil = {

  /**
   * Parses query string like a=b&c=d&e=f etc of the given search part (querySearch) of an URL
   * as JS object (key-value). Uses ES6 coding/parsing as in:
   * https://www.arungudelli.com/tutorial/javascript/get-query-string-parameter-values-from-url-using-javascript/
   *
   * @param  {String} query Search part (queryString) of an URL
   * @return {Object}             Key-value pairs of the URL parameters
   */
  parseQueryString: function parseQueryString(query) {
    return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
      var _param$split = param.split('='),
          _param$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_param$split, 2),
          key = _param$split2[0],
          value = _param$split2[1];

      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {});
  },


  /**
   * Returns the query params of the current 'location' from 'hash' or 'search'.
   *
   * @param  {String} locationType use query or hash part of URL
   * @return {Object}             Key-value pairs of the URL parameters
   */
  getParams: function getParams(locationType) {
    var querySearch = document.location[locationType].substring(1);
    if (!querySearch || querySearch === '') {
      return {};
    }
    return this.parseQueryString(querySearch);
  },


  /**
   * Returns all query params of the given search part (querySearch) of an URL
   * as JS object (key-value).
   * If querySearch is not provided it is derived from the current location.
   *
   * @param  {String} querySearch Search part (querySearch) of an URL
   * @return {Object}             Key-value pairs of the URL parameters
   */
  getQueryParams: function getQueryParams(querySearch) {
    if (!querySearch) {
      querySearch = document.location.search.substring(1);
    }

    return this.parseQueryString(querySearch);
  },


  /**
   * Returns all query params of the given hash part (hash) of an URL
   * as JS object (key-value).
   * If hash is not provided it is derived from the current location.
   *
   * @param  {String} hash Search part (hash) of an URL
   * @return {Object} Key-value pairs of the URL parameters
   */
  getHashParams: function getHashParams(hash) {
    if (!hash) {
      hash = document.location.hash.substring(1);
    }

    return this.parseQueryString(hash);
  },


  /**
   * Returns a dedicated URL parameter if existing.
   * If querySearch is not provided it is derived from the current location.
   *
   * @param  {String} param       The URL param name
   * @param  {String} querySearch Search part (querySearch) of an URL
   * @return {String}             Value of the given URL param
   */
  getQueryParam: function getQueryParam(param, querySearch) {
    var params = this.getQueryParams(querySearch);
    var value = void 0;
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
      if (key === param) {
        value = params[key];
      }
    });

    return value;
  },


  /**
   * Returns a query string from an object of key/value pairs.
   *
   * @param  {String} obj object with key/values to encode.
   * @return {String} the encoded query string
   */
  toQueryString: function toQueryString(obj) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).reduce(function (a, k) {
      a.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[k]) === 'object' ? _this.toQueryString(obj[k]) : encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]));
      return a;
    }, []).join('&');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (UrlUtil);

/***/ }),

/***/ "vDSi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"measure-result"},[_vm._v("\n    "+_vm._s(_vm.$t('LENGTH'))+": "+_vm._s(_vm.distance)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"measure-result"},[_vm._v("\n    "+_vm._s(_vm.$t('AREA'))+": "+_vm._s(_vm.area)+"\n  ")])])}
var staticRenderFns = []


/***/ }),

/***/ "vPiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.properties)?_c('table',{staticClass:"wgu-proptable",style:(_vm.tableStyles)},[_vm._m(0),_vm._v(" "),_c('tbody',{staticClass:"attr-tbody"},_vm._l((_vm.properties),function(value,key){return _c('tr',[_c('td',{staticClass:"key-td"},[_vm._v("\n        "+_vm._s(key)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"val-td"},[_vm._v("\n        "+_vm._s(value)+"\n      ")])])}),0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr')])}]


/***/ }),

/***/ "vo6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.toggleUi}},Object.assign({}, tooltip)),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.hoverText)))])])}
var staticRenderFns = []


/***/ }),

/***/ "w/12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureTypeChooser_vue__ = __webpack_require__("TooU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e59859_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__ = __webpack_require__("z1da");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("bSi1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureTypeChooser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e59859_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e59859_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("TtH7")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xFgQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// copy or rename this file to routingConfig.js
/* harmony default export */ __webpack_exports__["a"] = ({
  hereApiKey: 'x9SeCvwikNOtxoPoDbhI8qhRSWP1Gxmz_op6V7ovguE'
});

/***/ }),

/***/ "xGdD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y+0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguApp_vue__ = __webpack_require__("GgOu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f415710a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__ = __webpack_require__("C3SY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("+u1G")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f415710a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f415710a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y056":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Download all active layers as GPX":"Laden Sie alle aktiven Ebenen als GPX herunter","Wegue layers":"Wegue Ebenen"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "yi+M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ypcs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-zoomtomaxextent-btn',
  props: {
    icon: { type: String, required: false, default: 'zoom_out_map' },
    text: { type: String, required: false, default: '' },
    dark: { type: Boolean, required: false, default: false }
  },
  methods: {
    onClick: function onClick() {
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$emit('reset-bounds');
    }
  }
});

/***/ }),

/***/ "z1da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.measureTypeData),callback:function ($$v) {_vm.measureTypeData=$$v},expression:"measureTypeData"}},[_c('v-btn',{attrs:{"large":"","value":"distance"}},[_vm._v("\n     "+_vm._s(_vm.$t('Distance'))+"\n   ")]),_vm._v(" "),_c('v-btn',{attrs:{"large":"","value":"area"}},[_vm._v("\n     "+_vm._s(_vm.$t('Area'))+"\n   ")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "zFcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked_marked_min_js__ = __webpack_require__("Tahk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked_marked_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_marked_marked_min_js__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-feature-info-panel',
  props: {
    right: { type: Boolean, required: false, default: false },
    height: { type: String, required: false, default: '100%' },
    width: { type: Number, required: false, default: 360 },
    dark: { type: Boolean, required: false, default: false },
    icon: { type: String, required: false, default: 'info' },
    directionIcon: { type: String, required: false, default: 'directions' },
    color: { type: String, required: false, default: 'red darken-3' },
    draggable: { type: Boolean, required: false, default: false },
    active: { type: Boolean, required: false, default: false },
    toggleGroup: { type: String, required: false, default: undefined }
  },
  data: function data() {
    return {
      // will be filled in when mounted and when feature clicked
      layers: null,
      feature: null,
      attributes: null,
      title: 'Feature Info',
      titleProp: null,
      imageProp: null,
      descProp: null,
      infoUrlProp: null,
      infoUrlText: null,
      imageHeight: null,
      imageWidth: null,
      textHeight: null,
      moduleName: 'wgu-feature-info',
      drawerOpen: this.active
    };
  },
  mounted: function mounted() {
    var _this = this;

    var config = this.$appConfig.modules['wgu-feature-info'] || {};
    this.layers = config.layers;
    if (this.layers) {
      // Using a regular expression to Match layers
      this.layers.forEach(function (layer) {
        layer.layerId = new RegExp(layer.layerId);
      });
    }

    // listen to selection events of connected layer and apply attributes
    __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$on('map-selectionchange', function (layerId, selected, deselected) {
      if (selected.length === 0) {
        return;
      }
      var layer = _this.findLayer(layerId);
      if (!layer) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, layer, {
        infoUrlText: layer.infoUrlText || 'More info...',
        title: layer.title || layer.titleProp || 'Feature Info',
        textHeight: (layer.textHeight || 200) + 'px'
      }));

      _this.closePanel();

      _this.setFeature(selected[0]);

      // If part of toggleGroup, let other know we become active/visible
      _this.drawerOpen = true;
      __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$emit('close-layer-menu', _this.drawerOpen);
      if (_this.toggleGroup) {
        __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$emit(_this.toggleGroup, { 'moduleName': _this.moduleName, 'state': _this.drawerOpen });
      }
    });

    // When member of toggle group: close if any other panel active
    if (this.toggleGroup) {
      __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$on(this.toggleGroup, function (_ref) {
        var moduleName = _ref.moduleName,
            state = _ref.state;

        _this.drawerOpen = moduleName === _this.moduleName && state;
      });
    }
  },

  computed: {
    description: function description() {
      return __WEBPACK_IMPORTED_MODULE_3_marked_marked_min_js___default()(this.attributes[this.descProp] || '').replace(/<a /g, '<a target="_blank" ');
    }
  },
  methods: {
    /**
     * Sets the feature and its attributes as properties
     * @param {ol.Feature} feature The new feature
     */
    setFeature: function setFeature(feature) {
      this.feature = feature;
      this.attributes = this.feature ? this.feature.getProperties() : null;
    },

    /**
     * Find a layer in our target Layer collection by layer name (layerId).
     * @param {layerId} layerId layer name
     */
    findLayer: function findLayer(layerId) {
      var targetLayerArr = this.layers.filter(function (layer) {
        return layerId.match(layer.layerId);
      });
      return targetLayerArr.length > 0 ? targetLayerArr[0] : null;
    },

    closePanel: function closePanel() {
      // this.feature.deselected; TODO: how to deselect Feature on Map?
      this.setFeature(null);
      if (this.drawerOpen === false) {
        // Already closed
        return;
      }
      this.drawerOpen = false;
      __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$emit('open-layer-menu', this.drawerOpen);
      // if (this.toggleGroup) {
      //   WguEventBus.$emit(this.toggleGroup, {'moduleName': this.moduleName, 'state': this.drawerOpen});
      // }
    },
    clickDirections: function clickDirections() {
      __WEBPACK_IMPORTED_MODULE_2__src_WguEventBus__["a" /* WguEventBus */].$emit('directions-to-feature', this.feature);
      this.drawerOpen = true;
    }
  }
});

/***/ }),

/***/ "zZik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerList_vue__ = __webpack_require__("h0fj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052dd069_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__ = __webpack_require__("BeCa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Dam3")
  __webpack_require__("mcTj")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-052dd069"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052dd069_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052dd069_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("0VQP")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zbZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"wgu-app-toolbar white--text",attrs:{"color":_vm.color,"fixed":"","app":"","clipped-right":""}},[_vm._t("wgu-tb-start"),_vm._v(" "),_c('v-toolbar-title',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_vm._t("wgu-tb-after-title"),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("wgu-tb-before-auto-buttons"),_vm._v(" "),_vm._l((_vm.tbButtons),function(tbButton,index){return [_c(tbButton.type,{key:index,tag:"component",attrs:{"icon":tbButton.icon,"text":tbButton.text,"color":_vm.color,"dark":tbButton.dark,"active":tbButton.active,"toggleGroup":tbButton.toggleGroup}})]}),_vm._v(" "),_vm._t("wgu-tb-after-auto-buttons"),_vm._v(" "),(_vm.menuButtons.length)?_c('v-menu',{attrs:{"offset-y":"","close-on-content-click":_vm.menuCloseOnContentClick}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","bright":""},slot:"activator"},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("menu")])],1),_vm._v(" "),_c('v-list',[_vm._l((_vm.menuButtons),function(tbButton,index){return [_c('v-list-tile',[_c(tbButton.type,{key:index,tag:"component",attrs:{"icon":tbButton.icon,"color":_vm.color,"text":tbButton.text,"dark":tbButton.dark,"active":tbButton.active,"toggleGroup":tbButton.toggleGroup}})],1)]})],2)],1):_vm._e(),_vm._v(" "),_vm._t("wgu-tb-end")],2)}
var staticRenderFns = []


/***/ }),

/***/ "zqHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('v-progress-circular',{staticClass:"wgu-maploading-status",attrs:{"value":80,"indeterminate":"","color":_vm.color}}):_vm._e()}
var staticRenderFns = []


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.649fc93531e4841f1021.js